import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DemoAccountService {

  demo: false;

  constructor() { }

  getDemoUserSettings() {
    const demoUserSettings = {
      "version": 1,
      "senderId": "",
      "direction": "",
      "source": "",
      "items": [
          {
              "itemId": 2669,
              "success": true,
              "payload": {
                  "userId": "1",
                  "email": "demo@account.com",
                  "rootGroupIds": [
                      "",
                  ],
                  "settings": {
                      "dashboard": {
                          "energyProvider": {
                              "electricity": {},
                              "gas": {}
                          },
                          "settings": [
                              {
                                  "label": "Personal",
                                  "items": [
                                      {
                                          "label": "Email",
                                          "value": "demo@account.com"
                                      }
                                  ]
                              },
                              {
                                  "label": "Energy",
                                  "items": [
                                      {
                                          "label": "Unit Rate",
                                          "value": 24,
                                          "tooltip": "Please enter a positive number.",
                                          "rule": "Positive number"
                                      },
                                      {
                                          "type": "select",
                                          "label": "Currency",
                                          "value": "GBP (£)",
                                          "available": [
                                              "EUR (€)",
                                              "GBP (£)"
                                          ],
                                          "toggle": false
                                      }
                                  ]
                              }
                          ]
                      },
                  },
                  "utility": {
                      "electricity": {
                          "tariff": 0.27,
                          "country": "GB",
                          "currency": "GBP"
                      }
                  },
                  "currentRootGroup": "",
              }
          }
      ],
      "class": "user",
      "operation": "read",
      "transactionId": 118107
    }
    return demoUserSettings;
  }

  getDemoStructure() {
    const demoStructure = {
      "featureSets": [
        {
          "id": "4502",
          "featureId": "59d505a0eea9e528ef444c61-4502-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "icon": "icon-l22_dimmer_2gang",
          "productCode": "L22EU",
          "groupId": "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee",
          "name": "Kitchen Light",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-4483-3157328415+0",
            "59d505a0eea9e528ef444c61-4484-3157328415+0",
            "59d505a0eea9e528ef444c61-4485-3157328415+0",
            "59d505a0eea9e528ef444c61-4486-3157328415+0",
            "59d505a0eea9e528ef444c61-4487-3157328415+0",
            "59d505a0eea9e528ef444c61-4488-3157328415+0",
            "59d505a0eea9e528ef444c61-4496-3157328415+0",
            "59d505a0eea9e528ef444c61-4497-3157328415+0",
            "59d505a0eea9e528ef444c61-4498-3157328415+0",
            "59d505a0eea9e528ef444c61-4499-3157328415+0",
            "59d505a0eea9e528ef444c61-4500-3157328415+0",
            "59d505a0eea9e528ef444c61-4501-3157328415+0",
            "59d505a0eea9e528ef444c61-4502-3157328415+0",
            "59d505a0eea9e528ef444c61-4503-3157328415+0",
            "59d505a0eea9e528ef444c61-4510-3157328415+0",
            "59d505a0eea9e528ef444c61-4511-3157328415+0",
            "59d505a0eea9e528ef444c61-4512-3157328415+0",
            "59d505a0eea9e528ef444c61-4513-3157328415+0",
            "59d505a0eea9e528ef444c61-4514-3157328415+0",
            "59d505a0eea9e528ef444c61-4515-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Kitchen Light"
        },
        {
          "id": "2113",
          "featureId": "59d505a0eea9e528ef444c61-2113-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
          "name": "TV",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2109-3157328415+0",
            "59d505a0eea9e528ef444c61-2110-3157328415+0",
            "59d505a0eea9e528ef444c61-2111-3157328415+0",
            "59d505a0eea9e528ef444c61-2112-3157328415+0",
            "59d505a0eea9e528ef444c61-2113-3157328415+0",
            "59d505a0eea9e528ef444c61-2114-3157328415+0",
            "59d505a0eea9e528ef444c61-2115-3157328415+0",
            "59d505a0eea9e528ef444c61-2116-3157328415+0",
            "59d505a0eea9e528ef444c61-2117-3157328415+0",
            "59d505a0eea9e528ef444c61-2118-3157328415+0",
            "59d505a0eea9e528ef444c61-2102-3157328415+0",
            "59d505a0eea9e528ef444c61-2103-3157328415+0",
            "59d505a0eea9e528ef444c61-2104-3157328415+0",
            "59d505a0eea9e528ef444c61-2105-3157328415+0",
            "59d505a0eea9e528ef444c61-2106-3157328415+0",
            "59d505a0eea9e528ef444c61-2107-3157328415+0",
            "59d505a0eea9e528ef444c61-2108-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "TV"
        },
        {
          "id": "2123",
          "featureId": "59d505a0eea9e528ef444c61-2123-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3",
          "name": "Lamp",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2119-3157328415+0",
            "59d505a0eea9e528ef444c61-2120-3157328415+0",
            "59d505a0eea9e528ef444c61-2121-3157328415+0",
            "59d505a0eea9e528ef444c61-2122-3157328415+0",
            "59d505a0eea9e528ef444c61-2123-3157328415+0",
            "59d505a0eea9e528ef444c61-2124-3157328415+0",
            "59d505a0eea9e528ef444c61-2125-3157328415+0",
            "59d505a0eea9e528ef444c61-2126-3157328415+0",
            "59d505a0eea9e528ef444c61-2127-3157328415+0",
            "59d505a0eea9e528ef444c61-2128-3157328415+0",
            "59d505a0eea9e528ef444c61-2102-3157328415+0",
            "59d505a0eea9e528ef444c61-2103-3157328415+0",
            "59d505a0eea9e528ef444c61-2104-3157328415+0",
            "59d505a0eea9e528ef444c61-2105-3157328415+0",
            "59d505a0eea9e528ef444c61-2106-3157328415+0",
            "59d505a0eea9e528ef444c61-2107-3157328415+0",
            "59d505a0eea9e528ef444c61-2108-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Lamp"
        },
        {
          "id": "550",
          "featureId": "59d505a0eea9e528ef444c61-550-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3",
          "name": "Charger",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-1787-3157328415+0",
            "59d505a0eea9e528ef444c61-1792-3157328415+0",
            "59d505a0eea9e528ef444c61-1793-3157328415+0",
            "59d505a0eea9e528ef444c61-1794-3157328415+0",
            "59d505a0eea9e528ef444c61-1795-3157328415+0",
            "59d505a0eea9e528ef444c61-1796-3157328415+0",
            "59d505a0eea9e528ef444c61-534-3157328415+0",
            "59d505a0eea9e528ef444c61-535-3157328415+0",
            "59d505a0eea9e528ef444c61-536-3157328415+0",
            "59d505a0eea9e528ef444c61-537-3157328415+0",
            "59d505a0eea9e528ef444c61-538-3157328415+0",
            "59d505a0eea9e528ef444c61-539-3157328415+0",
            "59d505a0eea9e528ef444c61-546-3157328415+0",
            "59d505a0eea9e528ef444c61-547-3157328415+0",
            "59d505a0eea9e528ef444c61-548-3157328415+0",
            "59d505a0eea9e528ef444c61-549-3157328415+0",
            "59d505a0eea9e528ef444c61-550-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Charger"
        },
        {
          "id": "545",
          "featureId": "59d505a0eea9e528ef444c61-545-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
          "name": "Spare Socket",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-541-3157328415+0",
            "59d505a0eea9e528ef444c61-542-3157328415+0",
            "59d505a0eea9e528ef444c61-543-3157328415+0",
            "59d505a0eea9e528ef444c61-544-3157328415+0",
            "59d505a0eea9e528ef444c61-545-3157328415+0",
            "59d505a0eea9e528ef444c61-534-3157328415+0",
            "59d505a0eea9e528ef444c61-535-3157328415+0",
            "59d505a0eea9e528ef444c61-536-3157328415+0",
            "59d505a0eea9e528ef444c61-537-3157328415+0",
            "59d505a0eea9e528ef444c61-538-3157328415+0",
            "59d505a0eea9e528ef444c61-539-3157328415+0",
            "59d505a0eea9e528ef444c61-540-3157328415+0",
            "59d505a0eea9e528ef444c61-1787-3157328415+0",
            "59d505a0eea9e528ef444c61-1788-3157328415+0",
            "59d505a0eea9e528ef444c61-1789-3157328415+0",
            "59d505a0eea9e528ef444c61-1790-3157328415+0",
            "59d505a0eea9e528ef444c61-1791-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Spare Socket"
        },
        {
          "id": "878",
          "featureId": "59d505a0eea9e528ef444c61-878-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "icon": "icon-l21_dimmer_1gang",
          "productCode": "L21",
          "groupId": "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030",
          "name": "Bedroom Light",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-866-3157328415+0",
            "59d505a0eea9e528ef444c61-867-3157328415+0",
            "59d505a0eea9e528ef444c61-868-3157328415+0",
            "59d505a0eea9e528ef444c61-869-3157328415+0",
            "59d505a0eea9e528ef444c61-870-3157328415+0",
            "59d505a0eea9e528ef444c61-871-3157328415+0",
            "59d505a0eea9e528ef444c61-872-3157328415+0",
            "59d505a0eea9e528ef444c61-873-3157328415+0",
            "59d505a0eea9e528ef444c61-874-3157328415+0",
            "59d505a0eea9e528ef444c61-875-3157328415+0",
            "59d505a0eea9e528ef444c61-876-3157328415+0",
            "59d505a0eea9e528ef444c61-877-3157328415+0",
            "59d505a0eea9e528ef444c61-878-3157328415+0",
            "59d505a0eea9e528ef444c61-3037-3157328415+0",
            "59d505a0eea9e528ef444c61-3038-3157328415+0",
            "59d505a0eea9e528ef444c61-3039-3157328415+0",
            "59d505a0eea9e528ef444c61-3040-3157328415+0",
            "59d505a0eea9e528ef444c61-3041-3157328415+0",
            "59d505a0eea9e528ef444c61-3042-3157328415+0",
            "59d505a0eea9e528ef444c61-3043-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Bedroom Light"
        },
        {
          "id": "2167",
          "featureId": "59d505a0eea9e528ef444c61-2167-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
          "name": "Bedside Lamp",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2163-3157328415+0",
            "59d505a0eea9e528ef444c61-2164-3157328415+0",
            "59d505a0eea9e528ef444c61-2165-3157328415+0",
            "59d505a0eea9e528ef444c61-2166-3157328415+0",
            "59d505a0eea9e528ef444c61-2167-3157328415+0",
            "59d505a0eea9e528ef444c61-2168-3157328415+0",
            "59d505a0eea9e528ef444c61-2169-3157328415+0",
            "59d505a0eea9e528ef444c61-2170-3157328415+0",
            "59d505a0eea9e528ef444c61-2171-3157328415+0",
            "59d505a0eea9e528ef444c61-2172-3157328415+0",
            "59d505a0eea9e528ef444c61-2156-3157328415+0",
            "59d505a0eea9e528ef444c61-2157-3157328415+0",
            "59d505a0eea9e528ef444c61-2158-3157328415+0",
            "59d505a0eea9e528ef444c61-2159-3157328415+0",
            "59d505a0eea9e528ef444c61-2160-3157328415+0",
            "59d505a0eea9e528ef444c61-2161-3157328415+0",
            "59d505a0eea9e528ef444c61-2162-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Bedside Lamp"
        },
        {
          "id": "2177",
          "featureId": "59d505a0eea9e528ef444c61-2177-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43",
          "name": "Game Console",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2173-3157328415+0",
            "59d505a0eea9e528ef444c61-2174-3157328415+0",
            "59d505a0eea9e528ef444c61-2175-3157328415+0",
            "59d505a0eea9e528ef444c61-2176-3157328415+0",
            "59d505a0eea9e528ef444c61-2177-3157328415+0",
            "59d505a0eea9e528ef444c61-2178-3157328415+0",
            "59d505a0eea9e528ef444c61-2179-3157328415+0",
            "59d505a0eea9e528ef444c61-2180-3157328415+0",
            "59d505a0eea9e528ef444c61-2181-3157328415+0",
            "59d505a0eea9e528ef444c61-2182-3157328415+0",
            "59d505a0eea9e528ef444c61-2156-3157328415+0",
            "59d505a0eea9e528ef444c61-2157-3157328415+0",
            "59d505a0eea9e528ef444c61-2158-3157328415+0",
            "59d505a0eea9e528ef444c61-2159-3157328415+0",
            "59d505a0eea9e528ef444c61-2160-3157328415+0",
            "59d505a0eea9e528ef444c61-2161-3157328415+0",
            "59d505a0eea9e528ef444c61-2162-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Game Console"
        },
        {
          "id": "573",
          "featureId": "59d505a0eea9e528ef444c61-573-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d",
          "name": "Fridge",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-1757-3157328415+0",
            "59d505a0eea9e528ef444c61-1762-3157328415+0",
            "59d505a0eea9e528ef444c61-1763-3157328415+0",
            "59d505a0eea9e528ef444c61-1764-3157328415+0",
            "59d505a0eea9e528ef444c61-1765-3157328415+0",
            "59d505a0eea9e528ef444c61-1766-3157328415+0",
            "59d505a0eea9e528ef444c61-557-3157328415+0",
            "59d505a0eea9e528ef444c61-558-3157328415+0",
            "59d505a0eea9e528ef444c61-559-3157328415+0",
            "59d505a0eea9e528ef444c61-560-3157328415+0",
            "59d505a0eea9e528ef444c61-561-3157328415+0",
            "59d505a0eea9e528ef444c61-562-3157328415+0",
            "59d505a0eea9e528ef444c61-569-3157328415+0",
            "59d505a0eea9e528ef444c61-570-3157328415+0",
            "59d505a0eea9e528ef444c61-571-3157328415+0",
            "59d505a0eea9e528ef444c61-572-3157328415+0",
            "59d505a0eea9e528ef444c61-573-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Fridge"
        },
        {
          "id": "568",
          "featureId": "59d505a0eea9e528ef444c61-568-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
          "name": "Freezer",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-564-3157328415+0",
            "59d505a0eea9e528ef444c61-565-3157328415+0",
            "59d505a0eea9e528ef444c61-566-3157328415+0",
            "59d505a0eea9e528ef444c61-567-3157328415+0",
            "59d505a0eea9e528ef444c61-568-3157328415+0",
            "59d505a0eea9e528ef444c61-557-3157328415+0",
            "59d505a0eea9e528ef444c61-558-3157328415+0",
            "59d505a0eea9e528ef444c61-559-3157328415+0",
            "59d505a0eea9e528ef444c61-560-3157328415+0",
            "59d505a0eea9e528ef444c61-561-3157328415+0",
            "59d505a0eea9e528ef444c61-562-3157328415+0",
            "59d505a0eea9e528ef444c61-563-3157328415+0",
            "59d505a0eea9e528ef444c61-1757-3157328415+0",
            "59d505a0eea9e528ef444c61-1758-3157328415+0",
            "59d505a0eea9e528ef444c61-1759-3157328415+0",
            "59d505a0eea9e528ef444c61-1760-3157328415+0",
            "59d505a0eea9e528ef444c61-1761-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0"
        },
        {
          "id": "3828",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "icon": "icon-signal_0",
          "name": "Living Room TRV",
          "groupId": "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1",
          "productCode": "HR92",
          "featureId": "59d505a0eea9e528ef444c61-3828-3157328415+0",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-3828-3157328415+0",
            "59d505a0eea9e528ef444c61-3829-3157328415+0",
            "59d505a0eea9e528ef444c61-3830-3157328415+0",
            "59d505a0eea9e528ef444c61-3831-3157328415+0",
            "59d505a0eea9e528ef444c61-3832-3157328415+0",
            "59d505a0eea9e528ef444c61-3833-3157328415+0",
            "59d505a0eea9e528ef444c61-3834-3157328415+0",
            "59d505a0eea9e528ef444c61-3835-3157328415+0",
            "59d505a0eea9e528ef444c61-3836-3157328415+0"
          ],
          "created": 1635181691845,
          "type": "temperature"
        },
        {
          "id": "1355",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "icon": "icon-signal_0",
          "name": "Bedroom TRV",
          "groupId": "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c",
          "productCode": "HR92",
          "featureId": "59d505a0eea9e528ef444c61-1355-3157328415+0",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-1355-3157328415+0",
            "59d505a0eea9e528ef444c61-1356-3157328415+0",
            "59d505a0eea9e528ef444c61-1357-3157328415+0",
            "59d505a0eea9e528ef444c61-1358-3157328415+0",
            "59d505a0eea9e528ef444c61-1359-3157328415+0",
            "59d505a0eea9e528ef444c61-1360-3157328415+0",
            "59d505a0eea9e528ef444c61-1361-3157328415+0",
            "59d505a0eea9e528ef444c61-1362-3157328415+0",
            "59d505a0eea9e528ef444c61-1530-3157328415+0"
          ],
          "created": 1571073754300,
          "type": "temperature"
        },
      ],
      "expires": 1658509146479,
      "featureSetsWithData": [
        {
          "id": "4502",
          "featureId": "59d505a0eea9e528ef444c61-4502-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "icon": "icon-l22_dimmer_2gang",
          "productCode": "L22EU",
          "groupId": "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee",
          "name": "Kitchen Light",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-4483-3157328415+0",
            "59d505a0eea9e528ef444c61-4484-3157328415+0",
            "59d505a0eea9e528ef444c61-4485-3157328415+0",
            "59d505a0eea9e528ef444c61-4486-3157328415+0",
            "59d505a0eea9e528ef444c61-4487-3157328415+0",
            "59d505a0eea9e528ef444c61-4488-3157328415+0",
            "59d505a0eea9e528ef444c61-4496-3157328415+0",
            "59d505a0eea9e528ef444c61-4497-3157328415+0",
            "59d505a0eea9e528ef444c61-4498-3157328415+0",
            "59d505a0eea9e528ef444c61-4499-3157328415+0",
            "59d505a0eea9e528ef444c61-4500-3157328415+0",
            "59d505a0eea9e528ef444c61-4501-3157328415+0",
            "59d505a0eea9e528ef444c61-4502-3157328415+0",
            "59d505a0eea9e528ef444c61-4503-3157328415+0",
            "59d505a0eea9e528ef444c61-4510-3157328415+0",
            "59d505a0eea9e528ef444c61-4511-3157328415+0",
            "59d505a0eea9e528ef444c61-4512-3157328415+0",
            "59d505a0eea9e528ef444c61-4513-3157328415+0",
            "59d505a0eea9e528ef444c61-4514-3157328415+0",
            "59d505a0eea9e528ef444c61-4515-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Kitchen Light"
        },
        {
          "id": "2113",
          "featureId": "59d505a0eea9e528ef444c61-2113-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
          "name": "TV",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2109-3157328415+0",
            "59d505a0eea9e528ef444c61-2110-3157328415+0",
            "59d505a0eea9e528ef444c61-2111-3157328415+0",
            "59d505a0eea9e528ef444c61-2112-3157328415+0",
            "59d505a0eea9e528ef444c61-2113-3157328415+0",
            "59d505a0eea9e528ef444c61-2114-3157328415+0",
            "59d505a0eea9e528ef444c61-2115-3157328415+0",
            "59d505a0eea9e528ef444c61-2116-3157328415+0",
            "59d505a0eea9e528ef444c61-2117-3157328415+0",
            "59d505a0eea9e528ef444c61-2118-3157328415+0",
            "59d505a0eea9e528ef444c61-2102-3157328415+0",
            "59d505a0eea9e528ef444c61-2103-3157328415+0",
            "59d505a0eea9e528ef444c61-2104-3157328415+0",
            "59d505a0eea9e528ef444c61-2105-3157328415+0",
            "59d505a0eea9e528ef444c61-2106-3157328415+0",
            "59d505a0eea9e528ef444c61-2107-3157328415+0",
            "59d505a0eea9e528ef444c61-2108-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "TV"
        },
        {
          "id": "2123",
          "featureId": "59d505a0eea9e528ef444c61-2123-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3",
          "name": "Lamp",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2119-3157328415+0",
            "59d505a0eea9e528ef444c61-2120-3157328415+0",
            "59d505a0eea9e528ef444c61-2121-3157328415+0",
            "59d505a0eea9e528ef444c61-2122-3157328415+0",
            "59d505a0eea9e528ef444c61-2123-3157328415+0",
            "59d505a0eea9e528ef444c61-2124-3157328415+0",
            "59d505a0eea9e528ef444c61-2125-3157328415+0",
            "59d505a0eea9e528ef444c61-2126-3157328415+0",
            "59d505a0eea9e528ef444c61-2127-3157328415+0",
            "59d505a0eea9e528ef444c61-2128-3157328415+0",
            "59d505a0eea9e528ef444c61-2102-3157328415+0",
            "59d505a0eea9e528ef444c61-2103-3157328415+0",
            "59d505a0eea9e528ef444c61-2104-3157328415+0",
            "59d505a0eea9e528ef444c61-2105-3157328415+0",
            "59d505a0eea9e528ef444c61-2106-3157328415+0",
            "59d505a0eea9e528ef444c61-2107-3157328415+0",
            "59d505a0eea9e528ef444c61-2108-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Lamp"
        },
        {
          "id": "550",
          "featureId": "59d505a0eea9e528ef444c61-550-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3",
          "name": "Charger",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-1787-3157328415+0",
            "59d505a0eea9e528ef444c61-1792-3157328415+0",
            "59d505a0eea9e528ef444c61-1793-3157328415+0",
            "59d505a0eea9e528ef444c61-1794-3157328415+0",
            "59d505a0eea9e528ef444c61-1795-3157328415+0",
            "59d505a0eea9e528ef444c61-1796-3157328415+0",
            "59d505a0eea9e528ef444c61-534-3157328415+0",
            "59d505a0eea9e528ef444c61-535-3157328415+0",
            "59d505a0eea9e528ef444c61-536-3157328415+0",
            "59d505a0eea9e528ef444c61-537-3157328415+0",
            "59d505a0eea9e528ef444c61-538-3157328415+0",
            "59d505a0eea9e528ef444c61-539-3157328415+0",
            "59d505a0eea9e528ef444c61-546-3157328415+0",
            "59d505a0eea9e528ef444c61-547-3157328415+0",
            "59d505a0eea9e528ef444c61-548-3157328415+0",
            "59d505a0eea9e528ef444c61-549-3157328415+0",
            "59d505a0eea9e528ef444c61-550-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Charger"
        },
        {
          "id": "545",
          "featureId": "59d505a0eea9e528ef444c61-545-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
          "name": "Spare Socket",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-541-3157328415+0",
            "59d505a0eea9e528ef444c61-542-3157328415+0",
            "59d505a0eea9e528ef444c61-543-3157328415+0",
            "59d505a0eea9e528ef444c61-544-3157328415+0",
            "59d505a0eea9e528ef444c61-545-3157328415+0",
            "59d505a0eea9e528ef444c61-534-3157328415+0",
            "59d505a0eea9e528ef444c61-535-3157328415+0",
            "59d505a0eea9e528ef444c61-536-3157328415+0",
            "59d505a0eea9e528ef444c61-537-3157328415+0",
            "59d505a0eea9e528ef444c61-538-3157328415+0",
            "59d505a0eea9e528ef444c61-539-3157328415+0",
            "59d505a0eea9e528ef444c61-540-3157328415+0",
            "59d505a0eea9e528ef444c61-1787-3157328415+0",
            "59d505a0eea9e528ef444c61-1788-3157328415+0",
            "59d505a0eea9e528ef444c61-1789-3157328415+0",
            "59d505a0eea9e528ef444c61-1790-3157328415+0",
            "59d505a0eea9e528ef444c61-1791-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Spare Socket"
        },
        {
          "id": "878",
          "featureId": "59d505a0eea9e528ef444c61-878-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "icon": "icon-l21_dimmer_1gang",
          "productCode": "L21",
          "groupId": "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030",
          "name": "Bedroom Light",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-866-3157328415+0",
            "59d505a0eea9e528ef444c61-867-3157328415+0",
            "59d505a0eea9e528ef444c61-868-3157328415+0",
            "59d505a0eea9e528ef444c61-869-3157328415+0",
            "59d505a0eea9e528ef444c61-870-3157328415+0",
            "59d505a0eea9e528ef444c61-871-3157328415+0",
            "59d505a0eea9e528ef444c61-872-3157328415+0",
            "59d505a0eea9e528ef444c61-873-3157328415+0",
            "59d505a0eea9e528ef444c61-874-3157328415+0",
            "59d505a0eea9e528ef444c61-875-3157328415+0",
            "59d505a0eea9e528ef444c61-876-3157328415+0",
            "59d505a0eea9e528ef444c61-877-3157328415+0",
            "59d505a0eea9e528ef444c61-878-3157328415+0",
            "59d505a0eea9e528ef444c61-3037-3157328415+0",
            "59d505a0eea9e528ef444c61-3038-3157328415+0",
            "59d505a0eea9e528ef444c61-3039-3157328415+0",
            "59d505a0eea9e528ef444c61-3040-3157328415+0",
            "59d505a0eea9e528ef444c61-3041-3157328415+0",
            "59d505a0eea9e528ef444c61-3042-3157328415+0",
            "59d505a0eea9e528ef444c61-3043-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Bedroom Light"
        },
        {
          "id": "2167",
          "featureId": "59d505a0eea9e528ef444c61-2167-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
          "name": "Bedside Lamp",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2163-3157328415+0",
            "59d505a0eea9e528ef444c61-2164-3157328415+0",
            "59d505a0eea9e528ef444c61-2165-3157328415+0",
            "59d505a0eea9e528ef444c61-2166-3157328415+0",
            "59d505a0eea9e528ef444c61-2167-3157328415+0",
            "59d505a0eea9e528ef444c61-2168-3157328415+0",
            "59d505a0eea9e528ef444c61-2169-3157328415+0",
            "59d505a0eea9e528ef444c61-2170-3157328415+0",
            "59d505a0eea9e528ef444c61-2171-3157328415+0",
            "59d505a0eea9e528ef444c61-2172-3157328415+0",
            "59d505a0eea9e528ef444c61-2156-3157328415+0",
            "59d505a0eea9e528ef444c61-2157-3157328415+0",
            "59d505a0eea9e528ef444c61-2158-3157328415+0",
            "59d505a0eea9e528ef444c61-2159-3157328415+0",
            "59d505a0eea9e528ef444c61-2160-3157328415+0",
            "59d505a0eea9e528ef444c61-2161-3157328415+0",
            "59d505a0eea9e528ef444c61-2162-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Bedside Lamp"
        },
        {
          "id": "2177",
          "featureId": "59d505a0eea9e528ef444c61-2177-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43",
          "name": "Game Console",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-2173-3157328415+0",
            "59d505a0eea9e528ef444c61-2174-3157328415+0",
            "59d505a0eea9e528ef444c61-2175-3157328415+0",
            "59d505a0eea9e528ef444c61-2176-3157328415+0",
            "59d505a0eea9e528ef444c61-2177-3157328415+0",
            "59d505a0eea9e528ef444c61-2178-3157328415+0",
            "59d505a0eea9e528ef444c61-2179-3157328415+0",
            "59d505a0eea9e528ef444c61-2180-3157328415+0",
            "59d505a0eea9e528ef444c61-2181-3157328415+0",
            "59d505a0eea9e528ef444c61-2182-3157328415+0",
            "59d505a0eea9e528ef444c61-2156-3157328415+0",
            "59d505a0eea9e528ef444c61-2157-3157328415+0",
            "59d505a0eea9e528ef444c61-2158-3157328415+0",
            "59d505a0eea9e528ef444c61-2159-3157328415+0",
            "59d505a0eea9e528ef444c61-2160-3157328415+0",
            "59d505a0eea9e528ef444c61-2161-3157328415+0",
            "59d505a0eea9e528ef444c61-2162-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Game Console"
        },
        {
          "id": "573",
          "featureId": "59d505a0eea9e528ef444c61-573-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d",
          "name": "Fridge",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-1757-3157328415+0",
            "59d505a0eea9e528ef444c61-1762-3157328415+0",
            "59d505a0eea9e528ef444c61-1763-3157328415+0",
            "59d505a0eea9e528ef444c61-1764-3157328415+0",
            "59d505a0eea9e528ef444c61-1765-3157328415+0",
            "59d505a0eea9e528ef444c61-1766-3157328415+0",
            "59d505a0eea9e528ef444c61-557-3157328415+0",
            "59d505a0eea9e528ef444c61-558-3157328415+0",
            "59d505a0eea9e528ef444c61-559-3157328415+0",
            "59d505a0eea9e528ef444c61-560-3157328415+0",
            "59d505a0eea9e528ef444c61-561-3157328415+0",
            "59d505a0eea9e528ef444c61-562-3157328415+0",
            "59d505a0eea9e528ef444c61-569-3157328415+0",
            "59d505a0eea9e528ef444c61-570-3157328415+0",
            "59d505a0eea9e528ef444c61-571-3157328415+0",
            "59d505a0eea9e528ef444c61-572-3157328415+0",
            "59d505a0eea9e528ef444c61-573-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0",
          "displayName": "Fridge"
        },
        {
          "id": "568",
          "featureId": "59d505a0eea9e528ef444c61-568-3157328415+0",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "icon": "icon-l42_socket_2gang",
          "productCode": "L42",
          "groupId": "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
          "name": "Freezer",
          "linkId": "3157328415",
          "selected": true,
          "features": [
            "59d505a0eea9e528ef444c61-564-3157328415+0",
            "59d505a0eea9e528ef444c61-565-3157328415+0",
            "59d505a0eea9e528ef444c61-566-3157328415+0",
            "59d505a0eea9e528ef444c61-567-3157328415+0",
            "59d505a0eea9e528ef444c61-568-3157328415+0",
            "59d505a0eea9e528ef444c61-557-3157328415+0",
            "59d505a0eea9e528ef444c61-558-3157328415+0",
            "59d505a0eea9e528ef444c61-559-3157328415+0",
            "59d505a0eea9e528ef444c61-560-3157328415+0",
            "59d505a0eea9e528ef444c61-561-3157328415+0",
            "59d505a0eea9e528ef444c61-562-3157328415+0",
            "59d505a0eea9e528ef444c61-563-3157328415+0",
            "59d505a0eea9e528ef444c61-1757-3157328415+0",
            "59d505a0eea9e528ef444c61-1758-3157328415+0",
            "59d505a0eea9e528ef444c61-1759-3157328415+0",
            "59d505a0eea9e528ef444c61-1760-3157328415+0",
            "59d505a0eea9e528ef444c61-1761-3157328415+0"
          ],
          "type": "energy",
          "last_updated": 1658448000000,
          "up_to_date": true,
          "daily_data": [],
          "total": "0",
          "monthly_data": [],
          "monthly_total": "0"
        },
      ],
      "featureSetsWithoutData": [],
      "features": {
        "59d505a0eea9e528ef444c61-866-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-866-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.591Z",
          "attributes": {
            "featureId": 866,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-867-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-867-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.591Z",
          "attributes": {
            "featureId": 867,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-868-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-868-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.592Z",
          "attributes": {
            "featureId": 868,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-869-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-869-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.592Z",
          "attributes": {
            "featureId": 869,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-870-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-870-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.592Z",
          "attributes": {
            "featureId": 870,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-871-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-871-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.592Z",
          "attributes": {
            "featureId": 871,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-872-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-872-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.592Z",
          "attributes": {
            "featureId": 872,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-873-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-873-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.593Z",
          "attributes": {
            "featureId": 873,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-874-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-874-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.593Z",
          "attributes": {
            "featureId": 874,
            "writable": true,
            "channel": 0,
            "type": "dimSetup",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-875-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-875-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.593Z",
          "attributes": {
            "featureId": 875,
            "writable": true,
            "channel": 0,
            "type": "bulbSetup",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-876-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-876-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.593Z",
          "attributes": {
            "featureId": 876,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-877-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-877-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.593Z",
          "attributes": {
            "featureId": 877,
            "writable": true,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-878-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-878-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2019-02-16T08:09:26.594Z",
          "attributes": {
            "featureId": 878,
            "writable": true,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3037-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3037-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.813Z",
          "attributes": {
            "featureId": 3037,
            "deviceId": 112,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3038-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3038-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.813Z",
          "attributes": {
            "featureId": 3038,
            "deviceId": 112,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3039-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3039-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.814Z",
          "attributes": {
            "featureId": 3039,
            "deviceId": 112,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3040-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3040-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.814Z",
          "attributes": {
            "featureId": 3040,
            "deviceId": 112,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3041-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3041-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.814Z",
          "attributes": {
            "featureId": 3041,
            "deviceId": 112,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3042-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3042-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.814Z",
          "attributes": {
            "featureId": 3042,
            "deviceId": 112,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3043-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3043-3157328415+0",
          "name": "Bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "createdDate": "2021-03-29T16:04:30.814Z",
          "attributes": {
            "featureId": 3043,
            "deviceId": 112,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-3782-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3782-3157328415+0",
          "name": "john’s iPad",
          "deviceId": "59d505a0eea9e528ef444c61-294-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6113dc956bfd890dc2f3b63a"
          ],
          "createdDate": "2021-08-11T14:20:05.406Z",
          "attributes": {
            "featureId": 3782,
            "deviceId": 294,
            "type": "withinRadius",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": true,
            "status": "init",
            "name": "john’s iPad"
          }
        },
        "59d505a0eea9e528ef444c61-3783-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3783-3157328415+0",
          "name": "john’s iPad",
          "deviceId": "59d505a0eea9e528ef444c61-298-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6113dc956bfd890dc2f3b63d"
          ],
          "createdDate": "2021-08-11T14:20:05.507Z",
          "attributes": {
            "featureId": 3783,
            "deviceId": 298,
            "type": "withinRadius",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": true,
            "status": "init",
            "name": "john’s iPad"
          }
        },
        "59d505a0eea9e528ef444c61-144-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-144-3157328415+0",
          "name": "Bath light",
          "deviceId": "59d505a0eea9e528ef444c61-17-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51b5beea9e528ef449b4e"
          ],
          "createdDate": "2017-10-04T17:33:15.674Z",
          "attributes": {
            "name": "Bath light",
            "type": "switch",
            "channel": 0,
            "writable": true,
            "featureId": 144
          }
        },
        "59d505a0eea9e528ef444c61-145-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-145-3157328415+0",
          "name": "Bath light",
          "deviceId": "59d505a0eea9e528ef444c61-17-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51b5beea9e528ef449b4e"
          ],
          "createdDate": "2017-10-04T17:33:15.675Z",
          "attributes": {
            "name": "Bath light",
            "type": "protection",
            "channel": 0,
            "writable": true,
            "featureId": 145
          }
        },
        "59d505a0eea9e528ef444c61-146-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-146-3157328415+0",
          "name": "Bath light",
          "deviceId": "59d505a0eea9e528ef444c61-17-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51b5beea9e528ef449b4e"
          ],
          "createdDate": "2017-10-04T17:33:15.676Z",
          "attributes": {
            "name": "Bath light",
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "featureId": 146
          }
        },
        "59d505a0eea9e528ef444c61-980-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-980-3157328415+0",
          "name": "Bath light",
          "deviceId": "59d505a0eea9e528ef444c61-17-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51b5beea9e528ef449b4e"
          ],
          "createdDate": "2019-04-25T15:21:13.114Z",
          "attributes": {
            "featureId": 980,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Bath light"
          }
        },
        "59d505a0eea9e528ef444c61-721-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-721-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.484Z",
          "attributes": {
            "featureId": 721,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-722-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-722-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.485Z",
          "attributes": {
            "featureId": 722,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-723-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-723-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.485Z",
          "attributes": {
            "featureId": 723,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-724-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-724-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.485Z",
          "attributes": {
            "featureId": 724,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-725-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-725-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.486Z",
          "attributes": {
            "featureId": 725,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-726-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-726-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.486Z",
          "attributes": {
            "featureId": 726,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-727-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-727-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.486Z",
          "attributes": {
            "featureId": 727,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-728-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-728-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.487Z",
          "attributes": {
            "featureId": 728,
            "writable": true,
            "channel": 0,
            "type": "threeWayRelay",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-729-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-729-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2019-01-19T16:45:39.487Z",
          "attributes": {
            "featureId": 729,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-1811-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1811-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2020-06-23T09:15:47.109Z",
          "attributes": {
            "featureId": 1811,
            "deviceId": 105,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-1812-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1812-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2020-06-23T09:15:47.111Z",
          "attributes": {
            "featureId": 1812,
            "deviceId": 105,
            "type": "relaySetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-1813-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1813-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2020-06-23T09:15:47.112Z",
          "attributes": {
            "featureId": 1813,
            "deviceId": 105,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "ok",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-1814-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1814-3157328415+0",
          "name": "Towel rail",
          "deviceId": "59d505a0eea9e528ef444c61-105-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c435433890565768266d44d"
          ],
          "createdDate": "2020-06-23T09:15:47.112Z",
          "attributes": {
            "featureId": 1814,
            "deviceId": 105,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "ok",
            "name": "Towel rail"
          }
        },
        "59d505a0eea9e528ef444c61-4489-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4489-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.770Z",
          "attributes": {
            "featureId": 4489,
            "deviceId": 342,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4490-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4490-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.771Z",
          "attributes": {
            "featureId": 4490,
            "deviceId": 342,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4491-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4491-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.771Z",
          "attributes": {
            "featureId": 4491,
            "deviceId": 342,
            "type": "dimSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4492-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4492-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.771Z",
          "attributes": {
            "featureId": 4492,
            "deviceId": 342,
            "type": "bulbSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4493-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4493-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.772Z",
          "attributes": {
            "featureId": 4493,
            "deviceId": 342,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4494-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4494-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.772Z",
          "attributes": {
            "featureId": 4494,
            "deviceId": 342,
            "type": "power",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4495-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4495-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:30:29.772Z",
          "attributes": {
            "featureId": 4495,
            "deviceId": 342,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4483-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4483-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.775Z",
          "attributes": {
            "featureId": 4483,
            "deviceId": 342,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4484-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4484-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.775Z",
          "attributes": {
            "featureId": 4484,
            "deviceId": 342,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4485-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4485-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.775Z",
          "attributes": {
            "featureId": 4485,
            "deviceId": 342,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4486-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4486-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.776Z",
          "attributes": {
            "featureId": 4486,
            "deviceId": 342,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4487-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4487-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.776Z",
          "attributes": {
            "featureId": 4487,
            "deviceId": 342,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4488-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4488-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.776Z",
          "attributes": {
            "featureId": 4488,
            "deviceId": 342,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4503-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4503-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.545Z",
          "attributes": {
            "featureId": 4503,
            "deviceId": 342,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4504-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4504-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:40:31.546Z",
          "attributes": {
            "featureId": 4504,
            "deviceId": 342,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4505-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4505-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:40:31.546Z",
          "attributes": {
            "featureId": 4505,
            "deviceId": 342,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4506-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4506-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:40:31.546Z",
          "attributes": {
            "featureId": 4506,
            "deviceId": 342,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4507-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4507-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:40:31.548Z",
          "attributes": {
            "featureId": 4507,
            "deviceId": 342,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4508-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4508-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:40:31.548Z",
          "attributes": {
            "featureId": 4508,
            "deviceId": 342,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4509-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4509-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed"
          ],
          "createdDate": "2022-03-23T18:40:31.548Z",
          "attributes": {
            "featureId": 4509,
            "deviceId": 342,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-4496-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4496-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.773Z",
          "attributes": {
            "featureId": 4496,
            "deviceId": 342,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4497-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4497-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.773Z",
          "attributes": {
            "featureId": 4497,
            "deviceId": 342,
            "type": "dimLevel",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4498-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4498-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.773Z",
          "attributes": {
            "featureId": 4498,
            "deviceId": 342,
            "type": "dimSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4499-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4499-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.774Z",
          "attributes": {
            "featureId": 4499,
            "deviceId": 342,
            "type": "bulbSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4500-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4500-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.774Z",
          "attributes": {
            "featureId": 4500,
            "deviceId": 342,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4501-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4501-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.774Z",
          "attributes": {
            "featureId": 4501,
            "deviceId": 342,
            "type": "power",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4502-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4502-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:30:29.774Z",
          "attributes": {
            "featureId": 4502,
            "deviceId": 342,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4510-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4510-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.549Z",
          "attributes": {
            "featureId": 4510,
            "deviceId": 342,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4511-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4511-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.549Z",
          "attributes": {
            "featureId": 4511,
            "deviceId": 342,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4512-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4512-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.549Z",
          "attributes": {
            "featureId": 4512,
            "deviceId": 342,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4513-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4513-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.549Z",
          "attributes": {
            "featureId": 4513,
            "deviceId": 342,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4514-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4514-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.549Z",
          "attributes": {
            "featureId": 4514,
            "deviceId": 342,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-4515-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4515-3157328415+0",
          "name": "Main bed 1",
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "createdDate": "2022-03-23T18:40:31.551Z",
          "attributes": {
            "featureId": 4515,
            "deviceId": 342,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Main bed 1"
          }
        },
        "59d505a0eea9e528ef444c61-298-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-298-3157328415+0",
          "name": "Roof light",
          "deviceId": "59d505a0eea9e528ef444c61-37-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59dfd0de5cde16166bbc74a5"
          ],
          "createdDate": "2017-10-12T20:30:22.843Z",
          "attributes": {
            "name": "Roof light",
            "type": "switch",
            "channel": 0,
            "writable": true,
            "featureId": 298
          }
        },
        "59d505a0eea9e528ef444c61-299-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "name": "Roof light",
          "deviceId": "59d505a0eea9e528ef444c61-37-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59dfd0de5cde16166bbc74a5"
          ],
          "createdDate": "2017-10-12T20:30:22.844Z",
          "attributes": {
            "name": "Roof light",
            "type": "protection",
            "channel": 0,
            "writable": true,
            "featureId": 299
          }
        },
        "59d505a0eea9e528ef444c61-300-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "name": "Roof light",
          "deviceId": "59d505a0eea9e528ef444c61-37-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59dfd0de5cde16166bbc74a5"
          ],
          "createdDate": "2017-10-12T20:30:22.845Z",
          "attributes": {
            "name": "Roof light",
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "featureId": 300
          }
        },
        "59d505a0eea9e528ef444c61-982-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-982-3157328415+0",
          "name": "Roof light",
          "deviceId": "59d505a0eea9e528ef444c61-37-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59dfd0de5cde16166bbc74a5"
          ],
          "createdDate": "2019-04-25T15:21:12.144Z",
          "attributes": {
            "featureId": 982,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Roof light"
          }
        },
        "59d505a0eea9e528ef444c61-703-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-703-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2018-12-15T16:58:46.545Z",
          "attributes": {
            "featureId": 703,
            "writable": false,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-704-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-704-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2018-12-15T16:58:46.545Z",
          "attributes": {
            "featureId": 704,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-705-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-705-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2018-12-15T16:58:46.546Z",
          "attributes": {
            "featureId": 705,
            "writable": true,
            "channel": 0,
            "type": "valveLevel",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-706-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-706-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2018-12-15T16:58:46.546Z",
          "attributes": {
            "featureId": 706,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-707-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-707-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2018-12-15T16:58:46.546Z",
          "attributes": {
            "featureId": 707,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-977-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-977-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2019-04-25T15:21:16.197Z",
          "attributes": {
            "featureId": 977,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-978-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-978-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2019-04-25T15:21:16.198Z",
          "attributes": {
            "featureId": 978,
            "writable": false,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-1234-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1234-3157328415+0",
          "name": "Roof heater",
          "deviceId": "59d505a0eea9e528ef444c61-103-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c1532c607194d7d8d8b47d5"
          ],
          "createdDate": "2019-09-13T17:05:07.705Z",
          "attributes": {
            "featureId": 1234,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Roof heater"
          }
        },
        "59d505a0eea9e528ef444c61-879-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-879-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.746Z",
          "attributes": {
            "featureId": 879,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-880-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-880-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.746Z",
          "attributes": {
            "featureId": 880,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-881-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-881-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.749Z",
          "attributes": {
            "featureId": 881,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-882-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-882-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.749Z",
          "attributes": {
            "featureId": 882,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-883-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-883-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.749Z",
          "attributes": {
            "featureId": 883,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-884-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-884-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.749Z",
          "attributes": {
            "featureId": 884,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-885-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-885-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.749Z",
          "attributes": {
            "featureId": 885,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-886-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-886-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.750Z",
          "attributes": {
            "featureId": 886,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-887-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-887-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.750Z",
          "attributes": {
            "featureId": 887,
            "writable": true,
            "channel": 0,
            "type": "dimSetup",
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-888-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-888-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.750Z",
          "attributes": {
            "featureId": 888,
            "writable": true,
            "channel": 0,
            "type": "bulbSetup",
            "status": "ok"
          }
        },
        "59d505a0eea9e528ef444c61-889-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-889-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.750Z",
          "attributes": {
            "featureId": 889,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "ok"
          }
        },
        "59d505a0eea9e528ef444c61-890-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-890-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-16T08:10:10.751Z",
          "attributes": {
            "featureId": 890,
            "writable": true,
            "channel": 0,
            "type": "power",
            "status": "ok"
          }
        },
        "59d505a0eea9e528ef444c61-920-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-920-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2019-02-18T14:47:49.472Z",
          "attributes": {
            "featureId": 920,
            "writable": true,
            "channel": 0,
            "type": "energy",
            "status": "ok",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3103-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3103-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.996Z",
          "attributes": {
            "featureId": 3103,
            "deviceId": 113,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3104-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3104-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.996Z",
          "attributes": {
            "featureId": 3104,
            "deviceId": 113,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3105-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3105-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.996Z",
          "attributes": {
            "featureId": 3105,
            "deviceId": 113,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3106-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3106-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.997Z",
          "attributes": {
            "featureId": 3106,
            "deviceId": 113,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3107-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3107-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.997Z",
          "attributes": {
            "featureId": 3107,
            "deviceId": 113,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3108-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3108-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.997Z",
          "attributes": {
            "featureId": 3108,
            "deviceId": 113,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3109-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3109-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-113-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c67c562057e67216c8b6032"
          ],
          "createdDate": "2021-03-29T16:04:30.997Z",
          "attributes": {
            "featureId": 3109,
            "deviceId": 113,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-2066-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2066-3157328415+0",
          "name": "TRIGGER 1",
          "deviceId": "59d505a0eea9e528ef444c61-213-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f9311b663ff890d7c4f2e76"
          ],
          "createdDate": "2020-10-23T17:24:06.984Z",
          "attributes": {
            "featureId": 2066,
            "deviceId": 213,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 1"
          }
        },
        "59d505a0eea9e528ef444c61-2067-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2067-3157328415+0",
          "name": "TRIGGER 2",
          "deviceId": "59d505a0eea9e528ef444c61-214-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f9311b763ff890d7c4f2e79"
          ],
          "createdDate": "2020-10-23T17:24:07.082Z",
          "attributes": {
            "featureId": 2067,
            "deviceId": 214,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 2"
          }
        },
        "59d505a0eea9e528ef444c61-2068-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2068-3157328415+0",
          "name": "TRIGGER 3",
          "deviceId": "59d505a0eea9e528ef444c61-215-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f9311b763ff890d7c4f2e7c"
          ],
          "createdDate": "2020-10-23T17:24:07.185Z",
          "attributes": {
            "featureId": 2068,
            "deviceId": 215,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 3"
          }
        },
        "59d505a0eea9e528ef444c61-2069-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2069-3157328415+0",
          "name": "TRIGGER 4",
          "deviceId": "59d505a0eea9e528ef444c61-216-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f9311b763ff890d7c4f2e7f"
          ],
          "createdDate": "2020-10-23T17:24:07.283Z",
          "attributes": {
            "featureId": 2069,
            "deviceId": 216,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 4"
          }
        },
        "59d505a0eea9e528ef444c61-2070-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2070-3157328415+0",
          "name": "TRIGGER 5",
          "deviceId": "59d505a0eea9e528ef444c61-217-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f9311b763ff890d7c4f2e82"
          ],
          "createdDate": "2020-10-23T17:24:07.390Z",
          "attributes": {
            "featureId": 2070,
            "deviceId": 217,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 5"
          }
        },
        "59d505a0eea9e528ef444c61-2071-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2071-3157328415+0",
          "name": "TRIGGER 6",
          "deviceId": "59d505a0eea9e528ef444c61-218-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f942a80f9fae20d592a97d7"
          ],
          "createdDate": "2020-10-24T13:22:08.337Z",
          "attributes": {
            "featureId": 2071,
            "deviceId": 218,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 6"
          }
        },
        "59d505a0eea9e528ef444c61-2072-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2072-3157328415+0",
          "name": "TRIGGER 7",
          "deviceId": "59d505a0eea9e528ef444c61-219-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f942a80f9fae20d592a97da"
          ],
          "createdDate": "2020-10-24T13:22:08.437Z",
          "attributes": {
            "featureId": 2072,
            "deviceId": 219,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 7"
          }
        },
        "59d505a0eea9e528ef444c61-2073-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2073-3157328415+0",
          "name": "TRIGGER 8",
          "deviceId": "59d505a0eea9e528ef444c61-220-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f942a80f9fae20d592a97dd"
          ],
          "createdDate": "2020-10-24T13:22:08.546Z",
          "attributes": {
            "featureId": 2073,
            "deviceId": 220,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 8"
          }
        },
        "59d505a0eea9e528ef444c61-2074-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2074-3157328415+0",
          "name": "TRIGGER 9",
          "deviceId": "59d505a0eea9e528ef444c61-221-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f942a80f9fae20d592a97e0"
          ],
          "createdDate": "2020-10-24T13:22:08.729Z",
          "attributes": {
            "featureId": 2074,
            "deviceId": 221,
            "type": "trigger",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": true,
            "status": "lastKnown",
            "name": "TRIGGER 9"
          }
        },
        "59d505a0eea9e528ef444c61-1549-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1549-3157328415+0",
          "name": "Desk1",
          "deviceId": "59d505a0eea9e528ef444c61-187-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e81f139f108484d669a3717"
          ],
          "createdDate": "2020-03-30T13:16:41.866Z",
          "attributes": {
            "featureId": 1549,
            "deviceId": 187,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Desk1"
          }
        },
        "59d505a0eea9e528ef444c61-1550-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1550-3157328415+0",
          "name": "Desk1",
          "deviceId": "59d505a0eea9e528ef444c61-187-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e81f139f108484d669a3717"
          ],
          "createdDate": "2020-03-30T13:16:41.866Z",
          "attributes": {
            "featureId": 1550,
            "deviceId": 187,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Desk1"
          }
        },
        "59d505a0eea9e528ef444c61-1551-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1551-3157328415+0",
          "name": "Desk1",
          "deviceId": "59d505a0eea9e528ef444c61-187-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e81f139f108484d669a3717"
          ],
          "createdDate": "2020-03-30T13:16:41.867Z",
          "attributes": {
            "featureId": 1551,
            "deviceId": 187,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Desk1"
          }
        },
        "59d505a0eea9e528ef444c61-1552-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1552-3157328415+0",
          "name": "Desk1",
          "deviceId": "59d505a0eea9e528ef444c61-187-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e81f139f108484d669a3717"
          ],
          "createdDate": "2020-03-30T13:16:41.867Z",
          "attributes": {
            "featureId": 1552,
            "deviceId": 187,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Desk1"
          }
        },
        "59d505a0eea9e528ef444c61-4436-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4436-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:04:18.464Z",
          "attributes": {
            "featureId": 4436,
            "deviceId": 340,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4437-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4437-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:04:18.465Z",
          "attributes": {
            "featureId": 4437,
            "deviceId": 340,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4438-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4438-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:04:18.466Z",
          "attributes": {
            "featureId": 4438,
            "deviceId": 340,
            "type": "dimSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4439-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4439-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:04:18.466Z",
          "attributes": {
            "featureId": 4439,
            "deviceId": 340,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4440-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4440-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:04:18.466Z",
          "attributes": {
            "featureId": 4440,
            "deviceId": 340,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4441-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4441-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:04:18.467Z",
          "attributes": {
            "featureId": 4441,
            "deviceId": 340,
            "type": "energy",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4430-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4430-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.469Z",
          "attributes": {
            "featureId": 4430,
            "deviceId": 340,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4431-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4431-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.469Z",
          "attributes": {
            "featureId": 4431,
            "deviceId": 340,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4432-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4432-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.470Z",
          "attributes": {
            "featureId": 4432,
            "deviceId": 340,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4433-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4433-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.470Z",
          "attributes": {
            "featureId": 4433,
            "deviceId": 340,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4434-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4434-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.471Z",
          "attributes": {
            "featureId": 4434,
            "deviceId": 340,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4435-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4435-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.471Z",
          "attributes": {
            "featureId": 4435,
            "deviceId": 340,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4448-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4448-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T10:21:43.647Z",
          "attributes": {
            "featureId": 4448,
            "deviceId": 340,
            "type": "bulbSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4450-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4450-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86",
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.688Z",
          "attributes": {
            "featureId": 4450,
            "deviceId": 340,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4451-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4451-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T11:07:21.689Z",
          "attributes": {
            "featureId": 4451,
            "deviceId": 340,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4452-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4452-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T11:07:21.689Z",
          "attributes": {
            "featureId": 4452,
            "deviceId": 340,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4453-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4453-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T11:07:21.690Z",
          "attributes": {
            "featureId": 4453,
            "deviceId": 340,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4454-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4454-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T11:07:21.690Z",
          "attributes": {
            "featureId": 4454,
            "deviceId": 340,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4455-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4455-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T11:07:21.690Z",
          "attributes": {
            "featureId": 4455,
            "deviceId": 340,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4456-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4456-3157328415+0",
          "name": "Dining",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa86"
          ],
          "createdDate": "2022-03-23T11:07:21.691Z",
          "attributes": {
            "featureId": 4456,
            "deviceId": 340,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining"
          }
        },
        "59d505a0eea9e528ef444c61-4442-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4442-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.467Z",
          "attributes": {
            "featureId": 4442,
            "deviceId": 340,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4443-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4443-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.468Z",
          "attributes": {
            "featureId": 4443,
            "deviceId": 340,
            "type": "dimLevel",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4444-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4444-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.468Z",
          "attributes": {
            "featureId": 4444,
            "deviceId": 340,
            "type": "dimSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4445-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4445-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.468Z",
          "attributes": {
            "featureId": 4445,
            "deviceId": 340,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4446-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4446-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.468Z",
          "attributes": {
            "featureId": 4446,
            "deviceId": 340,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4447-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4447-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:04:18.469Z",
          "attributes": {
            "featureId": 4447,
            "deviceId": 340,
            "type": "energy",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4449-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4449-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T10:21:43.648Z",
          "attributes": {
            "featureId": 4449,
            "deviceId": 340,
            "type": "bulbSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4457-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4457-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.691Z",
          "attributes": {
            "featureId": 4457,
            "deviceId": 340,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4458-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4458-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.691Z",
          "attributes": {
            "featureId": 4458,
            "deviceId": 340,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4459-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4459-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.691Z",
          "attributes": {
            "featureId": 4459,
            "deviceId": 340,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4460-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4460-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.692Z",
          "attributes": {
            "featureId": 4460,
            "deviceId": 340,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4461-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4461-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.692Z",
          "attributes": {
            "featureId": 4461,
            "deviceId": 340,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-4462-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4462-3157328415+0",
          "name": "Dining 1",
          "deviceId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623af0a259b51614b16caa87"
          ],
          "createdDate": "2022-03-23T11:07:21.692Z",
          "attributes": {
            "featureId": 4462,
            "deviceId": 340,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Dining 1"
          }
        },
        "59d505a0eea9e528ef444c61-564-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-564-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2018-07-01T16:36:47.331Z",
          "attributes": {
            "featureId": 564,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-565-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-565-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2018-07-01T16:36:47.332Z",
          "attributes": {
            "featureId": 565,
            "writable": false,
            "channel": 0,
            "type": "outletInUse",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-566-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-566-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2018-07-01T16:36:47.332Z",
          "attributes": {
            "featureId": 566,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-567-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-567-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2018-07-01T16:36:47.332Z",
          "attributes": {
            "featureId": 567,
            "writable": false,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-568-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-568-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2018-07-01T16:36:47.333Z",
          "attributes": {
            "featureId": 568,
            "writable": false,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-557-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-557-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.334Z",
          "attributes": {
            "featureId": 557,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-558-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-558-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.335Z",
          "attributes": {
            "featureId": 558,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-559-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-559-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.335Z",
          "attributes": {
            "featureId": 559,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-560-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-560-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.335Z",
          "attributes": {
            "featureId": 560,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-561-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-561-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.344Z",
          "attributes": {
            "featureId": 561,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-562-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-562-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.344Z",
          "attributes": {
            "featureId": 562,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-563-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-563-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2018-07-01T16:36:47.344Z",
          "attributes": {
            "featureId": 563,
            "writable": false,
            "channel": 0,
            "type": "voltage",
            "status": "init",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-1757-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1757-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2020-05-22T16:19:07.801Z",
          "attributes": {
            "featureId": 1757,
            "deviceId": 85,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-1758-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1758-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2020-05-22T16:19:07.801Z",
          "attributes": {
            "featureId": 1758,
            "deviceId": 85,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-1759-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1759-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2020-05-22T16:19:07.801Z",
          "attributes": {
            "featureId": 1759,
            "deviceId": 85,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-1760-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1760-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2020-05-22T16:19:07.802Z",
          "attributes": {
            "featureId": 1760,
            "deviceId": 85,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-1761-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1761-3157328415+0",
          "name": "Fridge",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c"
          ],
          "createdDate": "2020-05-22T16:19:07.802Z",
          "attributes": {
            "featureId": 1761,
            "deviceId": 85,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Fridge"
          }
        },
        "59d505a0eea9e528ef444c61-1762-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1762-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2020-05-22T16:19:07.802Z",
          "attributes": {
            "featureId": 1762,
            "deviceId": 85,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-1763-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1763-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2020-05-22T16:19:07.802Z",
          "attributes": {
            "featureId": 1763,
            "deviceId": 85,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-1764-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1764-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2020-05-22T16:19:07.802Z",
          "attributes": {
            "featureId": 1764,
            "deviceId": 85,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-1765-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1765-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2020-05-22T16:19:07.803Z",
          "attributes": {
            "featureId": 1765,
            "deviceId": 85,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-1766-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1766-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2020-05-22T16:19:07.803Z",
          "attributes": {
            "featureId": 1766,
            "deviceId": 85,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-569-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-569-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.333Z",
          "attributes": {
            "featureId": 569,
            "writable": true,
            "channel": 1,
            "type": "switch",
            "status": "init",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-570-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-570-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.333Z",
          "attributes": {
            "featureId": 570,
            "writable": false,
            "channel": 1,
            "type": "outletInUse",
            "status": "init",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-571-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-571-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.334Z",
          "attributes": {
            "featureId": 571,
            "writable": true,
            "channel": 1,
            "type": "protection",
            "status": "init",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-572-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-572-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.334Z",
          "attributes": {
            "featureId": 572,
            "writable": false,
            "channel": 1,
            "type": "power",
            "status": "init",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-573-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-573-3157328415+0",
          "name": "Fridge 1",
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "createdDate": "2018-07-01T16:36:47.334Z",
          "attributes": {
            "featureId": 573,
            "writable": false,
            "channel": 1,
            "type": "energy",
            "status": "init",
            "name": "Fridge 1"
          }
        },
        "59d505a0eea9e528ef444c61-574-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-574-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-86-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b3b12eddf243261884ff6d6"
          ],
          "createdDate": "2018-07-03T06:08:45.020Z",
          "attributes": {
            "featureId": 574,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "unknown",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-575-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-575-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-86-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b3b12eddf243261884ff6d6"
          ],
          "createdDate": "2018-07-03T06:08:45.020Z",
          "attributes": {
            "featureId": 575,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "unknown",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-994-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-994-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-86-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b3b12eddf243261884ff6d6"
          ],
          "createdDate": "2019-04-25T15:21:16.018Z",
          "attributes": {
            "featureId": 994,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-576-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-576-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-87-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b3b12fedf243261884ffe69"
          ],
          "createdDate": "2018-07-03T06:09:02.444Z",
          "attributes": {
            "featureId": 576,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-577-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-577-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-87-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b3b12fedf243261884ffe69"
          ],
          "createdDate": "2018-07-03T06:09:02.444Z",
          "attributes": {
            "featureId": 577,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-995-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-995-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-87-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b3b12fedf243261884ffe69"
          ],
          "createdDate": "2019-04-25T15:21:15.794Z",
          "attributes": {
            "featureId": 995,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-1197-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1197-3157328415+0",
          "name": "Plate rack",
          "deviceId": "59d505a0eea9e528ef444c61-147-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d53a7597ff5ec6a3abddf97"
          ],
          "createdDate": "2019-08-14T06:16:57.064Z",
          "attributes": {
            "featureId": 1197,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Plate rack"
          }
        },
        "59d505a0eea9e528ef444c61-1198-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1198-3157328415+0",
          "name": "Plate rack",
          "deviceId": "59d505a0eea9e528ef444c61-147-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d53a7597ff5ec6a3abddf97"
          ],
          "createdDate": "2019-08-14T06:16:57.064Z",
          "attributes": {
            "featureId": 1198,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Plate rack"
          }
        },
        "59d505a0eea9e528ef444c61-1199-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1199-3157328415+0",
          "name": "Plate rack",
          "deviceId": "59d505a0eea9e528ef444c61-147-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d53a7597ff5ec6a3abddf97"
          ],
          "createdDate": "2019-08-14T06:16:57.064Z",
          "attributes": {
            "featureId": 1199,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Plate rack"
          }
        },
        "59d505a0eea9e528ef444c61-1849-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1849-3157328415+0",
          "name": "Kitchen cupboard",
          "deviceId": "59d505a0eea9e528ef444c61-198-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f3791beedf5960d47a3151b"
          ],
          "createdDate": "2020-08-15T07:41:50.881Z",
          "attributes": {
            "featureId": 1849,
            "deviceId": 198,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen cupboard"
          }
        },
        "59d505a0eea9e528ef444c61-1850-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1850-3157328415+0",
          "name": "Kitchen cupboard",
          "deviceId": "59d505a0eea9e528ef444c61-198-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f3791beedf5960d47a3151b"
          ],
          "createdDate": "2020-08-15T07:41:50.882Z",
          "attributes": {
            "featureId": 1850,
            "deviceId": 198,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen cupboard"
          }
        },
        "59d505a0eea9e528ef444c61-1851-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1851-3157328415+0",
          "name": "Kitchen cupboard",
          "deviceId": "59d505a0eea9e528ef444c61-198-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f3791beedf5960d47a3151b"
          ],
          "createdDate": "2020-08-15T07:41:50.882Z",
          "attributes": {
            "featureId": 1851,
            "deviceId": 198,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen cupboard"
          }
        },
        "59d505a0eea9e528ef444c61-2059-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2059-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.183Z",
          "attributes": {
            "featureId": 2059,
            "deviceId": 212,
            "type": "floodValveLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2060-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2060-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.183Z",
          "attributes": {
            "featureId": 2060,
            "deviceId": 212,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2061-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2061-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.183Z",
          "attributes": {
            "featureId": 2061,
            "deviceId": 212,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2062-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2062-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.183Z",
          "attributes": {
            "featureId": 2062,
            "deviceId": 212,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2063-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2063-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.184Z",
          "attributes": {
            "featureId": 2063,
            "deviceId": 212,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2064-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2064-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.184Z",
          "attributes": {
            "featureId": 2064,
            "deviceId": 212,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2065-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2065-3157328415+0",
          "name": "W",
          "deviceId": "59d505a0eea9e528ef444c61-212-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f8c5cd6f9fae20d592845df"
          ],
          "createdDate": "2020-10-18T15:18:46.184Z",
          "attributes": {
            "featureId": 2065,
            "deviceId": 212,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "W"
          }
        },
        "59d505a0eea9e528ef444c61-2082-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2082-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.869Z",
          "attributes": {
            "featureId": 2082,
            "deviceId": 222,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2083-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2083-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.869Z",
          "attributes": {
            "featureId": 2083,
            "deviceId": 222,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2084-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2084-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.870Z",
          "attributes": {
            "featureId": 2084,
            "deviceId": 222,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2085-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2085-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.870Z",
          "attributes": {
            "featureId": 2085,
            "deviceId": 222,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2086-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2086-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.870Z",
          "attributes": {
            "featureId": 2086,
            "deviceId": 222,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2087-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2087-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.870Z",
          "attributes": {
            "featureId": 2087,
            "deviceId": 222,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2088-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2088-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.870Z",
          "attributes": {
            "featureId": 2088,
            "deviceId": 222,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2089-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2089-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.870Z",
          "attributes": {
            "featureId": 2089,
            "deviceId": 222,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2090-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2090-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.871Z",
          "attributes": {
            "featureId": 2090,
            "deviceId": 222,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2091-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2091-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e"
          ],
          "createdDate": "2020-10-28T18:19:03.871Z",
          "attributes": {
            "featureId": 2091,
            "deviceId": 222,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2075-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2075-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.873Z",
          "attributes": {
            "featureId": 2075,
            "deviceId": 222,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2076-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2076-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.873Z",
          "attributes": {
            "featureId": 2076,
            "deviceId": 222,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2077-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2077-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.873Z",
          "attributes": {
            "featureId": 2077,
            "deviceId": 222,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2078-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2078-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.874Z",
          "attributes": {
            "featureId": 2078,
            "deviceId": 222,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2079-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2079-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.874Z",
          "attributes": {
            "featureId": 2079,
            "deviceId": 222,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2080-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2080-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.874Z",
          "attributes": {
            "featureId": 2080,
            "deviceId": 222,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2081-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2081-3157328415+0",
          "name": "KL 2",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4e",
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.874Z",
          "attributes": {
            "featureId": 2081,
            "deviceId": 222,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2"
          }
        },
        "59d505a0eea9e528ef444c61-2092-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2092-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.871Z",
          "attributes": {
            "featureId": 2092,
            "deviceId": 222,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2093-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2093-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2093,
            "deviceId": 222,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2094-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2094-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2094,
            "deviceId": 222,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2095-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2095-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2095,
            "deviceId": 222,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2096-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2096-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2096,
            "deviceId": 222,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2097-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2097-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2097,
            "deviceId": 222,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2098-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2098-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2098,
            "deviceId": 222,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2099-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2099-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.872Z",
          "attributes": {
            "featureId": 2099,
            "deviceId": 222,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2100-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2100-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.873Z",
          "attributes": {
            "featureId": 2100,
            "deviceId": 222,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2101-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2101-3157328415+0",
          "name": "KL 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-222-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b6178d3fe70df39b4b4f"
          ],
          "createdDate": "2020-10-28T18:19:03.873Z",
          "attributes": {
            "featureId": 2101,
            "deviceId": 222,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "KL 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-2163-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2163-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.163Z",
          "attributes": {
            "featureId": 2163,
            "deviceId": 225,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2164-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2164-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.165Z",
          "attributes": {
            "featureId": 2164,
            "deviceId": 225,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2165-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2165-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.165Z",
          "attributes": {
            "featureId": 2165,
            "deviceId": 225,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2166-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2166-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.165Z",
          "attributes": {
            "featureId": 2166,
            "deviceId": 225,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2167-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2167-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.166Z",
          "attributes": {
            "featureId": 2167,
            "deviceId": 225,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2168-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2168-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.166Z",
          "attributes": {
            "featureId": 2168,
            "deviceId": 225,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2169-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2169-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.166Z",
          "attributes": {
            "featureId": 2169,
            "deviceId": 225,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2170-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2170-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.166Z",
          "attributes": {
            "featureId": 2170,
            "deviceId": 225,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2171-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2171-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.167Z",
          "attributes": {
            "featureId": 2171,
            "deviceId": 225,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2172-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2172-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42"
          ],
          "createdDate": "2020-11-02T13:02:23.167Z",
          "attributes": {
            "featureId": 2172,
            "deviceId": 225,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2156-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2156-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.170Z",
          "attributes": {
            "featureId": 2156,
            "deviceId": 225,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2157-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2157-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.170Z",
          "attributes": {
            "featureId": 2157,
            "deviceId": 225,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2158-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2158-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.170Z",
          "attributes": {
            "featureId": 2158,
            "deviceId": 225,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2159-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2159-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.171Z",
          "attributes": {
            "featureId": 2159,
            "deviceId": 225,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2160-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2160-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.171Z",
          "attributes": {
            "featureId": 2160,
            "deviceId": 225,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2161-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2161-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.171Z",
          "attributes": {
            "featureId": 2161,
            "deviceId": 225,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2162-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2162-3157328415+0",
          "name": "Worktop",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.171Z",
          "attributes": {
            "featureId": 2162,
            "deviceId": 225,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop"
          }
        },
        "59d505a0eea9e528ef444c61-2173-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2173-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.168Z",
          "attributes": {
            "featureId": 2173,
            "deviceId": 225,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2174-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2174-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.168Z",
          "attributes": {
            "featureId": 2174,
            "deviceId": 225,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2175-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2175-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.168Z",
          "attributes": {
            "featureId": 2175,
            "deviceId": 225,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2176-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2176-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.169Z",
          "attributes": {
            "featureId": 2176,
            "deviceId": 225,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2177-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2177-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.169Z",
          "attributes": {
            "featureId": 2177,
            "deviceId": 225,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2178-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2178-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.169Z",
          "attributes": {
            "featureId": 2178,
            "deviceId": 225,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2179-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2179-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.169Z",
          "attributes": {
            "featureId": 2179,
            "deviceId": 225,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2180-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2180-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.169Z",
          "attributes": {
            "featureId": 2180,
            "deviceId": 225,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2181-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2181-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.169Z",
          "attributes": {
            "featureId": 2181,
            "deviceId": 225,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-2182-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2182-3157328415+0",
          "name": "Worktop 1",
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "createdDate": "2020-11-02T13:02:23.170Z",
          "attributes": {
            "featureId": 2182,
            "deviceId": 225,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Worktop 1"
          }
        },
        "59d505a0eea9e528ef444c61-4388-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4388-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.171Z",
          "attributes": {
            "featureId": 4388,
            "deviceId": 334,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4389-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4389-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.172Z",
          "attributes": {
            "featureId": 4389,
            "deviceId": 334,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4390-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4390-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.172Z",
          "attributes": {
            "featureId": 4390,
            "deviceId": 334,
            "type": "dimSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4391-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4391-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.173Z",
          "attributes": {
            "featureId": 4391,
            "deviceId": 334,
            "type": "bulbSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4392-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4392-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.173Z",
          "attributes": {
            "featureId": 4392,
            "deviceId": 334,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4393-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4393-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.174Z",
          "attributes": {
            "featureId": 4393,
            "deviceId": 334,
            "type": "power",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4394-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4394-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T17:56:03.174Z",
          "attributes": {
            "featureId": 4394,
            "deviceId": 334,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4382-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4382-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.179Z",
          "attributes": {
            "featureId": 4382,
            "deviceId": 334,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4383-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4383-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.179Z",
          "attributes": {
            "featureId": 4383,
            "deviceId": 334,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4384-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4384-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.180Z",
          "attributes": {
            "featureId": 4384,
            "deviceId": 334,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4385-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4385-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.180Z",
          "attributes": {
            "featureId": 4385,
            "deviceId": 334,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4386-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4386-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.181Z",
          "attributes": {
            "featureId": 4386,
            "deviceId": 334,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4387-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4387-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.181Z",
          "attributes": {
            "featureId": 4387,
            "deviceId": 334,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4402-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4402-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208",
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.831Z",
          "attributes": {
            "featureId": 4402,
            "deviceId": 334,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4403-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4403-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T18:02:43.832Z",
          "attributes": {
            "featureId": 4403,
            "deviceId": 334,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4404-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4404-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T18:02:43.832Z",
          "attributes": {
            "featureId": 4404,
            "deviceId": 334,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4405-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4405-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T18:02:43.832Z",
          "attributes": {
            "featureId": 4405,
            "deviceId": 334,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4406-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4406-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T18:02:43.833Z",
          "attributes": {
            "featureId": 4406,
            "deviceId": 334,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4407-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4407-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T18:02:43.833Z",
          "attributes": {
            "featureId": 4407,
            "deviceId": 334,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4408-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4408-3157328415+0",
          "name": "Kitchen",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57208"
          ],
          "createdDate": "2022-03-09T18:02:43.833Z",
          "attributes": {
            "featureId": 4408,
            "deviceId": 334,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Kitchen"
          }
        },
        "59d505a0eea9e528ef444c61-4395-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4395-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.175Z",
          "attributes": {
            "featureId": 4395,
            "deviceId": 334,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4396-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4396-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.176Z",
          "attributes": {
            "featureId": 4396,
            "deviceId": 334,
            "type": "dimLevel",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4397-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4397-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.177Z",
          "attributes": {
            "featureId": 4397,
            "deviceId": 334,
            "type": "dimSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4398-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4398-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.177Z",
          "attributes": {
            "featureId": 4398,
            "deviceId": 334,
            "type": "bulbSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4399-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4399-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.177Z",
          "attributes": {
            "featureId": 4399,
            "deviceId": 334,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4400-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4400-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.178Z",
          "attributes": {
            "featureId": 4400,
            "deviceId": 334,
            "type": "power",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4401-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4401-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T17:56:03.178Z",
          "attributes": {
            "featureId": 4401,
            "deviceId": 334,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4409-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4409-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.833Z",
          "attributes": {
            "featureId": 4409,
            "deviceId": 334,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4410-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4410-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.834Z",
          "attributes": {
            "featureId": 4410,
            "deviceId": 334,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4411-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4411-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.834Z",
          "attributes": {
            "featureId": 4411,
            "deviceId": 334,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4412-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4412-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.834Z",
          "attributes": {
            "featureId": 4412,
            "deviceId": 334,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4413-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4413-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.834Z",
          "attributes": {
            "featureId": 4413,
            "deviceId": 334,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4414-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4414-3157328415+0",
          "name": "Kitchen 1",
          "deviceId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6228ea337c46e00b90c57209"
          ],
          "createdDate": "2022-03-09T18:02:43.835Z",
          "attributes": {
            "featureId": 4414,
            "deviceId": 334,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Kitchen 1"
          }
        },
        "59d505a0eea9e528ef444c61-4426-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4426-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577"
          ],
          "createdDate": "2022-03-09T21:55:12.920Z",
          "attributes": {
            "featureId": 4426,
            "deviceId": 338,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4427-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4427-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577"
          ],
          "createdDate": "2022-03-09T21:55:12.921Z",
          "attributes": {
            "featureId": 4427,
            "deviceId": 338,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4415-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4415-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.924Z",
          "attributes": {
            "featureId": 4415,
            "deviceId": 338,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4416-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4416-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.924Z",
          "attributes": {
            "featureId": 4416,
            "deviceId": 338,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4417-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4417-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.924Z",
          "attributes": {
            "featureId": 4417,
            "deviceId": 338,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4418-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4418-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.925Z",
          "attributes": {
            "featureId": 4418,
            "deviceId": 338,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4419-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4419-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.925Z",
          "attributes": {
            "featureId": 4419,
            "deviceId": 338,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4420-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4420-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.925Z",
          "attributes": {
            "featureId": 4420,
            "deviceId": 338,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4421-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4421-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.926Z",
          "attributes": {
            "featureId": 4421,
            "deviceId": 338,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4422-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4422-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.926Z",
          "attributes": {
            "featureId": 4422,
            "deviceId": 338,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4423-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4423-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.926Z",
          "attributes": {
            "featureId": 4423,
            "deviceId": 338,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4424-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4424-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.927Z",
          "attributes": {
            "featureId": 4424,
            "deviceId": 338,
            "type": "powerSource",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4425-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4425-3157328415+0",
          "name": "Wire free",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491577",
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.927Z",
          "attributes": {
            "featureId": 4425,
            "deviceId": 338,
            "type": "lightLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free"
          }
        },
        "59d505a0eea9e528ef444c61-4428-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4428-3157328415+0",
          "name": "Wire free 1",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.921Z",
          "attributes": {
            "featureId": 4428,
            "deviceId": 338,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Wire free 1"
          }
        },
        "59d505a0eea9e528ef444c61-4429-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4429-3157328415+0",
          "name": "Wire free 1",
          "deviceId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-622922403f1e1e0b9c491578"
          ],
          "createdDate": "2022-03-09T21:55:12.923Z",
          "attributes": {
            "featureId": 4429,
            "deviceId": 338,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Wire free 1"
          }
        },
        "59d505a0eea9e528ef444c61-335-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-335-3157328415+0",
          "name": "Front door",
          "deviceId": "59d505a0eea9e528ef444c61-46-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59ff426842d7e1248ab5c16b"
          ],
          "createdDate": "2017-11-05T16:55:04.211Z",
          "attributes": {
            "name": "Front door",
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "featureId": 335
          }
        },
        "59d505a0eea9e528ef444c61-336-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-336-3157328415+0",
          "name": "Front door",
          "deviceId": "59d505a0eea9e528ef444c61-46-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59ff426842d7e1248ab5c16b"
          ],
          "createdDate": "2017-11-05T16:55:04.212Z",
          "attributes": {
            "name": "Front door",
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "featureId": 336
          }
        },
        "59d505a0eea9e528ef444c61-337-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-337-3157328415+0",
          "name": "Front door",
          "deviceId": "59d505a0eea9e528ef444c61-46-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59ff426842d7e1248ab5c16b"
          ],
          "createdDate": "2017-11-05T16:55:04.212Z",
          "attributes": {
            "name": "Front door",
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "featureId": 337
          }
        },
        "59d505a0eea9e528ef444c61-967-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-967-3157328415+0",
          "name": "Front door",
          "deviceId": "59d505a0eea9e528ef444c61-46-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59ff426842d7e1248ab5c16b"
          ],
          "createdDate": "2019-04-25T15:21:14.149Z",
          "attributes": {
            "featureId": 967,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Front door"
          }
        },
        "59d505a0eea9e528ef444c61-385-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-385-3157328415+0",
          "name": "Hall lamp",
          "deviceId": "59d505a0eea9e528ef444c61-56-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a89b7abe6223d06ec2c6968"
          ],
          "createdDate": "2018-02-18T17:28:11.507Z",
          "attributes": {
            "featureId": 385,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Hall lamp"
          }
        },
        "59d505a0eea9e528ef444c61-386-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-386-3157328415+0",
          "name": "Hall lamp",
          "deviceId": "59d505a0eea9e528ef444c61-56-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a89b7abe6223d06ec2c6968"
          ],
          "createdDate": "2018-02-18T17:28:11.508Z",
          "attributes": {
            "featureId": 386,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Hall lamp"
          }
        },
        "59d505a0eea9e528ef444c61-387-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-387-3157328415+0",
          "name": "Hall lamp",
          "deviceId": "59d505a0eea9e528ef444c61-56-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a89b7abe6223d06ec2c6968"
          ],
          "createdDate": "2018-02-18T17:28:11.508Z",
          "attributes": {
            "featureId": 387,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Hall lamp"
          }
        },
        "59d505a0eea9e528ef444c61-987-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-987-3157328415+0",
          "name": "Hall lamp",
          "deviceId": "59d505a0eea9e528ef444c61-56-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a89b7abe6223d06ec2c6968"
          ],
          "createdDate": "2019-04-25T15:21:14.681Z",
          "attributes": {
            "featureId": 987,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Hall lamp"
          }
        },
        "59d505a0eea9e528ef444c61-541-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-541-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2018-07-01T14:53:17.949Z",
          "attributes": {
            "featureId": 541,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-542-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-542-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2018-07-01T14:53:17.949Z",
          "attributes": {
            "featureId": 542,
            "writable": false,
            "channel": 0,
            "type": "outletInUse",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-543-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-543-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2018-07-01T14:53:17.950Z",
          "attributes": {
            "featureId": 543,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-544-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-544-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2018-07-01T14:53:17.950Z",
          "attributes": {
            "featureId": 544,
            "writable": false,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-545-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-545-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2018-07-01T14:53:17.950Z",
          "attributes": {
            "featureId": 545,
            "writable": false,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-534-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-534-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.952Z",
          "attributes": {
            "featureId": 534,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-535-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-535-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.952Z",
          "attributes": {
            "featureId": 535,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-536-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-536-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.952Z",
          "attributes": {
            "featureId": 536,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-537-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-537-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.952Z",
          "attributes": {
            "featureId": 537,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-538-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-538-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.953Z",
          "attributes": {
            "featureId": 538,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-539-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-539-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.953Z",
          "attributes": {
            "featureId": 539,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-540-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-540-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2018-07-01T14:53:17.953Z",
          "attributes": {
            "featureId": 540,
            "writable": false,
            "channel": 0,
            "type": "voltage",
            "status": "init",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-1787-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1787-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2020-05-22T16:19:07.652Z",
          "attributes": {
            "featureId": 1787,
            "deviceId": 83,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-1788-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1788-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2020-05-22T16:19:07.653Z",
          "attributes": {
            "featureId": 1788,
            "deviceId": 83,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-1789-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1789-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2020-05-22T16:19:07.653Z",
          "attributes": {
            "featureId": 1789,
            "deviceId": 83,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-1790-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1790-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2020-05-22T16:19:07.653Z",
          "attributes": {
            "featureId": 1790,
            "deviceId": 83,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-1791-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1791-3157328415+0",
          "name": "Washing machine",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2"
          ],
          "createdDate": "2020-05-22T16:19:07.653Z",
          "attributes": {
            "featureId": 1791,
            "deviceId": 83,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Washing machine"
          }
        },
        "59d505a0eea9e528ef444c61-1792-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1792-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2020-05-22T16:19:07.654Z",
          "attributes": {
            "featureId": 1792,
            "deviceId": 83,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-1793-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1793-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2020-05-22T16:19:07.654Z",
          "attributes": {
            "featureId": 1793,
            "deviceId": 83,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-1794-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1794-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2020-05-22T16:19:07.654Z",
          "attributes": {
            "featureId": 1794,
            "deviceId": 83,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-1795-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1795-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2020-05-22T16:19:07.654Z",
          "attributes": {
            "featureId": 1795,
            "deviceId": 83,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-1796-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1796-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2020-05-22T16:19:07.654Z",
          "attributes": {
            "featureId": 1796,
            "deviceId": 83,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-546-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-546-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.951Z",
          "attributes": {
            "featureId": 546,
            "writable": true,
            "channel": 1,
            "type": "switch",
            "status": "init",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-547-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-547-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.951Z",
          "attributes": {
            "featureId": 547,
            "writable": false,
            "channel": 1,
            "type": "outletInUse",
            "status": "init",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-548-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-548-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.951Z",
          "attributes": {
            "featureId": 548,
            "writable": true,
            "channel": 1,
            "type": "protection",
            "status": "init",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-549-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-549-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.951Z",
          "attributes": {
            "featureId": 549,
            "writable": false,
            "channel": 1,
            "type": "power",
            "status": "init",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-550-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-550-3157328415+0",
          "name": "Washing machine 1",
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "createdDate": "2018-07-01T14:53:17.951Z",
          "attributes": {
            "featureId": 550,
            "writable": false,
            "channel": 1,
            "type": "energy",
            "status": "init",
            "name": "Washing machine 1"
          }
        },
        "59d505a0eea9e528ef444c61-777-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-777-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.564Z",
          "attributes": {
            "featureId": 777,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-778-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-778-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.565Z",
          "attributes": {
            "featureId": 778,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-779-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-779-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.565Z",
          "attributes": {
            "featureId": 779,
            "writable": true,
            "channel": 0,
            "type": "dimSetup",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-780-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-780-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.565Z",
          "attributes": {
            "featureId": 780,
            "writable": true,
            "channel": 0,
            "type": "bulbSetup",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-781-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-781-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.565Z",
          "attributes": {
            "featureId": 781,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-782-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-782-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.566Z",
          "attributes": {
            "featureId": 782,
            "writable": true,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-783-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-783-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2019-02-07T09:41:55.566Z",
          "attributes": {
            "featureId": 783,
            "writable": true,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-771-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-771-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.568Z",
          "attributes": {
            "featureId": 771,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-772-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-772-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.568Z",
          "attributes": {
            "featureId": 772,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-773-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-773-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.568Z",
          "attributes": {
            "featureId": 773,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-774-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-774-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.569Z",
          "attributes": {
            "featureId": 774,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-775-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-775-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.569Z",
          "attributes": {
            "featureId": 775,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-776-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-776-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.569Z",
          "attributes": {
            "featureId": 776,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3090-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3090-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.452Z",
          "attributes": {
            "featureId": 3090,
            "deviceId": 108,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3091-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3091-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2021-03-29T16:04:30.452Z",
          "attributes": {
            "featureId": 3091,
            "deviceId": 108,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3092-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3092-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2021-03-29T16:04:30.452Z",
          "attributes": {
            "featureId": 3092,
            "deviceId": 108,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3093-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3093-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2021-03-29T16:04:30.452Z",
          "attributes": {
            "featureId": 3093,
            "deviceId": 108,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3094-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3094-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2021-03-29T16:04:30.453Z",
          "attributes": {
            "featureId": 3094,
            "deviceId": 108,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3095-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3095-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2021-03-29T16:04:30.453Z",
          "attributes": {
            "featureId": 3095,
            "deviceId": 108,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3096-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3096-3157328415+0",
          "name": "Porch",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3"
          ],
          "createdDate": "2021-03-29T16:04:30.453Z",
          "attributes": {
            "featureId": 3096,
            "deviceId": 108,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Porch"
          }
        },
        "59d505a0eea9e528ef444c61-3097-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3097-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.453Z",
          "attributes": {
            "featureId": 3097,
            "deviceId": 108,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-3098-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3098-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.453Z",
          "attributes": {
            "featureId": 3098,
            "deviceId": 108,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-3099-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3099-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.453Z",
          "attributes": {
            "featureId": 3099,
            "deviceId": 108,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-3100-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3100-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.454Z",
          "attributes": {
            "featureId": 3100,
            "deviceId": 108,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-3101-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3101-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.454Z",
          "attributes": {
            "featureId": 3101,
            "deviceId": 108,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-3102-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3102-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2021-03-29T16:04:30.454Z",
          "attributes": {
            "featureId": 3102,
            "deviceId": 108,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-784-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-784-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.566Z",
          "attributes": {
            "featureId": 784,
            "writable": true,
            "channel": 1,
            "type": "switch",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-785-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-785-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.567Z",
          "attributes": {
            "featureId": 785,
            "writable": true,
            "channel": 1,
            "type": "dimLevel",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-786-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-786-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.567Z",
          "attributes": {
            "featureId": 786,
            "writable": true,
            "channel": 1,
            "type": "dimSetup",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-787-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-787-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.567Z",
          "attributes": {
            "featureId": 787,
            "writable": true,
            "channel": 1,
            "type": "bulbSetup",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-788-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-788-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.567Z",
          "attributes": {
            "featureId": 788,
            "writable": true,
            "channel": 1,
            "type": "protection",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-789-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-789-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.567Z",
          "attributes": {
            "featureId": 789,
            "writable": true,
            "channel": 1,
            "type": "power",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-790-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-790-3157328415+0",
          "name": "Porch 1",
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "createdDate": "2019-02-07T09:41:55.568Z",
          "attributes": {
            "featureId": 790,
            "writable": true,
            "channel": 1,
            "type": "energy",
            "status": "init",
            "name": "Porch 1"
          }
        },
        "59d505a0eea9e528ef444c61-1179-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1179-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.083Z",
          "attributes": {
            "featureId": 1179,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1180-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1180-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.083Z",
          "attributes": {
            "featureId": 1180,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1181-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1181-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.084Z",
          "attributes": {
            "featureId": 1181,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1182-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1182-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.085Z",
          "attributes": {
            "featureId": 1182,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1183-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1183-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.085Z",
          "attributes": {
            "featureId": 1183,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1184-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1184-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.086Z",
          "attributes": {
            "featureId": 1184,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1185-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1185-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.086Z",
          "attributes": {
            "featureId": 1185,
            "writable": true,
            "channel": 0,
            "type": "voltage",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1186-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1186-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.087Z",
          "attributes": {
            "featureId": 1186,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1187-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1187-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.087Z",
          "attributes": {
            "featureId": 1187,
            "writable": true,
            "channel": 0,
            "type": "socketSetup",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1188-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1188-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.087Z",
          "attributes": {
            "featureId": 1188,
            "writable": false,
            "channel": 0,
            "type": "outletInUse",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1189-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1189-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.088Z",
          "attributes": {
            "featureId": 1189,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1190-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1190-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.088Z",
          "attributes": {
            "featureId": 1190,
            "writable": true,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1191-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1191-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2019-07-10T18:05:07.088Z",
          "attributes": {
            "featureId": 1191,
            "writable": true,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1807-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1807-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2020-05-22T16:19:10.198Z",
          "attributes": {
            "featureId": 1807,
            "deviceId": 141,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "ok",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1808-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1808-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2020-05-22T16:19:10.199Z",
          "attributes": {
            "featureId": 1808,
            "deviceId": 141,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1809-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1809-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2020-05-22T16:19:10.199Z",
          "attributes": {
            "featureId": 1809,
            "deviceId": 141,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-1810-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1810-3157328415+0",
          "name": "Landing skt",
          "deviceId": "59d505a0eea9e528ef444c61-141-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d2628d3b6c35d33e7bfee48"
          ],
          "createdDate": "2020-05-22T16:19:10.199Z",
          "attributes": {
            "featureId": 1810,
            "deviceId": 141,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "ok",
            "name": "Landing skt"
          }
        },
        "59d505a0eea9e528ef444c61-3846-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3846-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.669Z",
          "attributes": {
            "featureId": 3846,
            "deviceId": 304,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3847-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3847-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.670Z",
          "attributes": {
            "featureId": 3847,
            "deviceId": 304,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3848-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3848-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.671Z",
          "attributes": {
            "featureId": 3848,
            "deviceId": 304,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3849-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3849-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.671Z",
          "attributes": {
            "featureId": 3849,
            "deviceId": 304,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3850-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3850-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.671Z",
          "attributes": {
            "featureId": 3850,
            "deviceId": 304,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3851-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3851-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.671Z",
          "attributes": {
            "featureId": 3851,
            "deviceId": 304,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3852-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3852-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.672Z",
          "attributes": {
            "featureId": 3852,
            "deviceId": 304,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3853-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3853-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.672Z",
          "attributes": {
            "featureId": 3853,
            "deviceId": 304,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3854-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3854-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.672Z",
          "attributes": {
            "featureId": 3854,
            "deviceId": 304,
            "type": "dimSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3855-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3855-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.673Z",
          "attributes": {
            "featureId": 3855,
            "deviceId": 304,
            "type": "bulbSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3856-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3856-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.673Z",
          "attributes": {
            "featureId": 3856,
            "deviceId": 304,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3857-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3857-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.673Z",
          "attributes": {
            "featureId": 3857,
            "deviceId": 304,
            "type": "power",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3858-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3858-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:06:43.674Z",
          "attributes": {
            "featureId": 3858,
            "deviceId": 304,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3859-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3859-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.607Z",
          "attributes": {
            "featureId": 3859,
            "deviceId": 304,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3860-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3860-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.607Z",
          "attributes": {
            "featureId": 3860,
            "deviceId": 304,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3861-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3861-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.607Z",
          "attributes": {
            "featureId": 3861,
            "deviceId": 304,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3862-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3862-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.608Z",
          "attributes": {
            "featureId": 3862,
            "deviceId": 304,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3863-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3863-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.608Z",
          "attributes": {
            "featureId": 3863,
            "deviceId": 304,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3864-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3864-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.608Z",
          "attributes": {
            "featureId": 3864,
            "deviceId": 304,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-3865-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3865-3157328415+0",
          "name": "Downstairs light",
          "deviceId": "59d505a0eea9e528ef444c61-304-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-617e6ab35ed96e5badb63ffb"
          ],
          "createdDate": "2021-10-31T10:13:49.608Z",
          "attributes": {
            "featureId": 3865,
            "deviceId": 304,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Downstairs light"
          }
        },
        "59d505a0eea9e528ef444c61-4463-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4463-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.705Z",
          "attributes": {
            "featureId": 4463,
            "deviceId": 341,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4464-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4464-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.705Z",
          "attributes": {
            "featureId": 4464,
            "deviceId": 341,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4465-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4465-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.706Z",
          "attributes": {
            "featureId": 4465,
            "deviceId": 341,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4466-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4466-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.706Z",
          "attributes": {
            "featureId": 4466,
            "deviceId": 341,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4467-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4467-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.706Z",
          "attributes": {
            "featureId": 4467,
            "deviceId": 341,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4468-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4468-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.707Z",
          "attributes": {
            "featureId": 4468,
            "deviceId": 341,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4469-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4469-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.707Z",
          "attributes": {
            "featureId": 4469,
            "deviceId": 341,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4470-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4470-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.707Z",
          "attributes": {
            "featureId": 4470,
            "deviceId": 341,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4471-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4471-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.707Z",
          "attributes": {
            "featureId": 4471,
            "deviceId": 341,
            "type": "dimSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4472-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4472-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.708Z",
          "attributes": {
            "featureId": 4472,
            "deviceId": 341,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4473-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4473-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.708Z",
          "attributes": {
            "featureId": 4473,
            "deviceId": 341,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4474-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4474-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:09:30.708Z",
          "attributes": {
            "featureId": 4474,
            "deviceId": 341,
            "type": "energy",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4475-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4475-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:20:12.995Z",
          "attributes": {
            "featureId": 4475,
            "deviceId": 341,
            "type": "bulbSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4476-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4476-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.146Z",
          "attributes": {
            "featureId": 4476,
            "deviceId": 341,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4477-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4477-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.146Z",
          "attributes": {
            "featureId": 4477,
            "deviceId": 341,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4478-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4478-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.147Z",
          "attributes": {
            "featureId": 4478,
            "deviceId": 341,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4479-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4479-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.147Z",
          "attributes": {
            "featureId": 4479,
            "deviceId": 341,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4480-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4480-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.147Z",
          "attributes": {
            "featureId": 4480,
            "deviceId": 341,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4481-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4481-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.147Z",
          "attributes": {
            "featureId": 4481,
            "deviceId": 341,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-4482-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4482-3157328415+0",
          "name": "Landing light",
          "deviceId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-623affea59b51614b16ccc9c"
          ],
          "createdDate": "2022-03-23T11:26:43.148Z",
          "attributes": {
            "featureId": 4482,
            "deviceId": 341,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Landing light"
          }
        },
        "59d505a0eea9e528ef444c61-332-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "name": "Back door",
          "deviceId": "59d505a0eea9e528ef444c61-45-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59fc14467357bd3cf6ff91ea"
          ],
          "createdDate": "2017-11-03T07:01:26.349Z",
          "attributes": {
            "featureId": 332,
            "writable": false,
            "channel": 0,
            "type": "windowPosition",
            "name": "Back door"
          }
        },
        "59d505a0eea9e528ef444c61-333-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-333-3157328415+0",
          "name": "Back door",
          "deviceId": "59d505a0eea9e528ef444c61-45-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59fc14467357bd3cf6ff91ea"
          ],
          "createdDate": "2017-11-03T07:01:26.350Z",
          "attributes": {
            "featureId": 333,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "name": "Back door"
          }
        },
        "59d505a0eea9e528ef444c61-334-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-334-3157328415+0",
          "name": "Back door",
          "deviceId": "59d505a0eea9e528ef444c61-45-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59fc14467357bd3cf6ff91ea"
          ],
          "createdDate": "2017-11-03T07:01:26.350Z",
          "attributes": {
            "featureId": 334,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "name": "Back door"
          }
        },
        "59d505a0eea9e528ef444c61-966-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-966-3157328415+0",
          "name": "Back door",
          "deviceId": "59d505a0eea9e528ef444c61-45-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59fc14467357bd3cf6ff91ea"
          ],
          "createdDate": "2019-04-25T15:21:11.767Z",
          "attributes": {
            "featureId": 966,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Back door"
          }
        },
        "59d505a0eea9e528ef444c61-1231-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1231-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2019-09-13T17:05:04.339Z",
          "attributes": {
            "featureId": 1231,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Under floor"
          }
        },
        "59d505a0eea9e528ef444c61-341-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-341-3157328415+0",
          "name": "Under floor 1",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2017-12-22T02:36:28.589Z",
          "attributes": {
            "name": "Under floor 1",
            "status": "init",
            "type": "temperature",
            "channel": 1,
            "writable": false,
            "featureId": 341
          }
        },
        "59d505a0eea9e528ef444c61-342-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "name": "Under floor 1",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2017-12-22T02:36:28.589Z",
          "attributes": {
            "name": "Under floor 1",
            "status": "init",
            "type": "targetTemperature",
            "channel": 1,
            "writable": false,
            "featureId": 342
          }
        },
        "59d505a0eea9e528ef444c61-343-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2017-12-22T02:36:28.590Z",
          "attributes": {
            "name": "Under floor",
            "status": "init",
            "type": "valveLevel",
            "channel": 0,
            "writable": true,
            "featureId": 343
          }
        },
        "59d505a0eea9e528ef444c61-344-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2017-12-22T02:36:28.590Z",
          "attributes": {
            "name": "Under floor",
            "status": "init",
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "featureId": 344
          }
        },
        "59d505a0eea9e528ef444c61-345-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2017-12-22T02:36:28.590Z",
          "attributes": {
            "name": "Under floor",
            "status": "init",
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "featureId": 345
          }
        },
        "59d505a0eea9e528ef444c61-346-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-346-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2017-12-22T02:36:28.591Z",
          "attributes": {
            "name": "Under floor",
            "status": "init",
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "featureId": 346
          }
        },
        "59d505a0eea9e528ef444c61-406-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-406-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2018-04-17T16:28:23.115Z",
          "attributes": {
            "featureId": 406,
            "writable": false,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Under floor"
          }
        },
        "59d505a0eea9e528ef444c61-968-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-968-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c",
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250d"
          ],
          "createdDate": "2019-04-25T15:21:11.679Z",
          "attributes": {
            "featureId": 968,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Under floor"
          }
        },
        "59d505a0eea9e528ef444c61-927-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-927-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.211Z",
          "attributes": {
            "featureId": 927,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-928-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-928-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.211Z",
          "attributes": {
            "featureId": 928,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-929-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-929-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.212Z",
          "attributes": {
            "featureId": 929,
            "writable": true,
            "channel": 0,
            "type": "dimSetup",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-930-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-930-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.212Z",
          "attributes": {
            "featureId": 930,
            "writable": true,
            "channel": 0,
            "type": "bulbSetup",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-931-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-931-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.212Z",
          "attributes": {
            "featureId": 931,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-932-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-932-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.212Z",
          "attributes": {
            "featureId": 932,
            "writable": true,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-933-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-933-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2019-03-05T07:58:17.213Z",
          "attributes": {
            "featureId": 933,
            "writable": true,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-921-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-921-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.218Z",
          "attributes": {
            "featureId": 921,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-922-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-922-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.218Z",
          "attributes": {
            "featureId": 922,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-923-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-923-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.218Z",
          "attributes": {
            "featureId": 923,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-924-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-924-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.219Z",
          "attributes": {
            "featureId": 924,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-925-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-925-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.219Z",
          "attributes": {
            "featureId": 925,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-926-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-926-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.219Z",
          "attributes": {
            "featureId": 926,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2985-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2985-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601",
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.391Z",
          "attributes": {
            "featureId": 2985,
            "deviceId": 116,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2986-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2986-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2021-03-26T15:49:28.396Z",
          "attributes": {
            "featureId": 2986,
            "deviceId": 116,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2987-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2987-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2021-03-26T15:49:28.396Z",
          "attributes": {
            "featureId": 2987,
            "deviceId": 116,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2988-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2988-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2021-03-26T15:49:28.398Z",
          "attributes": {
            "featureId": 2988,
            "deviceId": 116,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2989-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2989-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2021-03-26T15:49:28.398Z",
          "attributes": {
            "featureId": 2989,
            "deviceId": 116,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2990-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2990-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2021-03-26T15:49:28.399Z",
          "attributes": {
            "featureId": 2990,
            "deviceId": 116,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2991-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2991-3157328415+0",
          "name": "4 gang",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb155ff"
          ],
          "createdDate": "2021-03-26T15:49:28.400Z",
          "attributes": {
            "featureId": 2991,
            "deviceId": 116,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang"
          }
        },
        "59d505a0eea9e528ef444c61-2992-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2992-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2021-03-26T15:49:28.400Z",
          "attributes": {
            "featureId": 2992,
            "deviceId": 116,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-2993-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2993-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2021-03-26T15:49:28.402Z",
          "attributes": {
            "featureId": 2993,
            "deviceId": 116,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-2994-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2994-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2021-03-26T15:49:28.403Z",
          "attributes": {
            "featureId": 2994,
            "deviceId": 116,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-2995-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2995-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2021-03-26T15:49:28.403Z",
          "attributes": {
            "featureId": 2995,
            "deviceId": 116,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-2996-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2996-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2021-03-26T15:49:28.404Z",
          "attributes": {
            "featureId": 2996,
            "deviceId": 116,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-2997-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2997-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2021-03-26T15:49:28.405Z",
          "attributes": {
            "featureId": 2997,
            "deviceId": 116,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-934-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-934-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.213Z",
          "attributes": {
            "featureId": 934,
            "writable": true,
            "channel": 1,
            "type": "switch",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-935-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-935-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.213Z",
          "attributes": {
            "featureId": 935,
            "writable": true,
            "channel": 1,
            "type": "dimLevel",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-936-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-936-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.214Z",
          "attributes": {
            "featureId": 936,
            "writable": true,
            "channel": 1,
            "type": "dimSetup",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-937-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-937-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.214Z",
          "attributes": {
            "featureId": 937,
            "writable": true,
            "channel": 1,
            "type": "bulbSetup",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-938-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-938-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.214Z",
          "attributes": {
            "featureId": 938,
            "writable": true,
            "channel": 1,
            "type": "protection",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-939-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-939-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.214Z",
          "attributes": {
            "featureId": 939,
            "writable": true,
            "channel": 1,
            "type": "power",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-940-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-940-3157328415+0",
          "name": "4 gang 1",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15600"
          ],
          "createdDate": "2019-03-05T07:58:17.214Z",
          "attributes": {
            "featureId": 940,
            "writable": true,
            "channel": 1,
            "type": "energy",
            "status": "init",
            "name": "4 gang 1"
          }
        },
        "59d505a0eea9e528ef444c61-2998-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2998-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2021-03-26T15:49:28.406Z",
          "attributes": {
            "featureId": 2998,
            "deviceId": 116,
            "type": "dimProfileCurve",
            "channel": 2,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-2999-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2999-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2021-03-26T15:49:28.406Z",
          "attributes": {
            "featureId": 2999,
            "deviceId": 116,
            "type": "dimProfileTimebase",
            "channel": 2,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-3000-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3000-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2021-03-26T15:49:28.407Z",
          "attributes": {
            "featureId": 3000,
            "deviceId": 116,
            "type": "uiButton",
            "channel": 2,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-3001-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3001-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2021-03-26T15:49:28.407Z",
          "attributes": {
            "featureId": 3001,
            "deviceId": 116,
            "type": "uiButtonPair",
            "channel": 2,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-3002-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3002-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2021-03-26T15:49:28.409Z",
          "attributes": {
            "featureId": 3002,
            "deviceId": 116,
            "type": "uiIndicator",
            "channel": 2,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-3003-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3003-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2021-03-26T15:49:28.409Z",
          "attributes": {
            "featureId": 3003,
            "deviceId": 116,
            "type": "uiIOMap",
            "channel": 2,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-941-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-941-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.215Z",
          "attributes": {
            "featureId": 941,
            "writable": true,
            "channel": 2,
            "type": "switch",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-942-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-942-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.215Z",
          "attributes": {
            "featureId": 942,
            "writable": true,
            "channel": 2,
            "type": "dimLevel",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-943-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-943-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.215Z",
          "attributes": {
            "featureId": 943,
            "writable": true,
            "channel": 2,
            "type": "dimSetup",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-944-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-944-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.215Z",
          "attributes": {
            "featureId": 944,
            "writable": true,
            "channel": 2,
            "type": "bulbSetup",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-945-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-945-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.216Z",
          "attributes": {
            "featureId": 945,
            "writable": true,
            "channel": 2,
            "type": "protection",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-946-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-946-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.216Z",
          "attributes": {
            "featureId": 946,
            "writable": false,
            "channel": 2,
            "type": "power",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-947-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-947-3157328415+0",
          "name": "4 gang 2",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15601"
          ],
          "createdDate": "2019-03-05T07:58:17.216Z",
          "attributes": {
            "featureId": 947,
            "writable": false,
            "channel": 2,
            "type": "energy",
            "status": "init",
            "name": "4 gang 2"
          }
        },
        "59d505a0eea9e528ef444c61-3004-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3004-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.410Z",
          "attributes": {
            "featureId": 3004,
            "deviceId": 116,
            "type": "dimProfileCurve",
            "channel": 3,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-3005-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3005-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.411Z",
          "attributes": {
            "featureId": 3005,
            "deviceId": 116,
            "type": "dimProfileTimebase",
            "channel": 3,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-3006-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3006-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.411Z",
          "attributes": {
            "featureId": 3006,
            "deviceId": 116,
            "type": "uiButton",
            "channel": 3,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-3007-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3007-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.412Z",
          "attributes": {
            "featureId": 3007,
            "deviceId": 116,
            "type": "uiButtonPair",
            "channel": 3,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-3008-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3008-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.413Z",
          "attributes": {
            "featureId": 3008,
            "deviceId": 116,
            "type": "uiIndicator",
            "channel": 3,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-3009-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3009-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2021-03-26T15:49:28.413Z",
          "attributes": {
            "featureId": 3009,
            "deviceId": 116,
            "type": "uiIOMap",
            "channel": 3,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-948-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-948-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.216Z",
          "attributes": {
            "featureId": 948,
            "writable": true,
            "channel": 3,
            "type": "switch",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-949-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-949-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.217Z",
          "attributes": {
            "featureId": 949,
            "writable": true,
            "channel": 3,
            "type": "dimLevel",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-950-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-950-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.217Z",
          "attributes": {
            "featureId": 950,
            "writable": true,
            "channel": 3,
            "type": "dimSetup",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-951-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-951-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.217Z",
          "attributes": {
            "featureId": 951,
            "writable": true,
            "channel": 3,
            "type": "bulbSetup",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-952-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-952-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.217Z",
          "attributes": {
            "featureId": 952,
            "writable": true,
            "channel": 3,
            "type": "protection",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-953-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-953-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.217Z",
          "attributes": {
            "featureId": 953,
            "writable": false,
            "channel": 3,
            "type": "power",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-954-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-954-3157328415+0",
          "name": "4 gang 3",
          "deviceId": "59d505a0eea9e528ef444c61-116-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c7e2c193c570522afb15602"
          ],
          "createdDate": "2019-03-05T07:58:17.218Z",
          "attributes": {
            "featureId": 954,
            "writable": false,
            "channel": 3,
            "type": "energy",
            "status": "init",
            "name": "4 gang 3"
          }
        },
        "59d505a0eea9e528ef444c61-1488-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1488-3157328415+0",
          "name": "Basket",
          "deviceId": "59d505a0eea9e528ef444c61-180-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5de3cad0f17977021c5855ce"
          ],
          "createdDate": "2019-12-01T14:14:40.404Z",
          "attributes": {
            "featureId": 1488,
            "deviceId": 180,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Basket"
          }
        },
        "59d505a0eea9e528ef444c61-1489-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1489-3157328415+0",
          "name": "Basket",
          "deviceId": "59d505a0eea9e528ef444c61-180-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5de3cad0f17977021c5855ce"
          ],
          "createdDate": "2019-12-01T14:14:40.405Z",
          "attributes": {
            "featureId": 1489,
            "deviceId": 180,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Basket"
          }
        },
        "59d505a0eea9e528ef444c61-1490-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1490-3157328415+0",
          "name": "Basket",
          "deviceId": "59d505a0eea9e528ef444c61-180-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5de3cad0f17977021c5855ce"
          ],
          "createdDate": "2019-12-01T14:14:40.405Z",
          "attributes": {
            "featureId": 1490,
            "deviceId": 180,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Basket"
          }
        },
        "59d505a0eea9e528ef444c61-1852-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1852-3157328415+0",
          "name": "Shed power",
          "deviceId": "59d505a0eea9e528ef444c61-199-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f37ab3df20e750df0097f28"
          ],
          "createdDate": "2020-08-15T09:30:37.577Z",
          "attributes": {
            "featureId": 1852,
            "deviceId": 199,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Shed power"
          }
        },
        "59d505a0eea9e528ef444c61-1853-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1853-3157328415+0",
          "name": "Shed power",
          "deviceId": "59d505a0eea9e528ef444c61-199-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f37ab3df20e750df0097f28"
          ],
          "createdDate": "2020-08-15T09:30:37.577Z",
          "attributes": {
            "featureId": 1853,
            "deviceId": 199,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Shed power"
          }
        },
        "59d505a0eea9e528ef444c61-1854-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1854-3157328415+0",
          "name": "Shed power",
          "deviceId": "59d505a0eea9e528ef444c61-199-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f37ab3df20e750df0097f28"
          ],
          "createdDate": "2020-08-15T09:30:37.578Z",
          "attributes": {
            "featureId": 1854,
            "deviceId": 199,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Shed power"
          }
        },
        "59d505a0eea9e528ef444c61-2109-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2109-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.927Z",
          "attributes": {
            "featureId": 2109,
            "deviceId": 223,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2110-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2110-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.927Z",
          "attributes": {
            "featureId": 2110,
            "deviceId": 223,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2111-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2111-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.927Z",
          "attributes": {
            "featureId": 2111,
            "deviceId": 223,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2112-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2112-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.927Z",
          "attributes": {
            "featureId": 2112,
            "deviceId": 223,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2113-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2113-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.928Z",
          "attributes": {
            "featureId": 2113,
            "deviceId": 223,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2114-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2114-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.928Z",
          "attributes": {
            "featureId": 2114,
            "deviceId": 223,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2115-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2115-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.928Z",
          "attributes": {
            "featureId": 2115,
            "deviceId": 223,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2116-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2116-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.928Z",
          "attributes": {
            "featureId": 2116,
            "deviceId": 223,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2117-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2117-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.928Z",
          "attributes": {
            "featureId": 2117,
            "deviceId": 223,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2118-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2118-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2"
          ],
          "createdDate": "2020-10-28T18:24:30.928Z",
          "attributes": {
            "featureId": 2118,
            "deviceId": 223,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2102-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2102-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.930Z",
          "attributes": {
            "featureId": 2102,
            "deviceId": 223,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2103-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2103-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.932Z",
          "attributes": {
            "featureId": 2103,
            "deviceId": 223,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2104-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2104-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.932Z",
          "attributes": {
            "featureId": 2104,
            "deviceId": 223,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2105-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2105-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.932Z",
          "attributes": {
            "featureId": 2105,
            "deviceId": 223,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2106-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2106-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.933Z",
          "attributes": {
            "featureId": 2106,
            "deviceId": 223,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2107-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2107-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.933Z",
          "attributes": {
            "featureId": 2107,
            "deviceId": 223,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2108-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2108-3157328415+0",
          "name": "F 3",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.933Z",
          "attributes": {
            "featureId": 2108,
            "deviceId": 223,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3"
          }
        },
        "59d505a0eea9e528ef444c61-2119-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2119-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.929Z",
          "attributes": {
            "featureId": 2119,
            "deviceId": 223,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2120-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2120-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.929Z",
          "attributes": {
            "featureId": 2120,
            "deviceId": 223,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2121-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2121-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.929Z",
          "attributes": {
            "featureId": 2121,
            "deviceId": 223,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2122-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2122-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.929Z",
          "attributes": {
            "featureId": 2122,
            "deviceId": 223,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2123-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2123-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.929Z",
          "attributes": {
            "featureId": 2123,
            "deviceId": 223,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2124-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2124-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.929Z",
          "attributes": {
            "featureId": 2124,
            "deviceId": 223,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2125-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2125-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.930Z",
          "attributes": {
            "featureId": 2125,
            "deviceId": 223,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2126-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2126-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.930Z",
          "attributes": {
            "featureId": 2126,
            "deviceId": 223,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2127-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2127-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.930Z",
          "attributes": {
            "featureId": 2127,
            "deviceId": 223,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2128-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2128-3157328415+0",
          "name": "F 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "createdDate": "2020-10-28T18:24:30.930Z",
          "attributes": {
            "featureId": 2128,
            "deviceId": 223,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "F 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-2610-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2610-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.646Z",
          "attributes": {
            "featureId": 2610,
            "deviceId": 247,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2611-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2611-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.647Z",
          "attributes": {
            "featureId": 2611,
            "deviceId": 247,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2612-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2612-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.647Z",
          "attributes": {
            "featureId": 2612,
            "deviceId": 247,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2613-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2613-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.647Z",
          "attributes": {
            "featureId": 2613,
            "deviceId": 247,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2614-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2614-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.648Z",
          "attributes": {
            "featureId": 2614,
            "deviceId": 247,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2615-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2615-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.648Z",
          "attributes": {
            "featureId": 2615,
            "deviceId": 247,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2616-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2616-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.649Z",
          "attributes": {
            "featureId": 2616,
            "deviceId": 247,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2617-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2617-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.649Z",
          "attributes": {
            "featureId": 2617,
            "deviceId": 247,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2618-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2618-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.649Z",
          "attributes": {
            "featureId": 2618,
            "deviceId": 247,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2619-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2619-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257"
          ],
          "createdDate": "2021-02-10T15:14:01.649Z",
          "attributes": {
            "featureId": 2619,
            "deviceId": 247,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2603-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2603-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.652Z",
          "attributes": {
            "featureId": 2603,
            "deviceId": 247,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2604-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2604-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.652Z",
          "attributes": {
            "featureId": 2604,
            "deviceId": 247,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2605-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2605-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.652Z",
          "attributes": {
            "featureId": 2605,
            "deviceId": 247,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2606-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2606-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.653Z",
          "attributes": {
            "featureId": 2606,
            "deviceId": 247,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2607-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2607-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.653Z",
          "attributes": {
            "featureId": 2607,
            "deviceId": 247,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2608-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2608-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.653Z",
          "attributes": {
            "featureId": 2608,
            "deviceId": 247,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2609-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2609-3157328415+0",
          "name": "Door skt",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b257",
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.653Z",
          "attributes": {
            "featureId": 2609,
            "deviceId": 247,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt"
          }
        },
        "59d505a0eea9e528ef444c61-2620-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2620-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.650Z",
          "attributes": {
            "featureId": 2620,
            "deviceId": 247,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2621-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2621-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.650Z",
          "attributes": {
            "featureId": 2621,
            "deviceId": 247,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2622-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2622-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.651Z",
          "attributes": {
            "featureId": 2622,
            "deviceId": 247,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2623-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2623-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.651Z",
          "attributes": {
            "featureId": 2623,
            "deviceId": 247,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2624-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2624-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.651Z",
          "attributes": {
            "featureId": 2624,
            "deviceId": 247,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2625-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2625-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.651Z",
          "attributes": {
            "featureId": 2625,
            "deviceId": 247,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2626-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2626-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.651Z",
          "attributes": {
            "featureId": 2626,
            "deviceId": 247,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2627-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2627-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.651Z",
          "attributes": {
            "featureId": 2627,
            "deviceId": 247,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2628-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2628-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.652Z",
          "attributes": {
            "featureId": 2628,
            "deviceId": 247,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-2629-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2629-3157328415+0",
          "name": "Door skt 1",
          "deviceId": "59d505a0eea9e528ef444c61-247-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6023f839f37c8475c9a9b258"
          ],
          "createdDate": "2021-02-10T15:14:01.652Z",
          "attributes": {
            "featureId": 2629,
            "deviceId": 247,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Door skt 1"
          }
        },
        "59d505a0eea9e528ef444c61-3791-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3791-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:26:24.122Z",
          "attributes": {
            "featureId": 3791,
            "deviceId": 299,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3792-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3792-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:26:24.123Z",
          "attributes": {
            "featureId": 3792,
            "deviceId": 299,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3793-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3793-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:26:24.124Z",
          "attributes": {
            "featureId": 3793,
            "deviceId": 299,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3794-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3794-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:26:24.124Z",
          "attributes": {
            "featureId": 3794,
            "deviceId": 299,
            "type": "power",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3795-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3795-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:26:24.125Z",
          "attributes": {
            "featureId": 3795,
            "deviceId": 299,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3784-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3784-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.129Z",
          "attributes": {
            "featureId": 3784,
            "deviceId": 299,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3785-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3785-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.129Z",
          "attributes": {
            "featureId": 3785,
            "deviceId": 299,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3786-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3786-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.130Z",
          "attributes": {
            "featureId": 3786,
            "deviceId": 299,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3787-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3787-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.130Z",
          "attributes": {
            "featureId": 3787,
            "deviceId": 299,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3788-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3788-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.131Z",
          "attributes": {
            "featureId": 3788,
            "deviceId": 299,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3789-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3789-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.131Z",
          "attributes": {
            "featureId": 3789,
            "deviceId": 299,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3790-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3790-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:26:24.131Z",
          "attributes": {
            "featureId": 3790,
            "deviceId": 299,
            "type": "voltage",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3801-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3801-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1",
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:31:09.236Z",
          "attributes": {
            "featureId": 3801,
            "deviceId": 299,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3802-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3802-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:31:09.237Z",
          "attributes": {
            "featureId": 3802,
            "deviceId": 299,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3803-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3803-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:31:09.237Z",
          "attributes": {
            "featureId": 3803,
            "deviceId": 299,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3804-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3804-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:31:09.238Z",
          "attributes": {
            "featureId": 3804,
            "deviceId": 299,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3805-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3805-3157328415+0",
          "name": "Ty",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a1"
          ],
          "createdDate": "2021-09-23T09:31:09.238Z",
          "attributes": {
            "featureId": 3805,
            "deviceId": 299,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Ty"
          }
        },
        "59d505a0eea9e528ef444c61-3796-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3796-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.126Z",
          "attributes": {
            "featureId": 3796,
            "deviceId": 299,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3797-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3797-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.127Z",
          "attributes": {
            "featureId": 3797,
            "deviceId": 299,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3798-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3798-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.127Z",
          "attributes": {
            "featureId": 3798,
            "deviceId": 299,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3799-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3799-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.128Z",
          "attributes": {
            "featureId": 3799,
            "deviceId": 299,
            "type": "power",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3800-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3800-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:26:24.128Z",
          "attributes": {
            "featureId": 3800,
            "deviceId": 299,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3806-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3806-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:31:09.238Z",
          "attributes": {
            "featureId": 3806,
            "deviceId": 299,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3807-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3807-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:31:09.239Z",
          "attributes": {
            "featureId": 3807,
            "deviceId": 299,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3808-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3808-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:31:09.239Z",
          "attributes": {
            "featureId": 3808,
            "deviceId": 299,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3809-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3809-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:31:09.239Z",
          "attributes": {
            "featureId": 3809,
            "deviceId": 299,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-3810-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3810-3157328415+0",
          "name": "Ty 1",
          "deviceId": "59d505a0eea9e528ef444c61-299-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614c4840dfe4df1499e110a2"
          ],
          "createdDate": "2021-09-23T09:31:09.240Z",
          "attributes": {
            "featureId": 3810,
            "deviceId": 299,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Ty 1"
          }
        },
        "59d505a0eea9e528ef444c61-4362-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4362-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T11:10:37.321Z",
          "attributes": {
            "featureId": 4362,
            "deviceId": 332,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4363-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4363-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T11:10:37.322Z",
          "attributes": {
            "featureId": 4363,
            "deviceId": 332,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4364-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4364-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T11:10:37.322Z",
          "attributes": {
            "featureId": 4364,
            "deviceId": 332,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4365-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4365-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T11:10:37.323Z",
          "attributes": {
            "featureId": 4365,
            "deviceId": 332,
            "type": "power",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4366-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4366-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T11:10:37.323Z",
          "attributes": {
            "featureId": 4366,
            "deviceId": 332,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4355-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4355-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.325Z",
          "attributes": {
            "featureId": 4355,
            "deviceId": 332,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4356-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4356-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.326Z",
          "attributes": {
            "featureId": 4356,
            "deviceId": 332,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4357-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4357-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.326Z",
          "attributes": {
            "featureId": 4357,
            "deviceId": 332,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4358-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4358-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.326Z",
          "attributes": {
            "featureId": 4358,
            "deviceId": 332,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4359-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4359-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.327Z",
          "attributes": {
            "featureId": 4359,
            "deviceId": 332,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4360-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4360-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.327Z",
          "attributes": {
            "featureId": 4360,
            "deviceId": 332,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4361-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4361-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T11:10:37.328Z",
          "attributes": {
            "featureId": 4361,
            "deviceId": 332,
            "type": "voltage",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4372-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4372-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2",
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T13:57:09.245Z",
          "attributes": {
            "featureId": 4372,
            "deviceId": 332,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4373-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4373-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T13:57:09.246Z",
          "attributes": {
            "featureId": 4373,
            "deviceId": 332,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4374-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4374-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T13:57:09.246Z",
          "attributes": {
            "featureId": 4374,
            "deviceId": 332,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4375-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4375-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T13:57:09.246Z",
          "attributes": {
            "featureId": 4375,
            "deviceId": 332,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4376-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4376-3157328415+0",
          "name": "L42 fire",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b2"
          ],
          "createdDate": "2022-03-04T13:57:09.247Z",
          "attributes": {
            "featureId": 4376,
            "deviceId": 332,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L42 fire"
          }
        },
        "59d505a0eea9e528ef444c61-4367-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4367-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.324Z",
          "attributes": {
            "featureId": 4367,
            "deviceId": 332,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4368-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4368-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.324Z",
          "attributes": {
            "featureId": 4368,
            "deviceId": 332,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4369-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4369-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.325Z",
          "attributes": {
            "featureId": 4369,
            "deviceId": 332,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4370-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4370-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.325Z",
          "attributes": {
            "featureId": 4370,
            "deviceId": 332,
            "type": "power",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4371-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4371-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T11:10:37.325Z",
          "attributes": {
            "featureId": 4371,
            "deviceId": 332,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4377-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4377-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T13:57:09.247Z",
          "attributes": {
            "featureId": 4377,
            "deviceId": 332,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4378-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4378-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T13:57:09.247Z",
          "attributes": {
            "featureId": 4378,
            "deviceId": 332,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4379-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4379-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T13:57:09.248Z",
          "attributes": {
            "featureId": 4379,
            "deviceId": 332,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4380-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4380-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T13:57:09.248Z",
          "attributes": {
            "featureId": 4380,
            "deviceId": 332,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4381-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4381-3157328415+0",
          "name": "L42 fire 1",
          "deviceId": "59d505a0eea9e528ef444c61-332-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f3ad7c46e00b90ace8b3"
          ],
          "createdDate": "2022-03-04T13:57:09.248Z",
          "attributes": {
            "featureId": 4381,
            "deviceId": 332,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L42 fire 1"
          }
        },
        "59d505a0eea9e528ef444c61-4516-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4516-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.831Z",
          "attributes": {
            "featureId": 4516,
            "deviceId": 343,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4517-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4517-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.832Z",
          "attributes": {
            "featureId": 4517,
            "deviceId": 343,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4518-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4518-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.832Z",
          "attributes": {
            "featureId": 4518,
            "deviceId": 343,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4519-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4519-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.833Z",
          "attributes": {
            "featureId": 4519,
            "deviceId": 343,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4520-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4520-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.833Z",
          "attributes": {
            "featureId": 4520,
            "deviceId": 343,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4521-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4521-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.833Z",
          "attributes": {
            "featureId": 4521,
            "deviceId": 343,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4522-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4522-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.833Z",
          "attributes": {
            "featureId": 4522,
            "deviceId": 343,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4523-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4523-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.834Z",
          "attributes": {
            "featureId": 4523,
            "deviceId": 343,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4524-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4524-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.834Z",
          "attributes": {
            "featureId": 4524,
            "deviceId": 343,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4525-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4525-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.834Z",
          "attributes": {
            "featureId": 4525,
            "deviceId": 343,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4526-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4526-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.834Z",
          "attributes": {
            "featureId": 4526,
            "deviceId": 343,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4527-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4527-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.834Z",
          "attributes": {
            "featureId": 4527,
            "deviceId": 343,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4528-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4528-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.835Z",
          "attributes": {
            "featureId": 4528,
            "deviceId": 343,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4529-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4529-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.835Z",
          "attributes": {
            "featureId": 4529,
            "deviceId": 343,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4530-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4530-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.835Z",
          "attributes": {
            "featureId": 4530,
            "deviceId": 343,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4531-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4531-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.836Z",
          "attributes": {
            "featureId": 4531,
            "deviceId": 343,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4532-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4532-3157328415+0",
          "name": "Lp40",
          "deviceId": "59d505a0eea9e528ef444c61-343-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6281ca6b7150e401bd82a24c"
          ],
          "createdDate": "2022-05-16T03:52:11.836Z",
          "attributes": {
            "featureId": 4532,
            "deviceId": 343,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lp40"
          }
        },
        "59d505a0eea9e528ef444c61-4540-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4540-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.241Z",
          "attributes": {
            "featureId": 4540,
            "deviceId": 344,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4541-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4541-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.241Z",
          "attributes": {
            "featureId": 4541,
            "deviceId": 344,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4542-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4542-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.242Z",
          "attributes": {
            "featureId": 4542,
            "deviceId": 344,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4543-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4543-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.242Z",
          "attributes": {
            "featureId": 4543,
            "deviceId": 344,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4544-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4544-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.242Z",
          "attributes": {
            "featureId": 4544,
            "deviceId": 344,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4545-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4545-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.243Z",
          "attributes": {
            "featureId": 4545,
            "deviceId": 344,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4546-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4546-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.243Z",
          "attributes": {
            "featureId": 4546,
            "deviceId": 344,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4547-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4547-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.243Z",
          "attributes": {
            "featureId": 4547,
            "deviceId": 344,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4548-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4548-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.243Z",
          "attributes": {
            "featureId": 4548,
            "deviceId": 344,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4549-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4549-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761"
          ],
          "createdDate": "2022-06-06T15:35:53.244Z",
          "attributes": {
            "featureId": 4549,
            "deviceId": 344,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4533-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4533-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.247Z",
          "attributes": {
            "featureId": 4533,
            "deviceId": 344,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4534-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4534-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.248Z",
          "attributes": {
            "featureId": 4534,
            "deviceId": 344,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4535-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4535-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.248Z",
          "attributes": {
            "featureId": 4535,
            "deviceId": 344,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4536-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4536-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.248Z",
          "attributes": {
            "featureId": 4536,
            "deviceId": 344,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4537-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4537-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.249Z",
          "attributes": {
            "featureId": 4537,
            "deviceId": 344,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4538-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4538-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.249Z",
          "attributes": {
            "featureId": 4538,
            "deviceId": 344,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4539-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4539-3157328415+0",
          "name": "LP42",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2761",
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.249Z",
          "attributes": {
            "featureId": 4539,
            "deviceId": 344,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42"
          }
        },
        "59d505a0eea9e528ef444c61-4550-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4550-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.245Z",
          "attributes": {
            "featureId": 4550,
            "deviceId": 344,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4551-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4551-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.245Z",
          "attributes": {
            "featureId": 4551,
            "deviceId": 344,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4552-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4552-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.245Z",
          "attributes": {
            "featureId": 4552,
            "deviceId": 344,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4553-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4553-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.245Z",
          "attributes": {
            "featureId": 4553,
            "deviceId": 344,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4554-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4554-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.246Z",
          "attributes": {
            "featureId": 4554,
            "deviceId": 344,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4555-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4555-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.246Z",
          "attributes": {
            "featureId": 4555,
            "deviceId": 344,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4556-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4556-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.246Z",
          "attributes": {
            "featureId": 4556,
            "deviceId": 344,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4557-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4557-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.246Z",
          "attributes": {
            "featureId": 4557,
            "deviceId": 344,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4558-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4558-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.247Z",
          "attributes": {
            "featureId": 4558,
            "deviceId": 344,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4559-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4559-3157328415+0",
          "name": "LP42 1",
          "deviceId": "59d505a0eea9e528ef444c61-344-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e1ed91abcca53383a2762"
          ],
          "createdDate": "2022-06-06T15:35:53.247Z",
          "attributes": {
            "featureId": 4559,
            "deviceId": 344,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "LP42 1"
          }
        },
        "59d505a0eea9e528ef444c61-4567-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4567-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.647Z",
          "attributes": {
            "featureId": 4567,
            "deviceId": 345,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4568-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4568-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.648Z",
          "attributes": {
            "featureId": 4568,
            "deviceId": 345,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4569-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4569-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.648Z",
          "attributes": {
            "featureId": 4569,
            "deviceId": 345,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4570-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4570-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.648Z",
          "attributes": {
            "featureId": 4570,
            "deviceId": 345,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4571-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4571-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.648Z",
          "attributes": {
            "featureId": 4571,
            "deviceId": 345,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4572-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4572-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.649Z",
          "attributes": {
            "featureId": 4572,
            "deviceId": 345,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4573-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4573-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.649Z",
          "attributes": {
            "featureId": 4573,
            "deviceId": 345,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4574-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4574-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.649Z",
          "attributes": {
            "featureId": 4574,
            "deviceId": 345,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4575-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4575-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.649Z",
          "attributes": {
            "featureId": 4575,
            "deviceId": 345,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4576-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4576-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878"
          ],
          "createdDate": "2022-06-06T15:57:41.650Z",
          "attributes": {
            "featureId": 4576,
            "deviceId": 345,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4560-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4560-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.653Z",
          "attributes": {
            "featureId": 4560,
            "deviceId": 345,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4561-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4561-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.653Z",
          "attributes": {
            "featureId": 4561,
            "deviceId": 345,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4562-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4562-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.654Z",
          "attributes": {
            "featureId": 4562,
            "deviceId": 345,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4563-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4563-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.654Z",
          "attributes": {
            "featureId": 4563,
            "deviceId": 345,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4564-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4564-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.654Z",
          "attributes": {
            "featureId": 4564,
            "deviceId": 345,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4565-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4565-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.654Z",
          "attributes": {
            "featureId": 4565,
            "deviceId": 345,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4566-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4566-3157328415+0",
          "name": "Qwer",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db878",
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.655Z",
          "attributes": {
            "featureId": 4566,
            "deviceId": 345,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer"
          }
        },
        "59d505a0eea9e528ef444c61-4577-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4577-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.650Z",
          "attributes": {
            "featureId": 4577,
            "deviceId": 345,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4578-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4578-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.651Z",
          "attributes": {
            "featureId": 4578,
            "deviceId": 345,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4579-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4579-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.651Z",
          "attributes": {
            "featureId": 4579,
            "deviceId": 345,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4580-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4580-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.651Z",
          "attributes": {
            "featureId": 4580,
            "deviceId": 345,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4581-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4581-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.651Z",
          "attributes": {
            "featureId": 4581,
            "deviceId": 345,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4582-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4582-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.652Z",
          "attributes": {
            "featureId": 4582,
            "deviceId": 345,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4583-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4583-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.652Z",
          "attributes": {
            "featureId": 4583,
            "deviceId": 345,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4584-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4584-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.652Z",
          "attributes": {
            "featureId": 4584,
            "deviceId": 345,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4585-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4585-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.652Z",
          "attributes": {
            "featureId": 4585,
            "deviceId": 345,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-4586-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4586-3157328415+0",
          "name": "Qwer 1",
          "deviceId": "59d505a0eea9e528ef444c61-345-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-629e23f55b6f830b9e0db879"
          ],
          "createdDate": "2022-06-06T15:57:41.653Z",
          "attributes": {
            "featureId": 4586,
            "deviceId": 345,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Qwer 1"
          }
        },
        "59d505a0eea9e528ef444c61-191-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-191-3157328415+0",
          "name": "Angle lamp",
          "deviceId": "59d505a0eea9e528ef444c61-26-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51cfaeea9e528ef44a9dd"
          ],
          "createdDate": "2017-10-04T17:40:10.822Z",
          "attributes": {
            "featureId": 191,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "name": "Angle lamp"
          }
        },
        "59d505a0eea9e528ef444c61-192-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-192-3157328415+0",
          "name": "Angle lamp",
          "deviceId": "59d505a0eea9e528ef444c61-26-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51cfaeea9e528ef44a9dd"
          ],
          "createdDate": "2017-10-04T17:40:10.823Z",
          "attributes": {
            "featureId": 192,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "name": "Angle lamp"
          }
        },
        "59d505a0eea9e528ef444c61-193-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-193-3157328415+0",
          "name": "Angle lamp",
          "deviceId": "59d505a0eea9e528ef444c61-26-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51cfaeea9e528ef44a9dd"
          ],
          "createdDate": "2017-10-04T17:40:10.823Z",
          "attributes": {
            "featureId": 193,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "name": "Angle lamp"
          }
        },
        "59d505a0eea9e528ef444c61-981-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-981-3157328415+0",
          "name": "Angle lamp",
          "deviceId": "59d505a0eea9e528ef444c61-26-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d51cfaeea9e528ef44a9dd"
          ],
          "createdDate": "2019-04-25T15:21:13.788Z",
          "attributes": {
            "featureId": 981,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Angle lamp"
          }
        },
        "59d505a0eea9e528ef444c61-325-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "name": "Side lamp",
          "deviceId": "59d505a0eea9e528ef444c61-42-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59f4b3fac6bf69015f088112"
          ],
          "createdDate": "2017-10-28T16:44:42.408Z",
          "attributes": {
            "name": "Side lamp",
            "type": "switch",
            "channel": 0,
            "writable": true,
            "featureId": 325
          }
        },
        "59d505a0eea9e528ef444c61-326-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-326-3157328415+0",
          "name": "Side lamp",
          "deviceId": "59d505a0eea9e528ef444c61-42-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59f4b3fac6bf69015f088112"
          ],
          "createdDate": "2017-10-28T16:44:42.409Z",
          "attributes": {
            "name": "Side lamp",
            "type": "protection",
            "channel": 0,
            "writable": true,
            "featureId": 326
          }
        },
        "59d505a0eea9e528ef444c61-984-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-984-3157328415+0",
          "name": "Side lamp",
          "deviceId": "59d505a0eea9e528ef444c61-42-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59f4b3fac6bf69015f088112"
          ],
          "createdDate": "2019-04-25T15:21:14.055Z",
          "attributes": {
            "featureId": 984,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Side lamp"
          }
        },
        "59d505a0eea9e528ef444c61-327-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "name": "Righthand lamp",
          "deviceId": "59d505a0eea9e528ef444c61-43-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59f4b45fc6bf69015f088733"
          ],
          "createdDate": "2017-10-28T16:46:23.434Z",
          "attributes": {
            "featureId": 327,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "name": "Righthand lamp"
          }
        },
        "59d505a0eea9e528ef444c61-328-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "name": "Righthand lamp",
          "deviceId": "59d505a0eea9e528ef444c61-43-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59f4b45fc6bf69015f088733"
          ],
          "createdDate": "2017-10-28T16:46:23.435Z",
          "attributes": {
            "featureId": 328,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "name": "Righthand lamp"
          }
        },
        "59d505a0eea9e528ef444c61-985-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-985-3157328415+0",
          "name": "Righthand lamp",
          "deviceId": "59d505a0eea9e528ef444c61-43-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59f4b45fc6bf69015f088733"
          ],
          "createdDate": "2019-04-25T15:21:11.856Z",
          "attributes": {
            "featureId": 985,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Righthand lamp"
          }
        },
        "59d505a0eea9e528ef444c61-737-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-737-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.222Z",
          "attributes": {
            "featureId": 737,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-738-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-738-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.223Z",
          "attributes": {
            "featureId": 738,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-739-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-739-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.223Z",
          "attributes": {
            "featureId": 739,
            "writable": true,
            "channel": 0,
            "type": "dimSetup",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-740-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-740-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.223Z",
          "attributes": {
            "featureId": 740,
            "writable": true,
            "channel": 0,
            "type": "bulbSetup",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-741-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-741-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.223Z",
          "attributes": {
            "featureId": 741,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-742-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-742-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.224Z",
          "attributes": {
            "featureId": 742,
            "writable": true,
            "channel": 0,
            "type": "power",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-743-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-743-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2019-02-07T09:38:32.224Z",
          "attributes": {
            "featureId": 743,
            "writable": true,
            "channel": 0,
            "type": "energy",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-731-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-731-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.226Z",
          "attributes": {
            "featureId": 731,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-732-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-732-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.226Z",
          "attributes": {
            "featureId": 732,
            "writable": true,
            "channel": 0,
            "type": "reset",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-733-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-733-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.226Z",
          "attributes": {
            "featureId": 733,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-734-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-734-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.227Z",
          "attributes": {
            "featureId": 734,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-735-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-735-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.227Z",
          "attributes": {
            "featureId": 735,
            "writable": true,
            "channel": 0,
            "type": "periodOfBroadcast",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-736-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-736-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.227Z",
          "attributes": {
            "featureId": 736,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3077-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3077-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab",
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.132Z",
          "attributes": {
            "featureId": 3077,
            "deviceId": 106,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3078-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3078-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2021-03-29T16:04:30.134Z",
          "attributes": {
            "featureId": 3078,
            "deviceId": 106,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3079-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3079-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2021-03-29T16:04:30.134Z",
          "attributes": {
            "featureId": 3079,
            "deviceId": 106,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3080-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3080-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2021-03-29T16:04:30.134Z",
          "attributes": {
            "featureId": 3080,
            "deviceId": 106,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3081-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3081-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2021-03-29T16:04:30.134Z",
          "attributes": {
            "featureId": 3081,
            "deviceId": 106,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3082-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3082-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2021-03-29T16:04:30.135Z",
          "attributes": {
            "featureId": 3082,
            "deviceId": 106,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3083-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3083-3157328415+0",
          "name": "Living room",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ab"
          ],
          "createdDate": "2021-03-29T16:04:30.135Z",
          "attributes": {
            "featureId": 3083,
            "deviceId": 106,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Living room"
          }
        },
        "59d505a0eea9e528ef444c61-3084-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3084-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.135Z",
          "attributes": {
            "featureId": 3084,
            "deviceId": 106,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-3085-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3085-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.135Z",
          "attributes": {
            "featureId": 3085,
            "deviceId": 106,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-3086-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3086-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.135Z",
          "attributes": {
            "featureId": 3086,
            "deviceId": 106,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-3087-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3087-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.135Z",
          "attributes": {
            "featureId": 3087,
            "deviceId": 106,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-3088-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3088-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.136Z",
          "attributes": {
            "featureId": 3088,
            "deviceId": 106,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-3089-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3089-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2021-03-29T16:04:30.136Z",
          "attributes": {
            "featureId": 3089,
            "deviceId": 106,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "ok",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-744-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-744-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.224Z",
          "attributes": {
            "featureId": 744,
            "writable": true,
            "channel": 1,
            "type": "switch",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-745-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-745-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.225Z",
          "attributes": {
            "featureId": 745,
            "writable": true,
            "channel": 1,
            "type": "dimLevel",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-746-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-746-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.225Z",
          "attributes": {
            "featureId": 746,
            "writable": true,
            "channel": 1,
            "type": "dimSetup",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-747-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-747-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.225Z",
          "attributes": {
            "featureId": 747,
            "writable": true,
            "channel": 1,
            "type": "bulbSetup",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-748-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-748-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.225Z",
          "attributes": {
            "featureId": 748,
            "writable": true,
            "channel": 1,
            "type": "protection",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-749-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-749-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.225Z",
          "attributes": {
            "featureId": 749,
            "writable": true,
            "channel": 1,
            "type": "power",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-750-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-750-3157328415+0",
          "name": "Living room 1",
          "deviceId": "59d505a0eea9e528ef444c61-106-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5c5bfc98f9d05f3d83c427ac"
          ],
          "createdDate": "2019-02-07T09:38:32.226Z",
          "attributes": {
            "featureId": 750,
            "writable": true,
            "channel": 1,
            "type": "energy",
            "status": "init",
            "name": "Living room 1"
          }
        },
        "59d505a0eea9e528ef444c61-4597-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4597-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.673Z",
          "attributes": {
            "featureId": 4597,
            "deviceId": 347,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4598-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4598-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.673Z",
          "attributes": {
            "featureId": 4598,
            "deviceId": 347,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4599-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4599-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.674Z",
          "attributes": {
            "featureId": 4599,
            "deviceId": 347,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4600-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4600-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.674Z",
          "attributes": {
            "featureId": 4600,
            "deviceId": 347,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4601-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4601-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.674Z",
          "attributes": {
            "featureId": 4601,
            "deviceId": 347,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4602-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4602-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.675Z",
          "attributes": {
            "featureId": 4602,
            "deviceId": 347,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4603-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4603-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.675Z",
          "attributes": {
            "featureId": 4603,
            "deviceId": 347,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4604-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4604-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.675Z",
          "attributes": {
            "featureId": 4604,
            "deviceId": 347,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4605-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4605-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.675Z",
          "attributes": {
            "featureId": 4605,
            "deviceId": 347,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4606-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4606-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880"
          ],
          "createdDate": "2022-07-07T14:37:08.676Z",
          "attributes": {
            "featureId": 4606,
            "deviceId": 347,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4590-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4590-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.680Z",
          "attributes": {
            "featureId": 4590,
            "deviceId": 347,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4591-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4591-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.680Z",
          "attributes": {
            "featureId": 4591,
            "deviceId": 347,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4592-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4592-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.680Z",
          "attributes": {
            "featureId": 4592,
            "deviceId": 347,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4593-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4593-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.681Z",
          "attributes": {
            "featureId": 4593,
            "deviceId": 347,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4594-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4594-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.681Z",
          "attributes": {
            "featureId": 4594,
            "deviceId": 347,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4595-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4595-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.681Z",
          "attributes": {
            "featureId": 4595,
            "deviceId": 347,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4596-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4596-3157328415+0",
          "name": "Mk3 test1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8880",
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.681Z",
          "attributes": {
            "featureId": 4596,
            "deviceId": 347,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1"
          }
        },
        "59d505a0eea9e528ef444c61-4607-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4607-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.676Z",
          "attributes": {
            "featureId": 4607,
            "deviceId": 347,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4608-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4608-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.677Z",
          "attributes": {
            "featureId": 4608,
            "deviceId": 347,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4609-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4609-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.677Z",
          "attributes": {
            "featureId": 4609,
            "deviceId": 347,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4610-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4610-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.677Z",
          "attributes": {
            "featureId": 4610,
            "deviceId": 347,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4611-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4611-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.677Z",
          "attributes": {
            "featureId": 4611,
            "deviceId": 347,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4612-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4612-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.678Z",
          "attributes": {
            "featureId": 4612,
            "deviceId": 347,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4613-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4613-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.678Z",
          "attributes": {
            "featureId": 4613,
            "deviceId": 347,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4614-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4614-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.679Z",
          "attributes": {
            "featureId": 4614,
            "deviceId": 347,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4615-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4615-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.679Z",
          "attributes": {
            "featureId": 4615,
            "deviceId": 347,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-4616-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4616-3157328415+0",
          "name": "Mk3 test1 1",
          "deviceId": "59d505a0eea9e528ef444c61-347-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6ef94b9a8680b9b0c8881"
          ],
          "createdDate": "2022-07-07T14:37:08.679Z",
          "attributes": {
            "featureId": 4616,
            "deviceId": 347,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test1 1"
          }
        },
        "59d505a0eea9e528ef444c61-1536-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1536-3157328415+0",
          "name": "House energy",
          "deviceId": "59d505a0eea9e528ef444c61-185-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e28e0a6da3f5d12b1fbda"
          ],
          "createdDate": "2020-03-27T16:25:04.527Z",
          "attributes": {
            "featureId": 1536,
            "deviceId": 185,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "House energy"
          }
        },
        "59d505a0eea9e528ef444c61-1537-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1537-3157328415+0",
          "name": "House energy",
          "deviceId": "59d505a0eea9e528ef444c61-185-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e28e0a6da3f5d12b1fbda"
          ],
          "createdDate": "2020-03-27T16:25:04.528Z",
          "attributes": {
            "featureId": 1537,
            "deviceId": 185,
            "type": "energy",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "House energy"
          }
        },
        "59d505a0eea9e528ef444c61-1538-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1538-3157328415+0",
          "name": "House energy",
          "deviceId": "59d505a0eea9e528ef444c61-185-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e28e0a6da3f5d12b1fbda"
          ],
          "createdDate": "2020-03-27T16:25:04.528Z",
          "attributes": {
            "featureId": 1538,
            "deviceId": 185,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "House energy"
          }
        },
        "59d505a0eea9e528ef444c61-1539-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1539-3157328415+0",
          "name": "House energy",
          "deviceId": "59d505a0eea9e528ef444c61-185-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e28e0a6da3f5d12b1fbda"
          ],
          "createdDate": "2020-03-27T16:25:04.528Z",
          "attributes": {
            "featureId": 1539,
            "deviceId": 185,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "House energy"
          }
        },
        "59d505a0eea9e528ef444c61-4220-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4220-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.106Z",
          "attributes": {
            "featureId": 4220,
            "deviceId": 328,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4221-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4221-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.106Z",
          "attributes": {
            "featureId": 4221,
            "deviceId": 328,
            "type": "dimLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4222-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4222-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.107Z",
          "attributes": {
            "featureId": 4222,
            "deviceId": 328,
            "type": "dimSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4223-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4223-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.107Z",
          "attributes": {
            "featureId": 4223,
            "deviceId": 328,
            "type": "dimProfileCurve",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4224-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4224-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.107Z",
          "attributes": {
            "featureId": 4224,
            "deviceId": 328,
            "type": "dimProfileTimebase",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4225-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4225-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.107Z",
          "attributes": {
            "featureId": 4225,
            "deviceId": 328,
            "type": "bulbSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4226-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4226-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.108Z",
          "attributes": {
            "featureId": 4226,
            "deviceId": 328,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4227-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4227-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.108Z",
          "attributes": {
            "featureId": 4227,
            "deviceId": 328,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4228-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4228-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.108Z",
          "attributes": {
            "featureId": 4228,
            "deviceId": 328,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4229-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4229-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.108Z",
          "attributes": {
            "featureId": 4229,
            "deviceId": 328,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4230-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4230-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.109Z",
          "attributes": {
            "featureId": 4230,
            "deviceId": 328,
            "type": "uiIndicator",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4231-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4231-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.109Z",
          "attributes": {
            "featureId": 4231,
            "deviceId": 328,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4232-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4232-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7"
          ],
          "createdDate": "2022-02-27T15:48:42.109Z",
          "attributes": {
            "featureId": 4232,
            "deviceId": 328,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4213-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4213-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.113Z",
          "attributes": {
            "featureId": 4213,
            "deviceId": 328,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4214-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4214-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.113Z",
          "attributes": {
            "featureId": 4214,
            "deviceId": 328,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4215-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4215-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.114Z",
          "attributes": {
            "featureId": 4215,
            "deviceId": 328,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4216-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4216-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.114Z",
          "attributes": {
            "featureId": 4216,
            "deviceId": 328,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4217-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4217-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.114Z",
          "attributes": {
            "featureId": 4217,
            "deviceId": 328,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4218-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4218-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.114Z",
          "attributes": {
            "featureId": 4218,
            "deviceId": 328,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4219-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4219-3157328415+0",
          "name": "N",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca7",
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.115Z",
          "attributes": {
            "featureId": 4219,
            "deviceId": 328,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N"
          }
        },
        "59d505a0eea9e528ef444c61-4233-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4233-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.110Z",
          "attributes": {
            "featureId": 4233,
            "deviceId": 328,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4234-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4234-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.110Z",
          "attributes": {
            "featureId": 4234,
            "deviceId": 328,
            "type": "dimLevel",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4235-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4235-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.110Z",
          "attributes": {
            "featureId": 4235,
            "deviceId": 328,
            "type": "dimSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4236-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4236-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.110Z",
          "attributes": {
            "featureId": 4236,
            "deviceId": 328,
            "type": "dimProfileCurve",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4237-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4237-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.111Z",
          "attributes": {
            "featureId": 4237,
            "deviceId": 328,
            "type": "dimProfileTimebase",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4238-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4238-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.111Z",
          "attributes": {
            "featureId": 4238,
            "deviceId": 328,
            "type": "bulbSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4239-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4239-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.111Z",
          "attributes": {
            "featureId": 4239,
            "deviceId": 328,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4240-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4240-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.111Z",
          "attributes": {
            "featureId": 4240,
            "deviceId": 328,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4241-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4241-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.112Z",
          "attributes": {
            "featureId": 4241,
            "deviceId": 328,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4242-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4242-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.112Z",
          "attributes": {
            "featureId": 4242,
            "deviceId": 328,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4243-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4243-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.112Z",
          "attributes": {
            "featureId": 4243,
            "deviceId": 328,
            "type": "uiIndicator",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4244-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4244-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.112Z",
          "attributes": {
            "featureId": 4244,
            "deviceId": 328,
            "type": "uiIOMap",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4245-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4245-3157328415+0",
          "name": "N 1",
          "deviceId": "59d505a0eea9e528ef444c61-328-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b9d5a289ec10b9dd85ca8"
          ],
          "createdDate": "2022-02-27T15:48:42.113Z",
          "attributes": {
            "featureId": 4245,
            "deviceId": 328,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "N 1"
          }
        },
        "59d505a0eea9e528ef444c61-4624-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4624-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.714Z",
          "attributes": {
            "featureId": 4624,
            "deviceId": 348,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4625-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4625-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.715Z",
          "attributes": {
            "featureId": 4625,
            "deviceId": 348,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4626-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4626-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.715Z",
          "attributes": {
            "featureId": 4626,
            "deviceId": 348,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4627-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4627-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.716Z",
          "attributes": {
            "featureId": 4627,
            "deviceId": 348,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4628-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4628-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.716Z",
          "attributes": {
            "featureId": 4628,
            "deviceId": 348,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4629-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4629-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.716Z",
          "attributes": {
            "featureId": 4629,
            "deviceId": 348,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4630-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4630-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.717Z",
          "attributes": {
            "featureId": 4630,
            "deviceId": 348,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4631-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4631-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.717Z",
          "attributes": {
            "featureId": 4631,
            "deviceId": 348,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4632-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4632-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.717Z",
          "attributes": {
            "featureId": 4632,
            "deviceId": 348,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4633-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4633-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328"
          ],
          "createdDate": "2022-07-07T14:41:14.718Z",
          "attributes": {
            "featureId": 4633,
            "deviceId": 348,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4617-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4617-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.722Z",
          "attributes": {
            "featureId": 4617,
            "deviceId": 348,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4618-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4618-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.723Z",
          "attributes": {
            "featureId": 4618,
            "deviceId": 348,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4619-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4619-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.723Z",
          "attributes": {
            "featureId": 4619,
            "deviceId": 348,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4620-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4620-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.723Z",
          "attributes": {
            "featureId": 4620,
            "deviceId": 348,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4621-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4621-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.725Z",
          "attributes": {
            "featureId": 4621,
            "deviceId": 348,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4622-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4622-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.725Z",
          "attributes": {
            "featureId": 4622,
            "deviceId": 348,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4623-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4623-3157328415+0",
          "name": "Mk3 test 2",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673328",
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.726Z",
          "attributes": {
            "featureId": 4623,
            "deviceId": 348,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2"
          }
        },
        "59d505a0eea9e528ef444c61-4634-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4634-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.719Z",
          "attributes": {
            "featureId": 4634,
            "deviceId": 348,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4635-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4635-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.719Z",
          "attributes": {
            "featureId": 4635,
            "deviceId": 348,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4636-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4636-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.719Z",
          "attributes": {
            "featureId": 4636,
            "deviceId": 348,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4637-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4637-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.720Z",
          "attributes": {
            "featureId": 4637,
            "deviceId": 348,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4638-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4638-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.720Z",
          "attributes": {
            "featureId": 4638,
            "deviceId": 348,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4639-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4639-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.720Z",
          "attributes": {
            "featureId": 4639,
            "deviceId": 348,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4640-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4640-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.721Z",
          "attributes": {
            "featureId": 4640,
            "deviceId": 348,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4641-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4641-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.721Z",
          "attributes": {
            "featureId": 4641,
            "deviceId": 348,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4642-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4642-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.722Z",
          "attributes": {
            "featureId": 4642,
            "deviceId": 348,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4643-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4643-3157328415+0",
          "name": "Mk3 test 2 1",
          "deviceId": "59d505a0eea9e528ef444c61-348-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f08ae0ef9f0b90673329"
          ],
          "createdDate": "2022-07-07T14:41:14.722Z",
          "attributes": {
            "featureId": 4643,
            "deviceId": 348,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 2 1"
          }
        },
        "59d505a0eea9e528ef444c61-4651-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4651-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.451Z",
          "attributes": {
            "featureId": 4651,
            "deviceId": 349,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4652-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4652-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.452Z",
          "attributes": {
            "featureId": 4652,
            "deviceId": 349,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4653-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4653-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.452Z",
          "attributes": {
            "featureId": 4653,
            "deviceId": 349,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4654-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4654-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.452Z",
          "attributes": {
            "featureId": 4654,
            "deviceId": 349,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4655-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4655-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.453Z",
          "attributes": {
            "featureId": 4655,
            "deviceId": 349,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4656-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4656-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.453Z",
          "attributes": {
            "featureId": 4656,
            "deviceId": 349,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4657-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4657-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.453Z",
          "attributes": {
            "featureId": 4657,
            "deviceId": 349,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4658-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4658-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.454Z",
          "attributes": {
            "featureId": 4658,
            "deviceId": 349,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4659-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4659-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.454Z",
          "attributes": {
            "featureId": 4659,
            "deviceId": 349,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4660-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4660-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f"
          ],
          "createdDate": "2022-07-07T14:44:14.455Z",
          "attributes": {
            "featureId": 4660,
            "deviceId": 349,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4644-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4644-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.459Z",
          "attributes": {
            "featureId": 4644,
            "deviceId": 349,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4645-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4645-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.460Z",
          "attributes": {
            "featureId": 4645,
            "deviceId": 349,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4646-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4646-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.461Z",
          "attributes": {
            "featureId": 4646,
            "deviceId": 349,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4647-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4647-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.461Z",
          "attributes": {
            "featureId": 4647,
            "deviceId": 349,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4648-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4648-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.462Z",
          "attributes": {
            "featureId": 4648,
            "deviceId": 349,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4649-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4649-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.462Z",
          "attributes": {
            "featureId": 4649,
            "deviceId": 349,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4650-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4650-3157328415+0",
          "name": "Mk3 test 3",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b9067356f",
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.462Z",
          "attributes": {
            "featureId": 4650,
            "deviceId": 349,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3"
          }
        },
        "59d505a0eea9e528ef444c61-4661-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4661-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.456Z",
          "attributes": {
            "featureId": 4661,
            "deviceId": 349,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4662-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4662-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.456Z",
          "attributes": {
            "featureId": 4662,
            "deviceId": 349,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4663-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4663-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.457Z",
          "attributes": {
            "featureId": 4663,
            "deviceId": 349,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4664-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4664-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.457Z",
          "attributes": {
            "featureId": 4664,
            "deviceId": 349,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4665-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4665-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.457Z",
          "attributes": {
            "featureId": 4665,
            "deviceId": 349,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4666-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4666-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.458Z",
          "attributes": {
            "featureId": 4666,
            "deviceId": 349,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4667-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4667-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.458Z",
          "attributes": {
            "featureId": 4667,
            "deviceId": 349,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4668-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4668-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.458Z",
          "attributes": {
            "featureId": 4668,
            "deviceId": 349,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4669-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4669-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.459Z",
          "attributes": {
            "featureId": 4669,
            "deviceId": 349,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4670-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4670-3157328415+0",
          "name": "Mk3 test 3 1",
          "deviceId": "59d505a0eea9e528ef444c61-349-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f13ee0ef9f0b90673570"
          ],
          "createdDate": "2022-07-07T14:44:14.459Z",
          "attributes": {
            "featureId": 4670,
            "deviceId": 349,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 3 1"
          }
        },
        "59d505a0eea9e528ef444c61-4678-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4678-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.203Z",
          "attributes": {
            "featureId": 4678,
            "deviceId": 351,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4679-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4679-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.204Z",
          "attributes": {
            "featureId": 4679,
            "deviceId": 351,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4680-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4680-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.204Z",
          "attributes": {
            "featureId": 4680,
            "deviceId": 351,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4681-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4681-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.204Z",
          "attributes": {
            "featureId": 4681,
            "deviceId": 351,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4682-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4682-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.205Z",
          "attributes": {
            "featureId": 4682,
            "deviceId": 351,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4683-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4683-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.205Z",
          "attributes": {
            "featureId": 4683,
            "deviceId": 351,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4684-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4684-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.205Z",
          "attributes": {
            "featureId": 4684,
            "deviceId": 351,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4685-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4685-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.205Z",
          "attributes": {
            "featureId": 4685,
            "deviceId": 351,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4686-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4686-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.206Z",
          "attributes": {
            "featureId": 4686,
            "deviceId": 351,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4687-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4687-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2"
          ],
          "createdDate": "2022-07-07T14:47:15.206Z",
          "attributes": {
            "featureId": 4687,
            "deviceId": 351,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4671-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4671-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.210Z",
          "attributes": {
            "featureId": 4671,
            "deviceId": 351,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4672-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4672-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.210Z",
          "attributes": {
            "featureId": 4672,
            "deviceId": 351,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4673-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4673-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.210Z",
          "attributes": {
            "featureId": 4673,
            "deviceId": 351,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4674-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4674-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.211Z",
          "attributes": {
            "featureId": 4674,
            "deviceId": 351,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4675-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4675-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.211Z",
          "attributes": {
            "featureId": 4675,
            "deviceId": 351,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4676-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4676-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.211Z",
          "attributes": {
            "featureId": 4676,
            "deviceId": 351,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4677-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4677-3157328415+0",
          "name": "Mk3 test4",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f2",
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.212Z",
          "attributes": {
            "featureId": 4677,
            "deviceId": 351,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4"
          }
        },
        "59d505a0eea9e528ef444c61-4688-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4688-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.207Z",
          "attributes": {
            "featureId": 4688,
            "deviceId": 351,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4689-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4689-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.207Z",
          "attributes": {
            "featureId": 4689,
            "deviceId": 351,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4690-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4690-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.207Z",
          "attributes": {
            "featureId": 4690,
            "deviceId": 351,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4691-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4691-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.208Z",
          "attributes": {
            "featureId": 4691,
            "deviceId": 351,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4692-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4692-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.208Z",
          "attributes": {
            "featureId": 4692,
            "deviceId": 351,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4693-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4693-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.208Z",
          "attributes": {
            "featureId": 4693,
            "deviceId": 351,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4694-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4694-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.208Z",
          "attributes": {
            "featureId": 4694,
            "deviceId": 351,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4695-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4695-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.209Z",
          "attributes": {
            "featureId": 4695,
            "deviceId": 351,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4696-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4696-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.209Z",
          "attributes": {
            "featureId": 4696,
            "deviceId": 351,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4697-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4697-3157328415+0",
          "name": "Mk3 test4 1",
          "deviceId": "59d505a0eea9e528ef444c61-351-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f1f3e0ef9f0b906737f3"
          ],
          "createdDate": "2022-07-07T14:47:15.209Z",
          "attributes": {
            "featureId": 4697,
            "deviceId": 351,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test4 1"
          }
        },
        "59d505a0eea9e528ef444c61-4705-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4705-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.379Z",
          "attributes": {
            "featureId": 4705,
            "deviceId": 352,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4706-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4706-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.380Z",
          "attributes": {
            "featureId": 4706,
            "deviceId": 352,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4707-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4707-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.380Z",
          "attributes": {
            "featureId": 4707,
            "deviceId": 352,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4708-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4708-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.381Z",
          "attributes": {
            "featureId": 4708,
            "deviceId": 352,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4709-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4709-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.381Z",
          "attributes": {
            "featureId": 4709,
            "deviceId": 352,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4710-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4710-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.381Z",
          "attributes": {
            "featureId": 4710,
            "deviceId": 352,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4711-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4711-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.381Z",
          "attributes": {
            "featureId": 4711,
            "deviceId": 352,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4712-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4712-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.382Z",
          "attributes": {
            "featureId": 4712,
            "deviceId": 352,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4713-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4713-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.382Z",
          "attributes": {
            "featureId": 4713,
            "deviceId": 352,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4714-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4714-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f"
          ],
          "createdDate": "2022-07-07T14:50:12.382Z",
          "attributes": {
            "featureId": 4714,
            "deviceId": 352,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4698-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4698-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.393Z",
          "attributes": {
            "featureId": 4698,
            "deviceId": 352,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4699-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4699-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.393Z",
          "attributes": {
            "featureId": 4699,
            "deviceId": 352,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4700-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4700-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.394Z",
          "attributes": {
            "featureId": 4700,
            "deviceId": 352,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4701-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4701-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.394Z",
          "attributes": {
            "featureId": 4701,
            "deviceId": 352,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4702-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4702-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.395Z",
          "attributes": {
            "featureId": 4702,
            "deviceId": 352,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4703-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4703-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.395Z",
          "attributes": {
            "featureId": 4703,
            "deviceId": 352,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4704-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4704-3157328415+0",
          "name": "Mk3 test5",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a4f",
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.395Z",
          "attributes": {
            "featureId": 4704,
            "deviceId": 352,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5"
          }
        },
        "59d505a0eea9e528ef444c61-4715-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4715-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.383Z",
          "attributes": {
            "featureId": 4715,
            "deviceId": 352,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4716-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4716-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.383Z",
          "attributes": {
            "featureId": 4716,
            "deviceId": 352,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4717-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4717-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.384Z",
          "attributes": {
            "featureId": 4717,
            "deviceId": 352,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4718-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4718-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.384Z",
          "attributes": {
            "featureId": 4718,
            "deviceId": 352,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4719-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4719-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.384Z",
          "attributes": {
            "featureId": 4719,
            "deviceId": 352,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4720-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4720-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.384Z",
          "attributes": {
            "featureId": 4720,
            "deviceId": 352,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4721-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4721-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.392Z",
          "attributes": {
            "featureId": 4721,
            "deviceId": 352,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4722-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4722-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.392Z",
          "attributes": {
            "featureId": 4722,
            "deviceId": 352,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4723-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4723-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.393Z",
          "attributes": {
            "featureId": 4723,
            "deviceId": 352,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4724-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4724-3157328415+0",
          "name": "Mk3 test5 1",
          "deviceId": "59d505a0eea9e528ef444c61-352-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f2a4e0ef9f0b90673a50"
          ],
          "createdDate": "2022-07-07T14:50:12.393Z",
          "attributes": {
            "featureId": 4724,
            "deviceId": 352,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test5 1"
          }
        },
        "59d505a0eea9e528ef444c61-4732-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4732-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.956Z",
          "attributes": {
            "featureId": 4732,
            "deviceId": 354,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4733-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4733-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.956Z",
          "attributes": {
            "featureId": 4733,
            "deviceId": 354,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4734-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4734-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.957Z",
          "attributes": {
            "featureId": 4734,
            "deviceId": 354,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4735-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4735-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.957Z",
          "attributes": {
            "featureId": 4735,
            "deviceId": 354,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4736-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4736-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.957Z",
          "attributes": {
            "featureId": 4736,
            "deviceId": 354,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4737-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4737-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.958Z",
          "attributes": {
            "featureId": 4737,
            "deviceId": 354,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4738-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4738-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.958Z",
          "attributes": {
            "featureId": 4738,
            "deviceId": 354,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4739-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4739-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.958Z",
          "attributes": {
            "featureId": 4739,
            "deviceId": 354,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4740-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4740-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.959Z",
          "attributes": {
            "featureId": 4740,
            "deviceId": 354,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4741-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4741-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d"
          ],
          "createdDate": "2022-07-07T14:58:35.959Z",
          "attributes": {
            "featureId": 4741,
            "deviceId": 354,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4725-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4725-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.964Z",
          "attributes": {
            "featureId": 4725,
            "deviceId": 354,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4726-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4726-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.965Z",
          "attributes": {
            "featureId": 4726,
            "deviceId": 354,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4727-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4727-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.965Z",
          "attributes": {
            "featureId": 4727,
            "deviceId": 354,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4728-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4728-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.965Z",
          "attributes": {
            "featureId": 4728,
            "deviceId": 354,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4729-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4729-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.966Z",
          "attributes": {
            "featureId": 4729,
            "deviceId": 354,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4730-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4730-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.966Z",
          "attributes": {
            "featureId": 4730,
            "deviceId": 354,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4731-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4731-3157328415+0",
          "name": "Mk3 test6",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2d",
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.966Z",
          "attributes": {
            "featureId": 4731,
            "deviceId": 354,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6"
          }
        },
        "59d505a0eea9e528ef444c61-4742-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4742-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.960Z",
          "attributes": {
            "featureId": 4742,
            "deviceId": 354,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4743-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4743-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.960Z",
          "attributes": {
            "featureId": 4743,
            "deviceId": 354,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4744-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4744-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.960Z",
          "attributes": {
            "featureId": 4744,
            "deviceId": 354,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4745-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4745-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.960Z",
          "attributes": {
            "featureId": 4745,
            "deviceId": 354,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4746-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4746-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.961Z",
          "attributes": {
            "featureId": 4746,
            "deviceId": 354,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4747-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4747-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.961Z",
          "attributes": {
            "featureId": 4747,
            "deviceId": 354,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4748-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4748-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.961Z",
          "attributes": {
            "featureId": 4748,
            "deviceId": 354,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4749-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4749-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.962Z",
          "attributes": {
            "featureId": 4749,
            "deviceId": 354,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4750-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4750-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.964Z",
          "attributes": {
            "featureId": 4750,
            "deviceId": 354,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4751-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4751-3157328415+0",
          "name": "Mk3 test6 1",
          "deviceId": "59d505a0eea9e528ef444c61-354-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f49bb9a8680b9b0cca2e"
          ],
          "createdDate": "2022-07-07T14:58:35.964Z",
          "attributes": {
            "featureId": 4751,
            "deviceId": 354,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test6 1"
          }
        },
        "59d505a0eea9e528ef444c61-4759-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4759-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.911Z",
          "attributes": {
            "featureId": 4759,
            "deviceId": 357,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4760-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4760-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.911Z",
          "attributes": {
            "featureId": 4760,
            "deviceId": 357,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4761-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4761-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.912Z",
          "attributes": {
            "featureId": 4761,
            "deviceId": 357,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4762-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4762-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.912Z",
          "attributes": {
            "featureId": 4762,
            "deviceId": 357,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4763-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4763-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.912Z",
          "attributes": {
            "featureId": 4763,
            "deviceId": 357,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4764-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4764-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.913Z",
          "attributes": {
            "featureId": 4764,
            "deviceId": 357,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4765-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4765-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.913Z",
          "attributes": {
            "featureId": 4765,
            "deviceId": 357,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4766-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4766-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.913Z",
          "attributes": {
            "featureId": 4766,
            "deviceId": 357,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4767-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4767-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.914Z",
          "attributes": {
            "featureId": 4767,
            "deviceId": 357,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4768-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4768-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755"
          ],
          "createdDate": "2022-07-07T15:05:59.914Z",
          "attributes": {
            "featureId": 4768,
            "deviceId": 357,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4752-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4752-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.918Z",
          "attributes": {
            "featureId": 4752,
            "deviceId": 357,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4753-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4753-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.918Z",
          "attributes": {
            "featureId": 4753,
            "deviceId": 357,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4754-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4754-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.918Z",
          "attributes": {
            "featureId": 4754,
            "deviceId": 357,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4755-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4755-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.918Z",
          "attributes": {
            "featureId": 4755,
            "deviceId": 357,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4756-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4756-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.919Z",
          "attributes": {
            "featureId": 4756,
            "deviceId": 357,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4757-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4757-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.919Z",
          "attributes": {
            "featureId": 4757,
            "deviceId": 357,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4758-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4758-3157328415+0",
          "name": "Mk3 test 7",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674755",
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.920Z",
          "attributes": {
            "featureId": 4758,
            "deviceId": 357,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7"
          }
        },
        "59d505a0eea9e528ef444c61-4769-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4769-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.915Z",
          "attributes": {
            "featureId": 4769,
            "deviceId": 357,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4770-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4770-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.915Z",
          "attributes": {
            "featureId": 4770,
            "deviceId": 357,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4771-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4771-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.915Z",
          "attributes": {
            "featureId": 4771,
            "deviceId": 357,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4772-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4772-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.915Z",
          "attributes": {
            "featureId": 4772,
            "deviceId": 357,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4773-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4773-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.916Z",
          "attributes": {
            "featureId": 4773,
            "deviceId": 357,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4774-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4774-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.916Z",
          "attributes": {
            "featureId": 4774,
            "deviceId": 357,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4775-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4775-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.916Z",
          "attributes": {
            "featureId": 4775,
            "deviceId": 357,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4776-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4776-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.916Z",
          "attributes": {
            "featureId": 4776,
            "deviceId": 357,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4777-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4777-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.917Z",
          "attributes": {
            "featureId": 4777,
            "deviceId": 357,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4778-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4778-3157328415+0",
          "name": "Mk3 test 7 1",
          "deviceId": "59d505a0eea9e528ef444c61-357-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6f657e0ef9f0b90674756"
          ],
          "createdDate": "2022-07-07T15:05:59.917Z",
          "attributes": {
            "featureId": 4778,
            "deviceId": 357,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 7 1"
          }
        },
        "59d505a0eea9e528ef444c61-4786-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4786-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.306Z",
          "attributes": {
            "featureId": 4786,
            "deviceId": 359,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4787-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4787-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.306Z",
          "attributes": {
            "featureId": 4787,
            "deviceId": 359,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4788-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4788-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.306Z",
          "attributes": {
            "featureId": 4788,
            "deviceId": 359,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4789-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4789-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.307Z",
          "attributes": {
            "featureId": 4789,
            "deviceId": 359,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4790-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4790-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.307Z",
          "attributes": {
            "featureId": 4790,
            "deviceId": 359,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4791-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4791-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.307Z",
          "attributes": {
            "featureId": 4791,
            "deviceId": 359,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4792-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4792-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.307Z",
          "attributes": {
            "featureId": 4792,
            "deviceId": 359,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4793-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4793-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.308Z",
          "attributes": {
            "featureId": 4793,
            "deviceId": 359,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4794-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4794-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.308Z",
          "attributes": {
            "featureId": 4794,
            "deviceId": 359,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4795-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4795-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085"
          ],
          "createdDate": "2022-07-07T15:31:16.308Z",
          "attributes": {
            "featureId": 4795,
            "deviceId": 359,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4779-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4779-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.326Z",
          "attributes": {
            "featureId": 4779,
            "deviceId": 359,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4780-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4780-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.326Z",
          "attributes": {
            "featureId": 4780,
            "deviceId": 359,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4781-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4781-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.327Z",
          "attributes": {
            "featureId": 4781,
            "deviceId": 359,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4782-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4782-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.327Z",
          "attributes": {
            "featureId": 4782,
            "deviceId": 359,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4783-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4783-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.327Z",
          "attributes": {
            "featureId": 4783,
            "deviceId": 359,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4784-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4784-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.328Z",
          "attributes": {
            "featureId": 4784,
            "deviceId": 359,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4785-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4785-3157328415+0",
          "name": "Mk3 test 8",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3085",
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.328Z",
          "attributes": {
            "featureId": 4785,
            "deviceId": 359,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8"
          }
        },
        "59d505a0eea9e528ef444c61-4796-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4796-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.309Z",
          "attributes": {
            "featureId": 4796,
            "deviceId": 359,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4797-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4797-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.309Z",
          "attributes": {
            "featureId": 4797,
            "deviceId": 359,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4798-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4798-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.310Z",
          "attributes": {
            "featureId": 4798,
            "deviceId": 359,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4799-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4799-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.310Z",
          "attributes": {
            "featureId": 4799,
            "deviceId": 359,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4800-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4800-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.310Z",
          "attributes": {
            "featureId": 4800,
            "deviceId": 359,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4801-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4801-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.311Z",
          "attributes": {
            "featureId": 4801,
            "deviceId": 359,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4802-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4802-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.324Z",
          "attributes": {
            "featureId": 4802,
            "deviceId": 359,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4803-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4803-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.324Z",
          "attributes": {
            "featureId": 4803,
            "deviceId": 359,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4804-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4804-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.325Z",
          "attributes": {
            "featureId": 4804,
            "deviceId": 359,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-4805-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4805-3157328415+0",
          "name": "Mk3 test 8 1",
          "deviceId": "59d505a0eea9e528ef444c61-359-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c6fc44b9a8680b9b0d3086"
          ],
          "createdDate": "2022-07-07T15:31:16.326Z",
          "attributes": {
            "featureId": 4805,
            "deviceId": 359,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Mk3 test 8 1"
          }
        },
        "59d505a0eea9e528ef444c61-339-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-339-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c"
          ],
          "createdDate": "2017-12-22T02:36:28.586Z",
          "attributes": {
            "name": "Under floor",
            "status": "init",
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "featureId": 339
          }
        },
        "59d505a0eea9e528ef444c61-340-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-340-3157328415+0",
          "name": "Under floor",
          "deviceId": "59d505a0eea9e528ef444c61-47-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5a3c6fac678993685e7a250c"
          ],
          "createdDate": "2017-12-22T02:36:28.588Z",
          "attributes": {
            "name": "Under floor",
            "status": "init",
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "featureId": 340
          }
        },
        "59d505a0eea9e528ef444c61-1244-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1244-3157328415+0",
          "name": "Hw t",
          "deviceId": "59d505a0eea9e528ef444c61-153-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d829456eb4e78368f18624e"
          ],
          "createdDate": "2019-09-18T20:32:22.866Z",
          "attributes": {
            "featureId": 1244,
            "writable": false,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Hw t"
          }
        },
        "59d505a0eea9e528ef444c61-1245-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1245-3157328415+0",
          "name": "Hw t",
          "deviceId": "59d505a0eea9e528ef444c61-153-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d829456eb4e78368f18624e"
          ],
          "createdDate": "2019-09-18T20:32:22.866Z",
          "attributes": {
            "featureId": 1245,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Hw t"
          }
        },
        "59d505a0eea9e528ef444c61-1246-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1246-3157328415+0",
          "name": "Hw t",
          "deviceId": "59d505a0eea9e528ef444c61-153-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d829456eb4e78368f18624e"
          ],
          "createdDate": "2019-09-18T20:32:22.866Z",
          "attributes": {
            "featureId": 1246,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Hw t"
          }
        },
        "59d505a0eea9e528ef444c61-1247-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1247-3157328415+0",
          "name": "Hw t",
          "deviceId": "59d505a0eea9e528ef444c61-153-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d829456eb4e78368f18624e"
          ],
          "createdDate": "2019-09-18T20:32:22.867Z",
          "attributes": {
            "featureId": 1247,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Hw t"
          }
        },
        "59d505a0eea9e528ef444c61-1248-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1248-3157328415+0",
          "name": "Hw t",
          "deviceId": "59d505a0eea9e528ef444c61-153-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d829456eb4e78368f18624e"
          ],
          "createdDate": "2019-09-18T20:32:22.867Z",
          "attributes": {
            "featureId": 1248,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Hw t"
          }
        },
        "59d505a0eea9e528ef444c61-1249-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1249-3157328415+0",
          "name": "Hw t",
          "deviceId": "59d505a0eea9e528ef444c61-153-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d829456eb4e78368f18624e"
          ],
          "createdDate": "2019-09-18T20:32:22.867Z",
          "attributes": {
            "featureId": 1249,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Hw t"
          }
        },
        "59d505a0eea9e528ef444c61-1295-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1295-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.935Z",
          "attributes": {
            "featureId": 1295,
            "writable": true,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1296-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1296-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.935Z",
          "attributes": {
            "featureId": 1296,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1297-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1297-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.935Z",
          "attributes": {
            "featureId": 1297,
            "writable": false,
            "channel": 0,
            "type": "valveLevel",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1298-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1298-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.936Z",
          "attributes": {
            "featureId": 1298,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1299-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1299-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.936Z",
          "attributes": {
            "featureId": 1299,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1300-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1300-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.936Z",
          "attributes": {
            "featureId": 1300,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1301-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1301-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.936Z",
          "attributes": {
            "featureId": 1301,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1302-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1302-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2019-09-30T18:39:25.936Z",
          "attributes": {
            "featureId": 1302,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1529-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1529-3157328415+0",
          "name": "Kit trv",
          "deviceId": "59d505a0eea9e528ef444c61-159-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d924bdd15b5241d7361bfe7"
          ],
          "createdDate": "2020-01-28T12:33:20.702Z",
          "attributes": {
            "featureId": 1529,
            "deviceId": 159,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "ok",
            "name": "Kit trv"
          }
        },
        "59d505a0eea9e528ef444c61-1309-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1309-3157328415+0",
          "name": "Bath stat",
          "deviceId": "59d505a0eea9e528ef444c61-161-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d92522015b5241d7361c1fa"
          ],
          "createdDate": "2019-09-30T19:06:08.870Z",
          "attributes": {
            "featureId": 1309,
            "writable": false,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Bath stat"
          }
        },
        "59d505a0eea9e528ef444c61-1310-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1310-3157328415+0",
          "name": "Bath stat",
          "deviceId": "59d505a0eea9e528ef444c61-161-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d92522015b5241d7361c1fa"
          ],
          "createdDate": "2019-09-30T19:06:08.870Z",
          "attributes": {
            "featureId": 1310,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Bath stat"
          }
        },
        "59d505a0eea9e528ef444c61-1311-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1311-3157328415+0",
          "name": "Bath stat",
          "deviceId": "59d505a0eea9e528ef444c61-161-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d92522015b5241d7361c1fa"
          ],
          "createdDate": "2019-09-30T19:06:08.870Z",
          "attributes": {
            "featureId": 1311,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Bath stat"
          }
        },
        "59d505a0eea9e528ef444c61-1312-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1312-3157328415+0",
          "name": "Bath stat",
          "deviceId": "59d505a0eea9e528ef444c61-161-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d92522015b5241d7361c1fa"
          ],
          "createdDate": "2019-09-30T19:06:08.871Z",
          "attributes": {
            "featureId": 1312,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Bath stat"
          }
        },
        "59d505a0eea9e528ef444c61-1313-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1313-3157328415+0",
          "name": "Bath stat",
          "deviceId": "59d505a0eea9e528ef444c61-161-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d92522015b5241d7361c1fa"
          ],
          "createdDate": "2019-09-30T19:06:08.871Z",
          "attributes": {
            "featureId": 1313,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Bath stat"
          }
        },
        "59d505a0eea9e528ef444c61-1314-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1314-3157328415+0",
          "name": "Bath stat",
          "deviceId": "59d505a0eea9e528ef444c61-161-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d92522015b5241d7361c1fa"
          ],
          "createdDate": "2019-09-30T19:06:08.871Z",
          "attributes": {
            "featureId": 1314,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Bath stat"
          }
        },
        "59d505a0eea9e528ef444c61-1315-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1315-3157328415+0",
          "name": "Main stat",
          "deviceId": "59d505a0eea9e528ef444c61-162-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d9252b215b5241d7361c221"
          ],
          "createdDate": "2019-09-30T19:08:34.214Z",
          "attributes": {
            "featureId": 1315,
            "writable": false,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Main stat"
          }
        },
        "59d505a0eea9e528ef444c61-1316-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1316-3157328415+0",
          "name": "Main stat",
          "deviceId": "59d505a0eea9e528ef444c61-162-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d9252b215b5241d7361c221"
          ],
          "createdDate": "2019-09-30T19:08:34.215Z",
          "attributes": {
            "featureId": 1316,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Main stat"
          }
        },
        "59d505a0eea9e528ef444c61-1317-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1317-3157328415+0",
          "name": "Main stat",
          "deviceId": "59d505a0eea9e528ef444c61-162-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d9252b215b5241d7361c221"
          ],
          "createdDate": "2019-09-30T19:08:34.215Z",
          "attributes": {
            "featureId": 1317,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Main stat"
          }
        },
        "59d505a0eea9e528ef444c61-1318-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1318-3157328415+0",
          "name": "Main stat",
          "deviceId": "59d505a0eea9e528ef444c61-162-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d9252b215b5241d7361c221"
          ],
          "createdDate": "2019-09-30T19:08:34.215Z",
          "attributes": {
            "featureId": 1318,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Main stat"
          }
        },
        "59d505a0eea9e528ef444c61-1319-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1319-3157328415+0",
          "name": "Main stat",
          "deviceId": "59d505a0eea9e528ef444c61-162-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d9252b215b5241d7361c221"
          ],
          "createdDate": "2019-09-30T19:08:34.216Z",
          "attributes": {
            "featureId": 1319,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Main stat"
          }
        },
        "59d505a0eea9e528ef444c61-1320-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1320-3157328415+0",
          "name": "Main stat",
          "deviceId": "59d505a0eea9e528ef444c61-162-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5d9252b215b5241d7361c221"
          ],
          "createdDate": "2019-09-30T19:08:34.216Z",
          "attributes": {
            "featureId": 1320,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Main stat"
          }
        },
        "59d505a0eea9e528ef444c61-1355-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1355-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.300Z",
          "attributes": {
            "featureId": 1355,
            "writable": true,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1356-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1356-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.301Z",
          "attributes": {
            "featureId": 1356,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1357-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1357-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.301Z",
          "attributes": {
            "featureId": 1357,
            "writable": false,
            "channel": 0,
            "type": "valveLevel",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1358-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1358-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.301Z",
          "attributes": {
            "featureId": 1358,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1359-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1359-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.301Z",
          "attributes": {
            "featureId": 1359,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1360-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1360-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.302Z",
          "attributes": {
            "featureId": 1360,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1361-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1361-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.302Z",
          "attributes": {
            "featureId": 1361,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1362-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1362-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2019-10-14T17:22:34.302Z",
          "attributes": {
            "featureId": 1362,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1530-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1530-3157328415+0",
          "name": "Trv dining",
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "createdDate": "2020-01-28T12:33:21.107Z",
          "attributes": {
            "featureId": 1530,
            "deviceId": 167,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Trv dining"
          }
        },
        "59d505a0eea9e528ef444c61-1371-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1371-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.337Z",
          "attributes": {
            "featureId": 1371,
            "writable": true,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1372-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1372-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.338Z",
          "attributes": {
            "featureId": 1372,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1373-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1373-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.338Z",
          "attributes": {
            "featureId": 1373,
            "writable": false,
            "channel": 0,
            "type": "valveLevel",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1374-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1374-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.338Z",
          "attributes": {
            "featureId": 1374,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1375-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1375-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.338Z",
          "attributes": {
            "featureId": 1375,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1376-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1376-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.338Z",
          "attributes": {
            "featureId": 1376,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1377-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1377-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.339Z",
          "attributes": {
            "featureId": 1377,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1378-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1378-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2019-10-14T17:55:15.339Z",
          "attributes": {
            "featureId": 1378,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1532-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1532-3157328415+0",
          "name": "Bath trv",
          "deviceId": "59d505a0eea9e528ef444c61-169-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b6831003e5429798deca"
          ],
          "createdDate": "2020-01-28T12:33:21.304Z",
          "attributes": {
            "featureId": 1532,
            "deviceId": 169,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Bath trv"
          }
        },
        "59d505a0eea9e528ef444c61-1379-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1379-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.932Z",
          "attributes": {
            "featureId": 1379,
            "writable": true,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1380-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1380-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.932Z",
          "attributes": {
            "featureId": 1380,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1381-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1381-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.932Z",
          "attributes": {
            "featureId": 1381,
            "writable": false,
            "channel": 0,
            "type": "valveLevel",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1382-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1382-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.933Z",
          "attributes": {
            "featureId": 1382,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1383-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1383-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.933Z",
          "attributes": {
            "featureId": 1383,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1384-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1384-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.933Z",
          "attributes": {
            "featureId": 1384,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1385-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1385-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.933Z",
          "attributes": {
            "featureId": 1385,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1386-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1386-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2019-10-14T17:58:39.933Z",
          "attributes": {
            "featureId": 1386,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1533-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1533-3157328415+0",
          "name": "Trv small bed",
          "deviceId": "59d505a0eea9e528ef444c61-170-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5da4b74f1003e5429798df1e"
          ],
          "createdDate": "2020-01-28T12:33:21.385Z",
          "attributes": {
            "featureId": 1533,
            "deviceId": 170,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Trv small bed"
          }
        },
        "59d505a0eea9e528ef444c61-1540-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1540-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.656Z",
          "attributes": {
            "featureId": 1540,
            "deviceId": 186,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1541-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1541-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.657Z",
          "attributes": {
            "featureId": 1541,
            "deviceId": 186,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1542-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1542-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.657Z",
          "attributes": {
            "featureId": 1542,
            "deviceId": 186,
            "type": "valveLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1543-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1543-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.658Z",
          "attributes": {
            "featureId": 1543,
            "deviceId": 186,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1544-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1544-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.658Z",
          "attributes": {
            "featureId": 1544,
            "deviceId": 186,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1545-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1545-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.658Z",
          "attributes": {
            "featureId": 1545,
            "deviceId": 186,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1546-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1546-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.658Z",
          "attributes": {
            "featureId": 1546,
            "deviceId": 186,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1547-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1547-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.659Z",
          "attributes": {
            "featureId": 1547,
            "deviceId": 186,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-1548-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1548-3157328415+0",
          "name": "Mid bed",
          "deviceId": "59d505a0eea9e528ef444c61-186-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e7e2b2aa6da3f5d12b1fc72"
          ],
          "createdDate": "2020-03-27T16:34:50.659Z",
          "attributes": {
            "featureId": 1548,
            "deviceId": 186,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Mid bed"
          }
        },
        "59d505a0eea9e528ef444c61-3811-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3811-3157328415+0",
          "name": "Stat",
          "deviceId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614cb5585adab9296afaf47b"
          ],
          "createdDate": "2021-09-23T17:11:52.510Z",
          "attributes": {
            "featureId": 3811,
            "deviceId": 300,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Stat"
          }
        },
        "59d505a0eea9e528ef444c61-3812-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3812-3157328415+0",
          "name": "Stat",
          "deviceId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614cb5585adab9296afaf47b"
          ],
          "createdDate": "2021-09-23T17:11:52.510Z",
          "attributes": {
            "featureId": 3812,
            "deviceId": 300,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Stat"
          }
        },
        "59d505a0eea9e528ef444c61-3813-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3813-3157328415+0",
          "name": "Stat",
          "deviceId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614cb5585adab9296afaf47b"
          ],
          "createdDate": "2021-09-23T17:11:52.510Z",
          "attributes": {
            "featureId": 3813,
            "deviceId": 300,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Stat"
          }
        },
        "59d505a0eea9e528ef444c61-3814-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3814-3157328415+0",
          "name": "Stat",
          "deviceId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614cb5585adab9296afaf47b"
          ],
          "createdDate": "2021-09-23T17:11:52.511Z",
          "attributes": {
            "featureId": 3814,
            "deviceId": 300,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Stat"
          }
        },
        "59d505a0eea9e528ef444c61-3815-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3815-3157328415+0",
          "name": "Stat",
          "deviceId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614cb5585adab9296afaf47b"
          ],
          "createdDate": "2021-09-23T17:11:52.511Z",
          "attributes": {
            "featureId": 3815,
            "deviceId": 300,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Stat"
          }
        },
        "59d505a0eea9e528ef444c61-3816-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3816-3157328415+0",
          "name": "Stat",
          "deviceId": "59d505a0eea9e528ef444c61-300-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-614cb5585adab9296afaf47b"
          ],
          "createdDate": "2021-09-23T17:11:52.511Z",
          "attributes": {
            "featureId": 3816,
            "deviceId": 300,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Stat"
          }
        },
        "59d505a0eea9e528ef444c61-3828-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3828-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.845Z",
          "attributes": {
            "featureId": 3828,
            "deviceId": 302,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3829-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3829-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.846Z",
          "attributes": {
            "featureId": 3829,
            "deviceId": 302,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3830-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3830-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.846Z",
          "attributes": {
            "featureId": 3830,
            "deviceId": 302,
            "type": "valveLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3831-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3831-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.847Z",
          "attributes": {
            "featureId": 3831,
            "deviceId": 302,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3832-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3832-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.848Z",
          "attributes": {
            "featureId": 3832,
            "deviceId": 302,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3833-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3833-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.848Z",
          "attributes": {
            "featureId": 3833,
            "deviceId": 302,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3834-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3834-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.849Z",
          "attributes": {
            "featureId": 3834,
            "deviceId": 302,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3835-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3835-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.849Z",
          "attributes": {
            "featureId": 3835,
            "deviceId": 302,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3836-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3836-3157328415+0",
          "name": "Hall TRV",
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "createdDate": "2021-10-25T17:08:11.850Z",
          "attributes": {
            "featureId": 3836,
            "deviceId": 302,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Hall TRV"
          }
        },
        "59d505a0eea9e528ef444c61-3866-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3866-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.913Z",
          "attributes": {
            "featureId": 3866,
            "deviceId": 305,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3867-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3867-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.914Z",
          "attributes": {
            "featureId": 3867,
            "deviceId": 305,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3868-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3868-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.914Z",
          "attributes": {
            "featureId": 3868,
            "deviceId": 305,
            "type": "valveLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3869-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3869-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.914Z",
          "attributes": {
            "featureId": 3869,
            "deviceId": 305,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3870-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3870-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.914Z",
          "attributes": {
            "featureId": 3870,
            "deviceId": 305,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3871-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3871-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.915Z",
          "attributes": {
            "featureId": 3871,
            "deviceId": 305,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3872-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3872-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.915Z",
          "attributes": {
            "featureId": 3872,
            "deviceId": 305,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3873-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3873-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.915Z",
          "attributes": {
            "featureId": 3873,
            "deviceId": 305,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3874-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3874-3157328415+0",
          "name": "Main bed",
          "deviceId": "59d505a0eea9e528ef444c61-305-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61803b018f93945b34fc4ec1"
          ],
          "createdDate": "2021-11-01T19:07:45.915Z",
          "attributes": {
            "featureId": 3874,
            "deviceId": 305,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Main bed"
          }
        },
        "59d505a0eea9e528ef444c61-3875-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3875-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.093Z",
          "attributes": {
            "featureId": 3875,
            "deviceId": 307,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3876-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3876-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.094Z",
          "attributes": {
            "featureId": 3876,
            "deviceId": 307,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3877-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3877-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.094Z",
          "attributes": {
            "featureId": 3877,
            "deviceId": 307,
            "type": "valveLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3878-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3878-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.094Z",
          "attributes": {
            "featureId": 3878,
            "deviceId": 307,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3879-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3879-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.095Z",
          "attributes": {
            "featureId": 3879,
            "deviceId": 307,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3880-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3880-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.095Z",
          "attributes": {
            "featureId": 3880,
            "deviceId": 307,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3881-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3881-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.095Z",
          "attributes": {
            "featureId": 3881,
            "deviceId": 307,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3882-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3882-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.095Z",
          "attributes": {
            "featureId": 3882,
            "deviceId": 307,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-3883-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3883-3157328415+0",
          "name": "Lounge t r v",
          "deviceId": "59d505a0eea9e528ef444c61-307-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-618045e1eda44b0b9c7523a1"
          ],
          "createdDate": "2021-11-01T19:54:09.096Z",
          "attributes": {
            "featureId": 3883,
            "deviceId": 307,
            "type": "windowPosition",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lounge t r v"
          }
        },
        "59d505a0eea9e528ef444c61-4190-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4190-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.296Z",
          "attributes": {
            "featureId": 4190,
            "deviceId": 327,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4191-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4191-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.297Z",
          "attributes": {
            "featureId": 4191,
            "deviceId": 327,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4192-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4192-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.297Z",
          "attributes": {
            "featureId": 4192,
            "deviceId": 327,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4193-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4193-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.298Z",
          "attributes": {
            "featureId": 4193,
            "deviceId": 327,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4194-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4194-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.298Z",
          "attributes": {
            "featureId": 4194,
            "deviceId": 327,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4195-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4195-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.298Z",
          "attributes": {
            "featureId": 4195,
            "deviceId": 327,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4196-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4196-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.298Z",
          "attributes": {
            "featureId": 4196,
            "deviceId": 327,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4197-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4197-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.298Z",
          "attributes": {
            "featureId": 4197,
            "deviceId": 327,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4198-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4198-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.299Z",
          "attributes": {
            "featureId": 4198,
            "deviceId": 327,
            "type": "relaySetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4199-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4199-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.299Z",
          "attributes": {
            "featureId": 4199,
            "deviceId": 327,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4200-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4200-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.299Z",
          "attributes": {
            "featureId": 4200,
            "deviceId": 327,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4201-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4201-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.300Z",
          "attributes": {
            "featureId": 4201,
            "deviceId": 327,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4202-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4202-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.300Z",
          "attributes": {
            "featureId": 4202,
            "deviceId": 327,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4203-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4203-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.300Z",
          "attributes": {
            "featureId": 4203,
            "deviceId": 327,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4204-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4204-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.300Z",
          "attributes": {
            "featureId": 4204,
            "deviceId": 327,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4205-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4205-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.300Z",
          "attributes": {
            "featureId": 4205,
            "deviceId": 327,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4206-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4206-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.301Z",
          "attributes": {
            "featureId": 4206,
            "deviceId": 327,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4207-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4207-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.301Z",
          "attributes": {
            "featureId": 4207,
            "deviceId": 327,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4208-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4208-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.301Z",
          "attributes": {
            "featureId": 4208,
            "deviceId": 327,
            "type": "humidity",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4209-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4209-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.301Z",
          "attributes": {
            "featureId": 4209,
            "deviceId": 327,
            "type": "targetHumidity",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4210-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4210-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.302Z",
          "attributes": {
            "featureId": 4210,
            "deviceId": 327,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4211-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4211-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.302Z",
          "attributes": {
            "featureId": 4211,
            "deviceId": 327,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4212-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4212-3157328415+0",
          "name": "Boiler switch",
          "deviceId": "59d505a0eea9e528ef444c61-327-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-621b8231782cc00b9ad95079"
          ],
          "createdDate": "2022-02-27T13:52:49.302Z",
          "attributes": {
            "featureId": 4212,
            "deviceId": 327,
            "type": "heatMode",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Boiler switch"
          }
        },
        "59d505a0eea9e528ef444c61-4332-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4332-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.286Z",
          "attributes": {
            "featureId": 4332,
            "deviceId": 331,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4333-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4333-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.286Z",
          "attributes": {
            "featureId": 4333,
            "deviceId": 331,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4334-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4334-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.286Z",
          "attributes": {
            "featureId": 4334,
            "deviceId": 331,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4335-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4335-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.287Z",
          "attributes": {
            "featureId": 4335,
            "deviceId": 331,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4336-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4336-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.287Z",
          "attributes": {
            "featureId": 4336,
            "deviceId": 331,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4337-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4337-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.287Z",
          "attributes": {
            "featureId": 4337,
            "deviceId": 331,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4338-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4338-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.288Z",
          "attributes": {
            "featureId": 4338,
            "deviceId": 331,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4339-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4339-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.288Z",
          "attributes": {
            "featureId": 4339,
            "deviceId": 331,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4340-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4340-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.288Z",
          "attributes": {
            "featureId": 4340,
            "deviceId": 331,
            "type": "relaySetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4341-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4341-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.288Z",
          "attributes": {
            "featureId": 4341,
            "deviceId": 331,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4342-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4342-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.289Z",
          "attributes": {
            "featureId": 4342,
            "deviceId": 331,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4343-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4343-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.289Z",
          "attributes": {
            "featureId": 4343,
            "deviceId": 331,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4344-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4344-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.289Z",
          "attributes": {
            "featureId": 4344,
            "deviceId": 331,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4345-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4345-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.289Z",
          "attributes": {
            "featureId": 4345,
            "deviceId": 331,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4346-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4346-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.290Z",
          "attributes": {
            "featureId": 4346,
            "deviceId": 331,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4347-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4347-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.290Z",
          "attributes": {
            "featureId": 4347,
            "deviceId": 331,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4348-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4348-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.290Z",
          "attributes": {
            "featureId": 4348,
            "deviceId": 331,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4349-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4349-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.290Z",
          "attributes": {
            "featureId": 4349,
            "deviceId": 331,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4350-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4350-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.291Z",
          "attributes": {
            "featureId": 4350,
            "deviceId": 331,
            "type": "humidity",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4351-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4351-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.291Z",
          "attributes": {
            "featureId": 4351,
            "deviceId": 331,
            "type": "targetHumidity",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4352-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4352-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.291Z",
          "attributes": {
            "featureId": 4352,
            "deviceId": 331,
            "type": "callForHeat",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4353-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4353-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.291Z",
          "attributes": {
            "featureId": 4353,
            "deviceId": 331,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-4354-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4354-3157328415+0",
          "name": "L92 uf",
          "deviceId": "59d505a0eea9e528ef444c61-331-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6221f1617c46e00b90acdbc9"
          ],
          "createdDate": "2022-03-04T11:00:49.292Z",
          "attributes": {
            "featureId": 4354,
            "deviceId": 331,
            "type": "heatMode",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L92 uf"
          }
        },
        "59d505a0eea9e528ef444c61-419-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-419-3157328415+0",
          "name": "Garage",
          "deviceId": "59d505a0eea9e528ef444c61-71-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab69887e5812644a36dd"
          ],
          "createdDate": "2018-05-11T14:40:41.889Z",
          "attributes": {
            "featureId": 419,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Garage"
          }
        },
        "59d505a0eea9e528ef444c61-420-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-420-3157328415+0",
          "name": "Garage",
          "deviceId": "59d505a0eea9e528ef444c61-71-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab69887e5812644a36dd"
          ],
          "createdDate": "2018-05-11T14:40:41.889Z",
          "attributes": {
            "featureId": 420,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Garage"
          }
        },
        "59d505a0eea9e528ef444c61-421-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-421-3157328415+0",
          "name": "Garage",
          "deviceId": "59d505a0eea9e528ef444c61-71-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab69887e5812644a36dd"
          ],
          "createdDate": "2018-05-11T14:40:41.890Z",
          "attributes": {
            "featureId": 421,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Garage"
          }
        },
        "59d505a0eea9e528ef444c61-988-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-988-3157328415+0",
          "name": "Garage",
          "deviceId": "59d505a0eea9e528ef444c61-71-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab69887e5812644a36dd"
          ],
          "createdDate": "2019-04-25T15:21:15.054Z",
          "attributes": {
            "featureId": 988,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Garage"
          }
        },
        "59d505a0eea9e528ef444c61-422-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-422-3157328415+0",
          "name": "Ivy",
          "deviceId": "59d505a0eea9e528ef444c61-72-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab97887e5812644a423c"
          ],
          "createdDate": "2018-05-11T14:41:27.088Z",
          "attributes": {
            "featureId": 422,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Ivy"
          }
        },
        "59d505a0eea9e528ef444c61-423-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-423-3157328415+0",
          "name": "Ivy",
          "deviceId": "59d505a0eea9e528ef444c61-72-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab97887e5812644a423c"
          ],
          "createdDate": "2018-05-11T14:41:27.088Z",
          "attributes": {
            "featureId": 423,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Ivy"
          }
        },
        "59d505a0eea9e528ef444c61-424-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-424-3157328415+0",
          "name": "Ivy",
          "deviceId": "59d505a0eea9e528ef444c61-72-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab97887e5812644a423c"
          ],
          "createdDate": "2018-05-11T14:41:27.088Z",
          "attributes": {
            "featureId": 424,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Ivy"
          }
        },
        "59d505a0eea9e528ef444c61-989-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-989-3157328415+0",
          "name": "Ivy",
          "deviceId": "59d505a0eea9e528ef444c61-72-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5ab97887e5812644a423c"
          ],
          "createdDate": "2019-04-25T15:21:15.136Z",
          "attributes": {
            "featureId": 989,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Ivy"
          }
        },
        "59d505a0eea9e528ef444c61-425-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-425-3157328415+0",
          "name": "Step",
          "deviceId": "59d505a0eea9e528ef444c61-73-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5abc0887e5812644a4bb6"
          ],
          "createdDate": "2018-05-11T14:42:08.263Z",
          "attributes": {
            "featureId": 425,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Step"
          }
        },
        "59d505a0eea9e528ef444c61-426-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-426-3157328415+0",
          "name": "Step",
          "deviceId": "59d505a0eea9e528ef444c61-73-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5abc0887e5812644a4bb6"
          ],
          "createdDate": "2018-05-11T14:42:08.264Z",
          "attributes": {
            "featureId": 426,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Step"
          }
        },
        "59d505a0eea9e528ef444c61-427-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-427-3157328415+0",
          "name": "Step",
          "deviceId": "59d505a0eea9e528ef444c61-73-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5abc0887e5812644a4bb6"
          ],
          "createdDate": "2018-05-11T14:42:08.265Z",
          "attributes": {
            "featureId": 427,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Step"
          }
        },
        "59d505a0eea9e528ef444c61-990-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-990-3157328415+0",
          "name": "Step",
          "deviceId": "59d505a0eea9e528ef444c61-73-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5af5abc0887e5812644a4bb6"
          ],
          "createdDate": "2019-04-25T15:21:15.238Z",
          "attributes": {
            "featureId": 990,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Step"
          }
        },
        "59d505a0eea9e528ef444c61-434-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-434-3157328415+0",
          "name": "Patio",
          "deviceId": "59d505a0eea9e528ef444c61-76-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5afa7b75887e5812645e263a"
          ],
          "createdDate": "2018-05-15T06:17:25.329Z",
          "attributes": {
            "featureId": 434,
            "writable": true,
            "channel": 0,
            "type": "switch",
            "status": "init",
            "name": "Patio"
          }
        },
        "59d505a0eea9e528ef444c61-435-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-435-3157328415+0",
          "name": "Patio",
          "deviceId": "59d505a0eea9e528ef444c61-76-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5afa7b75887e5812645e263a"
          ],
          "createdDate": "2018-05-15T06:17:25.329Z",
          "attributes": {
            "featureId": 435,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Patio"
          }
        },
        "59d505a0eea9e528ef444c61-436-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-436-3157328415+0",
          "name": "Patio",
          "deviceId": "59d505a0eea9e528ef444c61-76-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5afa7b75887e5812645e263a"
          ],
          "createdDate": "2018-05-15T06:17:25.330Z",
          "attributes": {
            "featureId": 436,
            "writable": true,
            "channel": 0,
            "type": "dimLevel",
            "status": "init",
            "name": "Patio"
          }
        },
        "59d505a0eea9e528ef444c61-993-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-993-3157328415+0",
          "name": "Patio",
          "deviceId": "59d505a0eea9e528ef444c61-76-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5afa7b75887e5812645e263a"
          ],
          "createdDate": "2019-04-25T15:21:15.503Z",
          "attributes": {
            "featureId": 993,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "unknown",
            "name": "Patio"
          }
        },
        "59d505a0eea9e528ef444c61-3762-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3762-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.955Z",
          "attributes": {
            "featureId": 3762,
            "deviceId": 291,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3763-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3763-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.955Z",
          "attributes": {
            "featureId": 3763,
            "deviceId": 291,
            "type": "socketSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3764-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3764-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.956Z",
          "attributes": {
            "featureId": 3764,
            "deviceId": 291,
            "type": "voltage",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3765-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3765-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.956Z",
          "attributes": {
            "featureId": 3765,
            "deviceId": 291,
            "type": "current",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3766-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3766-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.956Z",
          "attributes": {
            "featureId": 3766,
            "deviceId": 291,
            "type": "energy",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3767-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3767-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.957Z",
          "attributes": {
            "featureId": 3767,
            "deviceId": 291,
            "type": "power",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3768-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3768-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.957Z",
          "attributes": {
            "featureId": 3768,
            "deviceId": 291,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3769-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3769-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.957Z",
          "attributes": {
            "featureId": 3769,
            "deviceId": 291,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3770-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3770-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.957Z",
          "attributes": {
            "featureId": 3770,
            "deviceId": 291,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3771-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3771-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0"
          ],
          "createdDate": "2021-07-30T14:37:41.957Z",
          "attributes": {
            "featureId": 3771,
            "deviceId": 291,
            "type": "outletInUse",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3755-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3755-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.961Z",
          "attributes": {
            "featureId": 3755,
            "deviceId": 291,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3756-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3756-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.961Z",
          "attributes": {
            "featureId": 3756,
            "deviceId": 291,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3757-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3757-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.961Z",
          "attributes": {
            "featureId": 3757,
            "deviceId": 291,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3758-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3758-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.961Z",
          "attributes": {
            "featureId": 3758,
            "deviceId": 291,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3759-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3759-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.962Z",
          "attributes": {
            "featureId": 3759,
            "deviceId": 291,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3760-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3760-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.962Z",
          "attributes": {
            "featureId": 3760,
            "deviceId": 291,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3761-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3761-3157328415+0",
          "name": "G",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b0",
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.962Z",
          "attributes": {
            "featureId": 3761,
            "deviceId": 291,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G"
          }
        },
        "59d505a0eea9e528ef444c61-3772-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3772-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.958Z",
          "attributes": {
            "featureId": 3772,
            "deviceId": 291,
            "type": "switch",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3773-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3773-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.959Z",
          "attributes": {
            "featureId": 3773,
            "deviceId": 291,
            "type": "socketSetup",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3774-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3774-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.959Z",
          "attributes": {
            "featureId": 3774,
            "deviceId": 291,
            "type": "voltage",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3775-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3775-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.959Z",
          "attributes": {
            "featureId": 3775,
            "deviceId": 291,
            "type": "current",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3776-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3776-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.959Z",
          "attributes": {
            "featureId": 3776,
            "deviceId": 291,
            "type": "energy",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3777-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3777-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.960Z",
          "attributes": {
            "featureId": 3777,
            "deviceId": 291,
            "type": "power",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3778-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3778-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.960Z",
          "attributes": {
            "featureId": 3778,
            "deviceId": 291,
            "type": "uiButton",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3779-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3779-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.960Z",
          "attributes": {
            "featureId": 3779,
            "deviceId": 291,
            "type": "uiButtonPair",
            "channel": 1,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3780-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3780-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.960Z",
          "attributes": {
            "featureId": 3780,
            "deviceId": 291,
            "type": "protection",
            "channel": 1,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-3781-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3781-3157328415+0",
          "name": "G 1",
          "deviceId": "59d505a0eea9e528ef444c61-291-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61040eb54ba41f668b5fd1b1"
          ],
          "createdDate": "2021-07-30T14:37:41.960Z",
          "attributes": {
            "featureId": 3781,
            "deviceId": 291,
            "type": "outletInUse",
            "channel": 1,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "G 1"
          }
        },
        "59d505a0eea9e528ef444c61-4087-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4087-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.347Z",
          "attributes": {
            "featureId": 4087,
            "deviceId": 317,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4088-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4088-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.348Z",
          "attributes": {
            "featureId": 4088,
            "deviceId": 317,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4089-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4089-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.348Z",
          "attributes": {
            "featureId": 4089,
            "deviceId": 317,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4090-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4090-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.349Z",
          "attributes": {
            "featureId": 4090,
            "deviceId": 317,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4091-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4091-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.349Z",
          "attributes": {
            "featureId": 4091,
            "deviceId": 317,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4092-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4092-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.349Z",
          "attributes": {
            "featureId": 4092,
            "deviceId": 317,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4093-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4093-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.349Z",
          "attributes": {
            "featureId": 4093,
            "deviceId": 317,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4094-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4094-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.350Z",
          "attributes": {
            "featureId": 4094,
            "deviceId": 317,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4095-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4095-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.350Z",
          "attributes": {
            "featureId": 4095,
            "deviceId": 317,
            "type": "relaySetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4096-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4096-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.350Z",
          "attributes": {
            "featureId": 4096,
            "deviceId": 317,
            "type": "uiButton",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4097-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4097-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.350Z",
          "attributes": {
            "featureId": 4097,
            "deviceId": 317,
            "type": "uiButtonPair",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4098-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4098-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.351Z",
          "attributes": {
            "featureId": 4098,
            "deviceId": 317,
            "type": "uiDigitalInput",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4099-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4099-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.351Z",
          "attributes": {
            "featureId": 4099,
            "deviceId": 317,
            "type": "uiAnalogInput",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4100-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4100-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.351Z",
          "attributes": {
            "featureId": 4100,
            "deviceId": 317,
            "type": "uiIOMap",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4101-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4101-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.352Z",
          "attributes": {
            "featureId": 4101,
            "deviceId": 317,
            "type": "uiInputSetup",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4102-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4102-3157328415+0",
          "name": "L81m",
          "deviceId": "59d505a0eea9e528ef444c61-317-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-6202c571c3720f0b9fc63e5e"
          ],
          "createdDate": "2022-02-08T19:33:05.352Z",
          "attributes": {
            "featureId": 4102,
            "deviceId": 317,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "L81m"
          }
        },
        "59d505a0eea9e528ef444c61-4587-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4587-3157328415+0",
          "name": "Workshop",
          "deviceId": "59d505a0eea9e528ef444c61-346-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c0638e14a7cf0ba4e578de"
          ],
          "createdDate": "2022-07-02T15:26:06.638Z",
          "attributes": {
            "featureId": 4587,
            "deviceId": 346,
            "type": "switch",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Workshop"
          }
        },
        "59d505a0eea9e528ef444c61-4588-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4588-3157328415+0",
          "name": "Workshop",
          "deviceId": "59d505a0eea9e528ef444c61-346-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c0638e14a7cf0ba4e578de"
          ],
          "createdDate": "2022-07-02T15:26:06.639Z",
          "attributes": {
            "featureId": 4588,
            "deviceId": 346,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Workshop"
          }
        },
        "59d505a0eea9e528ef444c61-4589-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4589-3157328415+0",
          "name": "Workshop",
          "deviceId": "59d505a0eea9e528ef444c61-346-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62c0638e14a7cf0ba4e578de"
          ],
          "createdDate": "2022-07-02T15:26:06.639Z",
          "attributes": {
            "featureId": 4589,
            "deviceId": 346,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Workshop"
          }
        },
        "59d505a0eea9e528ef444c61-586-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-586-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2018-07-17T05:32:21.352Z",
          "attributes": {
            "featureId": 586,
            "writable": false,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-587-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-587-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2018-07-17T05:32:21.352Z",
          "attributes": {
            "featureId": 587,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-588-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-588-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2018-07-17T05:32:21.352Z",
          "attributes": {
            "featureId": 588,
            "writable": true,
            "channel": 0,
            "type": "valveLevel",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-589-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-589-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2018-07-17T05:32:21.353Z",
          "attributes": {
            "featureId": 589,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-590-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-590-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2018-07-17T05:32:21.353Z",
          "attributes": {
            "featureId": 590,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-591-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-591-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2018-07-17T05:32:21.353Z",
          "attributes": {
            "featureId": 591,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-972-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-972-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2019-04-25T15:21:15.855Z",
          "attributes": {
            "featureId": 972,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-973-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-973-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2019-04-25T15:21:15.855Z",
          "attributes": {
            "featureId": 973,
            "writable": false,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-1232-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1232-3157328415+0",
          "name": "Pipe temperature",
          "deviceId": "59d505a0eea9e528ef444c61-89-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5b4d7f65415f952873878df2"
          ],
          "createdDate": "2019-09-13T17:05:07.341Z",
          "attributes": {
            "featureId": 1232,
            "writable": false,
            "channel": 0,
            "type": "callForHeat",
            "status": "init",
            "name": "Pipe temperature"
          }
        },
        "59d505a0eea9e528ef444c61-678-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-678-3157328415+0",
          "name": "water monitor",
          "deviceId": "59d505a0eea9e528ef444c61-100-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5be80530b39e8164bbb02630"
          ],
          "createdDate": "2018-11-11T10:32:16.587Z",
          "attributes": {
            "featureId": 678,
            "writable": true,
            "channel": 0,
            "type": "pulseCounter",
            "status": "init",
            "name": "water monitor"
          },
          "measurement": {
            "meterType": "water",
            "unit": "m3",
            "tariff": 0.12,
            "pulseValue": 1
          }
        },
        "59d505a0eea9e528ef444c61-679-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-679-3157328415+0",
          "name": "water monitor",
          "deviceId": "59d505a0eea9e528ef444c61-100-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5be80530b39e8164bbb02630"
          ],
          "createdDate": "2018-11-11T10:32:16.587Z",
          "attributes": {
            "featureId": 679,
            "writable": true,
            "channel": 0,
            "type": "pulseCounterTotal",
            "status": "init",
            "name": "water monitor"
          },
          "measurement": {
            "meterType": "water",
            "unit": "m3",
            "tariff": 0.12,
            "pulseValue": 1
          }
        },
        "59d505a0eea9e528ef444c61-680-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-680-3157328415+0",
          "name": "water monitor",
          "deviceId": "59d505a0eea9e528ef444c61-100-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5be80530b39e8164bbb02630"
          ],
          "createdDate": "2018-11-11T10:32:16.588Z",
          "attributes": {
            "featureId": 680,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "water monitor"
          }
        },
        "59d505a0eea9e528ef444c61-976-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-976-3157328415+0",
          "name": "water monitor",
          "deviceId": "59d505a0eea9e528ef444c61-100-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5be80530b39e8164bbb02630"
          ],
          "createdDate": "2019-04-25T15:21:16.108Z",
          "attributes": {
            "featureId": 976,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "ok",
            "name": "water monitor"
          }
        },
        "59d505a0eea9e528ef444c61-1074-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1074-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.113Z",
          "attributes": {
            "featureId": 1074,
            "writable": false,
            "channel": 0,
            "type": "temperature",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1075-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1075-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.113Z",
          "attributes": {
            "featureId": 1075,
            "writable": true,
            "channel": 0,
            "type": "targetTemperature",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1076-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1076-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.113Z",
          "attributes": {
            "featureId": 1076,
            "writable": false,
            "channel": 0,
            "type": "rssi",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1077-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1077-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.114Z",
          "attributes": {
            "featureId": 1077,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1078-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1078-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.114Z",
          "attributes": {
            "featureId": 1078,
            "writable": true,
            "channel": 0,
            "type": "heatState",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1079-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1079-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.114Z",
          "attributes": {
            "featureId": 1079,
            "writable": true,
            "channel": 0,
            "type": "protection",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1080-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1080-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.114Z",
          "attributes": {
            "featureId": 1080,
            "writable": false,
            "channel": 0,
            "type": "batteryLevel",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1081-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1081-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.114Z",
          "attributes": {
            "featureId": 1081,
            "writable": true,
            "channel": 0,
            "type": "diagnostics",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1082-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1082-3157328415+0",
          "name": "Kitchen thermostat",
          "deviceId": "59d505a0eea9e528ef444c61-127-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5cdc610271a3af199f2dada4"
          ],
          "createdDate": "2019-05-15T18:57:06.115Z",
          "attributes": {
            "featureId": 1082,
            "writable": true,
            "channel": 0,
            "type": "upgrade",
            "status": "init",
            "name": "Kitchen thermostat"
          }
        },
        "59d505a0eea9e528ef444c61-1506-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1506-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.542Z",
          "attributes": {
            "featureId": 1506,
            "deviceId": 183,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1507-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1507-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.542Z",
          "attributes": {
            "featureId": 1507,
            "deviceId": 183,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1508-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1508-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.543Z",
          "attributes": {
            "featureId": 1508,
            "deviceId": 183,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1509-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1509-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.543Z",
          "attributes": {
            "featureId": 1509,
            "deviceId": 183,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1510-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1510-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.543Z",
          "attributes": {
            "featureId": 1510,
            "deviceId": 183,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1511-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1511-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.543Z",
          "attributes": {
            "featureId": 1511,
            "deviceId": 183,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1512-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1512-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.544Z",
          "attributes": {
            "featureId": 1512,
            "deviceId": 183,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1513-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1513-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.544Z",
          "attributes": {
            "featureId": 1513,
            "deviceId": 183,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1514-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1514-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.544Z",
          "attributes": {
            "featureId": 1514,
            "deviceId": 183,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1515-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1515-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.544Z",
          "attributes": {
            "featureId": 1515,
            "deviceId": 183,
            "type": "lightLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1516-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1516-3157328415+0",
          "name": "Pir 2",
          "deviceId": "59d505a0eea9e528ef444c61-183-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e1e097c85900419174fb3ec"
          ],
          "createdDate": "2020-01-14T18:33:32.544Z",
          "attributes": {
            "featureId": 1516,
            "deviceId": 183,
            "type": "movement",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 2"
          }
        },
        "59d505a0eea9e528ef444c61-1517-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1517-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.106Z",
          "attributes": {
            "featureId": 1517,
            "deviceId": 184,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1518-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1518-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.106Z",
          "attributes": {
            "featureId": 1518,
            "deviceId": 184,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1519-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1519-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.107Z",
          "attributes": {
            "featureId": 1519,
            "deviceId": 184,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1520-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1520-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.107Z",
          "attributes": {
            "featureId": 1520,
            "deviceId": 184,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1521-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1521-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.107Z",
          "attributes": {
            "featureId": 1521,
            "deviceId": 184,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1522-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1522-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.107Z",
          "attributes": {
            "featureId": 1522,
            "deviceId": 184,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1523-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1523-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.107Z",
          "attributes": {
            "featureId": 1523,
            "deviceId": 184,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1524-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1524-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.108Z",
          "attributes": {
            "featureId": 1524,
            "deviceId": 184,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1525-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1525-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.108Z",
          "attributes": {
            "featureId": 1525,
            "deviceId": 184,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1526-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1526-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.108Z",
          "attributes": {
            "featureId": 1526,
            "deviceId": 184,
            "type": "lightLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-1527-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1527-3157328415+0",
          "name": "Pir 3",
          "deviceId": "59d505a0eea9e528ef444c61-184-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5e2f277b12e25d2fa0e90f3b"
          ],
          "createdDate": "2020-01-27T18:10:03.108Z",
          "attributes": {
            "featureId": 1527,
            "deviceId": 184,
            "type": "movement",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "status": "init",
            "name": "Pir 3"
          }
        },
        "59d505a0eea9e528ef444c61-2338-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2338-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.027Z",
          "attributes": {
            "featureId": 2338,
            "deviceId": 234,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2339-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2339-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.027Z",
          "attributes": {
            "featureId": 2339,
            "deviceId": 234,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2340-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2340-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.028Z",
          "attributes": {
            "featureId": 2340,
            "deviceId": 234,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2341-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2341-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.028Z",
          "attributes": {
            "featureId": 2341,
            "deviceId": 234,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2342-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2342-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.028Z",
          "attributes": {
            "featureId": 2342,
            "deviceId": 234,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2343-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2343-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.028Z",
          "attributes": {
            "featureId": 2343,
            "deviceId": 234,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2344-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2344-3157328415+0",
          "name": "Lars1",
          "deviceId": "59d505a0eea9e528ef444c61-234-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f13440e2c0457d386802"
          ],
          "createdDate": "2020-11-30T13:18:44.028Z",
          "attributes": {
            "featureId": 2344,
            "deviceId": 234,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars1"
          }
        },
        "59d505a0eea9e528ef444c61-2352-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2352-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.363Z",
          "attributes": {
            "featureId": 2352,
            "deviceId": 236,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-2353-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2353-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.364Z",
          "attributes": {
            "featureId": 2353,
            "deviceId": 236,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-2354-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2354-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.364Z",
          "attributes": {
            "featureId": 2354,
            "deviceId": 236,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-2355-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2355-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.364Z",
          "attributes": {
            "featureId": 2355,
            "deviceId": 236,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-2356-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2356-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.364Z",
          "attributes": {
            "featureId": 2356,
            "deviceId": 236,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-2357-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2357-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.365Z",
          "attributes": {
            "featureId": 2357,
            "deviceId": 236,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-2358-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2358-3157328415+0",
          "name": "Lars2",
          "deviceId": "59d505a0eea9e528ef444c61-236-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5fc4f7330065880d598c2869"
          ],
          "createdDate": "2020-11-30T13:44:19.365Z",
          "attributes": {
            "featureId": 2358,
            "deviceId": 236,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Lars2"
          }
        },
        "59d505a0eea9e528ef444c61-3163-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3163-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.626Z",
          "attributes": {
            "featureId": 3163,
            "deviceId": 264,
            "type": "temperature",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3164-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3164-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.627Z",
          "attributes": {
            "featureId": 3164,
            "deviceId": 264,
            "type": "targetTemperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3165-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3165-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.627Z",
          "attributes": {
            "featureId": 3165,
            "deviceId": 264,
            "type": "rssi",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3166-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3166-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.627Z",
          "attributes": {
            "featureId": 3166,
            "deviceId": 264,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3167-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3167-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.628Z",
          "attributes": {
            "featureId": 3167,
            "deviceId": 264,
            "type": "heatState",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3168-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3168-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.628Z",
          "attributes": {
            "featureId": 3168,
            "deviceId": 264,
            "type": "protection",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3169-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3169-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.628Z",
          "attributes": {
            "featureId": 3169,
            "deviceId": 264,
            "type": "batteryLevel",
            "channel": 0,
            "writable": false,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3170-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3170-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.628Z",
          "attributes": {
            "featureId": 3170,
            "deviceId": 264,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3171-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3171-3157328415+0",
          "name": "H",
          "deviceId": "59d505a0eea9e528ef444c61-264-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-606d9618c041873fa93947ce"
          ],
          "createdDate": "2021-04-07T11:23:04.629Z",
          "attributes": {
            "featureId": 3171,
            "deviceId": 264,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "H"
          }
        },
        "59d505a0eea9e528ef444c61-3817-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3817-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.353Z",
          "attributes": {
            "featureId": 3817,
            "deviceId": 301,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3818-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3818-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.353Z",
          "attributes": {
            "featureId": 3818,
            "deviceId": 301,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3819-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3819-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.354Z",
          "attributes": {
            "featureId": 3819,
            "deviceId": 301,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3820-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3820-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.354Z",
          "attributes": {
            "featureId": 3820,
            "deviceId": 301,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3821-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3821-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.354Z",
          "attributes": {
            "featureId": 3821,
            "deviceId": 301,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3822-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3822-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.355Z",
          "attributes": {
            "featureId": 3822,
            "deviceId": 301,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3823-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3823-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.355Z",
          "attributes": {
            "featureId": 3823,
            "deviceId": 301,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3824-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3824-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.356Z",
          "attributes": {
            "featureId": 3824,
            "deviceId": 301,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3825-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3825-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.356Z",
          "attributes": {
            "featureId": 3825,
            "deviceId": 301,
            "type": "batteryLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3826-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3826-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.356Z",
          "attributes": {
            "featureId": 3826,
            "deviceId": 301,
            "type": "lightLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-3827-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3827-3157328415+0",
          "name": "Sens",
          "deviceId": "59d505a0eea9e528ef444c61-301-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-61670489798f3656f4b08084"
          ],
          "createdDate": "2021-10-13T16:08:41.357Z",
          "attributes": {
            "featureId": 3827,
            "deviceId": 301,
            "type": "movement",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "Sens"
          }
        },
        "59d505a0eea9e528ef444c61-4168-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4168-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.853Z",
          "attributes": {
            "featureId": 4168,
            "deviceId": 324,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4169-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4169-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.853Z",
          "attributes": {
            "featureId": 4169,
            "deviceId": 324,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4170-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4170-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.854Z",
          "attributes": {
            "featureId": 4170,
            "deviceId": 324,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4171-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4171-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.854Z",
          "attributes": {
            "featureId": 4171,
            "deviceId": 324,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4172-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4172-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.854Z",
          "attributes": {
            "featureId": 4172,
            "deviceId": 324,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4173-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4173-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.854Z",
          "attributes": {
            "featureId": 4173,
            "deviceId": 324,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4174-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4174-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.855Z",
          "attributes": {
            "featureId": 4174,
            "deviceId": 324,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4175-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4175-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.855Z",
          "attributes": {
            "featureId": 4175,
            "deviceId": 324,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4176-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4176-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.855Z",
          "attributes": {
            "featureId": 4176,
            "deviceId": 324,
            "type": "batteryLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4177-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4177-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.855Z",
          "attributes": {
            "featureId": 4177,
            "deviceId": 324,
            "type": "lightLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4178-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4178-3157328415+0",
          "name": "P22",
          "deviceId": "59d505a0eea9e528ef444c61-324-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179d81782cc00b9aced9f6"
          ],
          "createdDate": "2022-02-24T15:00:17.856Z",
          "attributes": {
            "featureId": 4178,
            "deviceId": 324,
            "type": "movement",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P22"
          }
        },
        "59d505a0eea9e528ef444c61-4179-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4179-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.949Z",
          "attributes": {
            "featureId": 4179,
            "deviceId": 325,
            "type": "identify",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4180-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4180-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.950Z",
          "attributes": {
            "featureId": 4180,
            "deviceId": 325,
            "type": "reset",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4181-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4181-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.951Z",
          "attributes": {
            "featureId": 4181,
            "deviceId": 325,
            "type": "upgrade",
            "channel": 0,
            "writable": true,
            "stateless": true,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4182-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4182-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.951Z",
          "attributes": {
            "featureId": 4182,
            "deviceId": 325,
            "type": "diagnostics",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4183-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4183-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.951Z",
          "attributes": {
            "featureId": 4183,
            "deviceId": 325,
            "type": "error",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4184-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4184-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.952Z",
          "attributes": {
            "featureId": 4184,
            "deviceId": 325,
            "type": "periodOfBroadcast",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4185-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4185-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.952Z",
          "attributes": {
            "featureId": 4185,
            "deviceId": 325,
            "type": "rgbColor",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4186-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4186-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.953Z",
          "attributes": {
            "featureId": 4186,
            "deviceId": 325,
            "type": "temperature",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4187-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4187-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.953Z",
          "attributes": {
            "featureId": 4187,
            "deviceId": 325,
            "type": "batteryLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4188-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4188-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.953Z",
          "attributes": {
            "featureId": 4188,
            "deviceId": 325,
            "type": "lightLevel",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-4189-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4189-3157328415+0",
          "name": "P33",
          "deviceId": "59d505a0eea9e528ef444c61-325-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-62179e827c46e00b907b813d"
          ],
          "createdDate": "2022-02-24T15:04:34.954Z",
          "attributes": {
            "featureId": 4189,
            "deviceId": 325,
            "type": "movement",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": false,
            "status": "init",
            "name": "P33"
          }
        },
        "59d505a0eea9e528ef444c61-1-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.309Z",
          "attributes": {
            "featureId": 1,
            "writable": true,
            "channel": 0,
            "type": "currentTime",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-2-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.310Z",
          "attributes": {
            "featureId": 2,
            "writable": false,
            "channel": 0,
            "type": "buttonPress",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-3-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-3-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.310Z",
          "attributes": {
            "featureId": 3,
            "writable": false,
            "channel": 0,
            "type": "time",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-4-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-4-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.311Z",
          "attributes": {
            "featureId": 4,
            "writable": false,
            "channel": 0,
            "type": "date",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-5-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-5-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.311Z",
          "attributes": {
            "featureId": 5,
            "writable": false,
            "channel": 0,
            "type": "monthArray",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-6-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-6-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.311Z",
          "attributes": {
            "featureId": 6,
            "writable": false,
            "channel": 0,
            "type": "weekdayArray",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-7-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-7-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.312Z",
          "attributes": {
            "featureId": 7,
            "writable": true,
            "channel": 0,
            "type": "timeZone",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-8-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-8-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.312Z",
          "attributes": {
            "featureId": 8,
            "writable": true,
            "channel": 0,
            "type": "locationLongitude",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-9-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-9-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.312Z",
          "attributes": {
            "featureId": 9,
            "writable": true,
            "channel": 0,
            "type": "locationLatitude",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-10-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-10-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.313Z",
          "attributes": {
            "featureId": 10,
            "writable": true,
            "channel": 0,
            "type": "duskTime",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-11-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-11-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-10-04T16:00:32.313Z",
          "attributes": {
            "featureId": 11,
            "writable": true,
            "channel": 0,
            "type": "dawnTime",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-338-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-338-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2017-12-12T17:24:40.623Z",
          "attributes": {
            "featureId": 338,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-595-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-595-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2018-08-20T16:11:03.965Z",
          "attributes": {
            "featureId": 595,
            "writable": false,
            "channel": 0,
            "type": "day",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-596-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-596-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2018-08-20T16:11:03.965Z",
          "attributes": {
            "featureId": 596,
            "writable": false,
            "channel": 0,
            "type": "month",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-597-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-597-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2018-08-20T16:11:03.966Z",
          "attributes": {
            "featureId": 597,
            "writable": false,
            "channel": 0,
            "type": "year",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-730-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-730-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2019-01-21T15:00:55.419Z",
          "attributes": {
            "featureId": 730,
            "writable": false,
            "channel": 0,
            "type": "weekday",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-1001-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-1001-3157328415+0",
          "name": "LinkPlus",
          "deviceId": "59d505a0eea9e528ef444c61-1-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c6a"
          ],
          "createdDate": "2019-05-06T16:31:46.073Z",
          "attributes": {
            "featureId": 1001,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "LinkPlus"
          }
        },
        "59d505a0eea9e528ef444c61-2031-3157328415+0": {
          "featureId": "59d505a0eea9e528ef444c61-2031-3157328415+0",
          "name": "John's iphone 11",
          "deviceId": "59d505a0eea9e528ef444c61-210-3157328415+0",
          "groups": [
            "59d505a0eea9e528ef444c61-5f857f4ff9fae20d592648ea"
          ],
          "createdDate": "2020-10-13T10:19:59.122Z",
          "attributes": {
            "featureId": 2031,
            "deviceId": 822083844,
            "type": "withinRadius",
            "channel": 0,
            "writable": true,
            "stateless": false,
            "virtual": true,
            "status": "lastKnown",
            "name": "John's iphone 11"
          },
          "geoFence": {
            "featureId": "59d505a0eea9e528ef444c61-2031-3157328415+0",
            "name": "House",
            "latitude": 52.543624,
            "longitude": -1.97885,
            "radius": 200
          }
        },
        "5dd7f8f91270730572ffa48f-1-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.023Z",
          "attributes": {
            "featureId": 1,
            "writable": false,
            "channel": 0,
            "type": "currentTime",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-2-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-2-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.023Z",
          "attributes": {
            "featureId": 2,
            "writable": false,
            "channel": 0,
            "type": "buttonPress",
            "status": "init",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-3-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-3-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.024Z",
          "attributes": {
            "featureId": 3,
            "writable": false,
            "channel": 0,
            "type": "time",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-4-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-4-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.024Z",
          "attributes": {
            "featureId": 4,
            "writable": false,
            "channel": 0,
            "type": "date",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-5-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-5-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.024Z",
          "attributes": {
            "featureId": 5,
            "writable": false,
            "channel": 0,
            "type": "monthArray",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-6-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-6-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.024Z",
          "attributes": {
            "featureId": 6,
            "writable": false,
            "channel": 0,
            "type": "weekdayArray",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-7-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-7-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.025Z",
          "attributes": {
            "featureId": 7,
            "writable": true,
            "channel": 0,
            "type": "timeZone",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-8-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-8-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.025Z",
          "attributes": {
            "featureId": 8,
            "writable": true,
            "channel": 0,
            "type": "locationLongitude",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-9-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-9-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.025Z",
          "attributes": {
            "featureId": 9,
            "writable": true,
            "channel": 0,
            "type": "locationLatitude",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-10-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-10-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.025Z",
          "attributes": {
            "featureId": 10,
            "writable": false,
            "channel": 0,
            "type": "duskTime",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-11-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-11-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.025Z",
          "attributes": {
            "featureId": 11,
            "writable": false,
            "channel": 0,
            "type": "dawnTime",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-12-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-12-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.026Z",
          "attributes": {
            "featureId": 12,
            "writable": true,
            "channel": 0,
            "type": "rgbColor",
            "status": "init",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-13-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-13-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.026Z",
          "attributes": {
            "featureId": 13,
            "writable": false,
            "channel": 0,
            "type": "day",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-14-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-14-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.026Z",
          "attributes": {
            "featureId": 14,
            "writable": false,
            "channel": 0,
            "type": "month",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-15-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-15-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.026Z",
          "attributes": {
            "featureId": 15,
            "writable": false,
            "channel": 0,
            "type": "year",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-16-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-16-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.026Z",
          "attributes": {
            "featureId": 16,
            "writable": false,
            "channel": 0,
            "type": "weekday",
            "status": "ok",
            "name": "LinkPlus"
          }
        },
        "5dd7f8f91270730572ffa48f-17-3157338507+2": {
          "featureId": "5dd7f8f91270730572ffa48f-17-3157338507+2",
          "name": "LinkPlus",
          "deviceId": "5dd7f8f91270730572ffa48f-1-3157338507+2",
          "groups": [
            "5dd7f8f91270730572ffa48f-5dd7f9231270730572ffa4b4"
          ],
          "createdDate": "2019-11-22T15:05:07.027Z",
          "attributes": {
            "featureId": 17,
            "writable": true,
            "channel": 0,
            "type": "identify",
            "status": "init",
            "name": "LinkPlus"
          }
        }
      },
      "rooms": [
        {
          "groupId": "1000",
          "name": "Living Room",
          "type": "room",
          "parentGroups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c66"
          ],
          "visible": true,
          "order": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3",
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
          ],
          "featureSets": [
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
            "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
            "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3",
            "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3",
            "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
          ],
          "automationSets": []
        },
        {
          "groupId": "1001",
          "name": "Kitchen",
          "type": "room",
          "parentGroups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c66"
          ],
          "visible": true,
          "order": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "featureSets": [
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee",
            "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
            "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "automationSets": []
        },
        {
          "groupId": "1002",
          "name": "Bedroom",
          "type": "room",
          "parentGroups": [
            "59d505a0eea9e528ef444c61-59d505a0eea9e528ef444c66"
          ],
          "visible": true,
          "order": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43",
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "featureSets": [
            "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
            "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43",
            "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "automationSets": []
        },
      ],
      "devices": {
        "5dd7f8f91270730572ffa48f-1-3157338507+2" :{
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "name": "Porch",
          "paired": true,
          "productCode": "L22",
          "createdDate": "2019-02-07T09:41:55.562Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-771-3157328415+0",
              "59d505a0eea9e528ef444c61-772-3157328415+0",
              "59d505a0eea9e528ef444c61-773-3157328415+0",
              "59d505a0eea9e528ef444c61-774-3157328415+0",
              "59d505a0eea9e528ef444c61-775-3157328415+0",
              "59d505a0eea9e528ef444c61-776-3157328415+0",
              "59d505a0eea9e528ef444c61-777-3157328415+0",
              "59d505a0eea9e528ef444c61-778-3157328415+0",
              "59d505a0eea9e528ef444c61-779-3157328415+0",
              "59d505a0eea9e528ef444c61-780-3157328415+0",
              "59d505a0eea9e528ef444c61-781-3157328415+0",
              "59d505a0eea9e528ef444c61-782-3157328415+0",
              "59d505a0eea9e528ef444c61-783-3157328415+0",
              "59d505a0eea9e528ef444c61-784-3157328415+0",
              "59d505a0eea9e528ef444c61-785-3157328415+0",
              "59d505a0eea9e528ef444c61-786-3157328415+0",
              "59d505a0eea9e528ef444c61-787-3157328415+0",
              "59d505a0eea9e528ef444c61-788-3157328415+0",
              "59d505a0eea9e528ef444c61-789-3157328415+0",
              "59d505a0eea9e528ef444c61-790-3157328415+0",
              "59d505a0eea9e528ef444c61-3090-3157328415+0",
              "59d505a0eea9e528ef444c61-3091-3157328415+0",
              "59d505a0eea9e528ef444c61-3092-3157328415+0",
              "59d505a0eea9e528ef444c61-3093-3157328415+0",
              "59d505a0eea9e528ef444c61-3094-3157328415+0",
              "59d505a0eea9e528ef444c61-3095-3157328415+0",
              "59d505a0eea9e528ef444c61-3096-3157328415+0",
              "59d505a0eea9e528ef444c61-3097-3157328415+0",
              "59d505a0eea9e528ef444c61-3098-3157328415+0",
              "59d505a0eea9e528ef444c61-3099-3157328415+0",
              "59d505a0eea9e528ef444c61-3100-3157328415+0",
              "59d505a0eea9e528ef444c61-3101-3157328415+0",
              "59d505a0eea9e528ef444c61-3102-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
              "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "icon": "icon-l22_dimmer_2gang"
        },
        "59d505a0eea9e528ef444c61-342-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-342-3157328415+0",
          "name": "Main bed",
          "paired": true,
          "productCode": "L22EU",
          "createdDate": "2022-03-23T18:30:29.765Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-4483-3157328415+0",
              "59d505a0eea9e528ef444c61-4484-3157328415+0",
              "59d505a0eea9e528ef444c61-4485-3157328415+0",
              "59d505a0eea9e528ef444c61-4486-3157328415+0",
              "59d505a0eea9e528ef444c61-4487-3157328415+0",
              "59d505a0eea9e528ef444c61-4488-3157328415+0",
              "59d505a0eea9e528ef444c61-4489-3157328415+0",
              "59d505a0eea9e528ef444c61-4490-3157328415+0",
              "59d505a0eea9e528ef444c61-4491-3157328415+0",
              "59d505a0eea9e528ef444c61-4492-3157328415+0",
              "59d505a0eea9e528ef444c61-4493-3157328415+0",
              "59d505a0eea9e528ef444c61-4494-3157328415+0",
              "59d505a0eea9e528ef444c61-4495-3157328415+0",
              "59d505a0eea9e528ef444c61-4496-3157328415+0",
              "59d505a0eea9e528ef444c61-4497-3157328415+0",
              "59d505a0eea9e528ef444c61-4498-3157328415+0",
              "59d505a0eea9e528ef444c61-4499-3157328415+0",
              "59d505a0eea9e528ef444c61-4500-3157328415+0",
              "59d505a0eea9e528ef444c61-4501-3157328415+0",
              "59d505a0eea9e528ef444c61-4502-3157328415+0",
              "59d505a0eea9e528ef444c61-4503-3157328415+0",
              "59d505a0eea9e528ef444c61-4504-3157328415+0",
              "59d505a0eea9e528ef444c61-4505-3157328415+0",
              "59d505a0eea9e528ef444c61-4506-3157328415+0",
              "59d505a0eea9e528ef444c61-4507-3157328415+0",
              "59d505a0eea9e528ef444c61-4508-3157328415+0",
              "59d505a0eea9e528ef444c61-4509-3157328415+0",
              "59d505a0eea9e528ef444c61-4510-3157328415+0",
              "59d505a0eea9e528ef444c61-4511-3157328415+0",
              "59d505a0eea9e528ef444c61-4512-3157328415+0",
              "59d505a0eea9e528ef444c61-4513-3157328415+0",
              "59d505a0eea9e528ef444c61-4514-3157328415+0",
              "59d505a0eea9e528ef444c61-4515-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-623b674559b51614b16db8ed",
              "59d505a0eea9e528ef444c61-623b674559b51614b16db8ee"
          ],
          "icon": "icon-l22_dimmer_2gang"
        },
        "59d505a0eea9e528ef444c61-223-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-223-3157328415+0",
          "name": "F 3",
          "paired": true,
          "productCode": "L42",
          "createdDate": "2020-10-28T18:24:30.925Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-2102-3157328415+0",
              "59d505a0eea9e528ef444c61-2103-3157328415+0",
              "59d505a0eea9e528ef444c61-2104-3157328415+0",
              "59d505a0eea9e528ef444c61-2105-3157328415+0",
              "59d505a0eea9e528ef444c61-2106-3157328415+0",
              "59d505a0eea9e528ef444c61-2107-3157328415+0",
              "59d505a0eea9e528ef444c61-2108-3157328415+0",
              "59d505a0eea9e528ef444c61-2109-3157328415+0",
              "59d505a0eea9e528ef444c61-2110-3157328415+0",
              "59d505a0eea9e528ef444c61-2111-3157328415+0",
              "59d505a0eea9e528ef444c61-2112-3157328415+0",
              "59d505a0eea9e528ef444c61-2113-3157328415+0",
              "59d505a0eea9e528ef444c61-2114-3157328415+0",
              "59d505a0eea9e528ef444c61-2115-3157328415+0",
              "59d505a0eea9e528ef444c61-2116-3157328415+0",
              "59d505a0eea9e528ef444c61-2117-3157328415+0",
              "59d505a0eea9e528ef444c61-2118-3157328415+0",
              "59d505a0eea9e528ef444c61-2119-3157328415+0",
              "59d505a0eea9e528ef444c61-2120-3157328415+0",
              "59d505a0eea9e528ef444c61-2121-3157328415+0",
              "59d505a0eea9e528ef444c61-2122-3157328415+0",
              "59d505a0eea9e528ef444c61-2123-3157328415+0",
              "59d505a0eea9e528ef444c61-2124-3157328415+0",
              "59d505a0eea9e528ef444c61-2125-3157328415+0",
              "59d505a0eea9e528ef444c61-2126-3157328415+0",
              "59d505a0eea9e528ef444c61-2127-3157328415+0",
              "59d505a0eea9e528ef444c61-2128-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd2",
              "59d505a0eea9e528ef444c61-5f99b75e8d3fe70df39b4bd3"
          ],
          "icon": "icon-l42_socket_2gang"
        },
        "59d505a0eea9e528ef444c61-83-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-83-3157328415+0",
          "name": "Washing machine",
          "paired": true,
          "productCode": "L42",
          "createdDate": "2018-07-01T14:53:17.944Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-534-3157328415+0",
              "59d505a0eea9e528ef444c61-535-3157328415+0",
              "59d505a0eea9e528ef444c61-536-3157328415+0",
              "59d505a0eea9e528ef444c61-537-3157328415+0",
              "59d505a0eea9e528ef444c61-538-3157328415+0",
              "59d505a0eea9e528ef444c61-539-3157328415+0",
              "59d505a0eea9e528ef444c61-540-3157328415+0",
              "59d505a0eea9e528ef444c61-541-3157328415+0",
              "59d505a0eea9e528ef444c61-542-3157328415+0",
              "59d505a0eea9e528ef444c61-543-3157328415+0",
              "59d505a0eea9e528ef444c61-544-3157328415+0",
              "59d505a0eea9e528ef444c61-545-3157328415+0",
              "59d505a0eea9e528ef444c61-546-3157328415+0",
              "59d505a0eea9e528ef444c61-547-3157328415+0",
              "59d505a0eea9e528ef444c61-548-3157328415+0",
              "59d505a0eea9e528ef444c61-549-3157328415+0",
              "59d505a0eea9e528ef444c61-550-3157328415+0",
              "59d505a0eea9e528ef444c61-1787-3157328415+0",
              "59d505a0eea9e528ef444c61-1788-3157328415+0",
              "59d505a0eea9e528ef444c61-1789-3157328415+0",
              "59d505a0eea9e528ef444c61-1790-3157328415+0",
              "59d505a0eea9e528ef444c61-1791-3157328415+0",
              "59d505a0eea9e528ef444c61-1792-3157328415+0",
              "59d505a0eea9e528ef444c61-1793-3157328415+0",
              "59d505a0eea9e528ef444c61-1794-3157328415+0",
              "59d505a0eea9e528ef444c61-1795-3157328415+0",
              "59d505a0eea9e528ef444c61-1796-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b2",
              "59d505a0eea9e528ef444c61-5b38eadd118ab263afca82b3"
          ],
          "icon": "icon-l42_socket_2gang"
        },
        "59d505a0eea9e528ef444c61-112-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-112-3157328415+0",
          "name": "Bed 1",
          "paired": true,
          "productCode": "L21",
          "createdDate": "2019-02-16T08:09:26.589Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-866-3157328415+0",
              "59d505a0eea9e528ef444c61-867-3157328415+0",
              "59d505a0eea9e528ef444c61-868-3157328415+0",
              "59d505a0eea9e528ef444c61-869-3157328415+0",
              "59d505a0eea9e528ef444c61-870-3157328415+0",
              "59d505a0eea9e528ef444c61-871-3157328415+0",
              "59d505a0eea9e528ef444c61-872-3157328415+0",
              "59d505a0eea9e528ef444c61-873-3157328415+0",
              "59d505a0eea9e528ef444c61-874-3157328415+0",
              "59d505a0eea9e528ef444c61-875-3157328415+0",
              "59d505a0eea9e528ef444c61-876-3157328415+0",
              "59d505a0eea9e528ef444c61-877-3157328415+0",
              "59d505a0eea9e528ef444c61-878-3157328415+0",
              "59d505a0eea9e528ef444c61-3037-3157328415+0",
              "59d505a0eea9e528ef444c61-3038-3157328415+0",
              "59d505a0eea9e528ef444c61-3039-3157328415+0",
              "59d505a0eea9e528ef444c61-3040-3157328415+0",
              "59d505a0eea9e528ef444c61-3041-3157328415+0",
              "59d505a0eea9e528ef444c61-3042-3157328415+0",
              "59d505a0eea9e528ef444c61-3043-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5c67c536057e67216c8b6030"
          ],
          "icon": "icon-l21_dimmer_1gang"
        },
        "59d505a0eea9e528ef444c61-225-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-225-3157328415+0",
          "name": "Worktop",
          "paired": true,
          "productCode": "L42",
          "createdDate": "2020-11-02T13:02:23.157Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-2156-3157328415+0",
              "59d505a0eea9e528ef444c61-2157-3157328415+0",
              "59d505a0eea9e528ef444c61-2158-3157328415+0",
              "59d505a0eea9e528ef444c61-2159-3157328415+0",
              "59d505a0eea9e528ef444c61-2160-3157328415+0",
              "59d505a0eea9e528ef444c61-2161-3157328415+0",
              "59d505a0eea9e528ef444c61-2162-3157328415+0",
              "59d505a0eea9e528ef444c61-2163-3157328415+0",
              "59d505a0eea9e528ef444c61-2164-3157328415+0",
              "59d505a0eea9e528ef444c61-2165-3157328415+0",
              "59d505a0eea9e528ef444c61-2166-3157328415+0",
              "59d505a0eea9e528ef444c61-2167-3157328415+0",
              "59d505a0eea9e528ef444c61-2168-3157328415+0",
              "59d505a0eea9e528ef444c61-2169-3157328415+0",
              "59d505a0eea9e528ef444c61-2170-3157328415+0",
              "59d505a0eea9e528ef444c61-2171-3157328415+0",
              "59d505a0eea9e528ef444c61-2172-3157328415+0",
              "59d505a0eea9e528ef444c61-2173-3157328415+0",
              "59d505a0eea9e528ef444c61-2174-3157328415+0",
              "59d505a0eea9e528ef444c61-2175-3157328415+0",
              "59d505a0eea9e528ef444c61-2176-3157328415+0",
              "59d505a0eea9e528ef444c61-2177-3157328415+0",
              "59d505a0eea9e528ef444c61-2178-3157328415+0",
              "59d505a0eea9e528ef444c61-2179-3157328415+0",
              "59d505a0eea9e528ef444c61-2180-3157328415+0",
              "59d505a0eea9e528ef444c61-2181-3157328415+0",
              "59d505a0eea9e528ef444c61-2182-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f42",
              "59d505a0eea9e528ef444c61-5fa0035fa74d380d72e64f43"
          ],
          "icon": "icon-l42_socket_2gang"
        },
        "59d505a0eea9e528ef444c61-85-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-85-3157328415+0",
          "name": "Fridge",
          "paired": true,
          "productCode": "L42",
          "createdDate": "2018-07-01T16:36:47.329Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-557-3157328415+0",
              "59d505a0eea9e528ef444c61-558-3157328415+0",
              "59d505a0eea9e528ef444c61-559-3157328415+0",
              "59d505a0eea9e528ef444c61-560-3157328415+0",
              "59d505a0eea9e528ef444c61-561-3157328415+0",
              "59d505a0eea9e528ef444c61-562-3157328415+0",
              "59d505a0eea9e528ef444c61-563-3157328415+0",
              "59d505a0eea9e528ef444c61-564-3157328415+0",
              "59d505a0eea9e528ef444c61-565-3157328415+0",
              "59d505a0eea9e528ef444c61-566-3157328415+0",
              "59d505a0eea9e528ef444c61-567-3157328415+0",
              "59d505a0eea9e528ef444c61-568-3157328415+0",
              "59d505a0eea9e528ef444c61-569-3157328415+0",
              "59d505a0eea9e528ef444c61-570-3157328415+0",
              "59d505a0eea9e528ef444c61-571-3157328415+0",
              "59d505a0eea9e528ef444c61-572-3157328415+0",
              "59d505a0eea9e528ef444c61-573-3157328415+0",
              "59d505a0eea9e528ef444c61-1757-3157328415+0",
              "59d505a0eea9e528ef444c61-1758-3157328415+0",
              "59d505a0eea9e528ef444c61-1759-3157328415+0",
              "59d505a0eea9e528ef444c61-1760-3157328415+0",
              "59d505a0eea9e528ef444c61-1761-3157328415+0",
              "59d505a0eea9e528ef444c61-1762-3157328415+0",
              "59d505a0eea9e528ef444c61-1763-3157328415+0",
              "59d505a0eea9e528ef444c61-1764-3157328415+0",
              "59d505a0eea9e528ef444c61-1765-3157328415+0",
              "59d505a0eea9e528ef444c61-1766-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c",
              "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d"
          ],
          "icon": "icon-l42_socket_2gang"
        },
        "59d505a0eea9e528ef444c61-108-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-108-3157328415+0",
          "name": "Porch",
          "paired": true,
          "productCode": "L22",
          "createdDate": "2019-02-07T09:41:55.562Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-771-3157328415+0",
              "59d505a0eea9e528ef444c61-772-3157328415+0",
              "59d505a0eea9e528ef444c61-773-3157328415+0",
              "59d505a0eea9e528ef444c61-774-3157328415+0",
              "59d505a0eea9e528ef444c61-775-3157328415+0",
              "59d505a0eea9e528ef444c61-776-3157328415+0",
              "59d505a0eea9e528ef444c61-777-3157328415+0",
              "59d505a0eea9e528ef444c61-778-3157328415+0",
              "59d505a0eea9e528ef444c61-779-3157328415+0",
              "59d505a0eea9e528ef444c61-780-3157328415+0",
              "59d505a0eea9e528ef444c61-781-3157328415+0",
              "59d505a0eea9e528ef444c61-782-3157328415+0",
              "59d505a0eea9e528ef444c61-783-3157328415+0",
              "59d505a0eea9e528ef444c61-784-3157328415+0",
              "59d505a0eea9e528ef444c61-785-3157328415+0",
              "59d505a0eea9e528ef444c61-786-3157328415+0",
              "59d505a0eea9e528ef444c61-787-3157328415+0",
              "59d505a0eea9e528ef444c61-788-3157328415+0",
              "59d505a0eea9e528ef444c61-789-3157328415+0",
              "59d505a0eea9e528ef444c61-790-3157328415+0",
              "59d505a0eea9e528ef444c61-3090-3157328415+0",
              "59d505a0eea9e528ef444c61-3091-3157328415+0",
              "59d505a0eea9e528ef444c61-3092-3157328415+0",
              "59d505a0eea9e528ef444c61-3093-3157328415+0",
              "59d505a0eea9e528ef444c61-3094-3157328415+0",
              "59d505a0eea9e528ef444c61-3095-3157328415+0",
              "59d505a0eea9e528ef444c61-3096-3157328415+0",
              "59d505a0eea9e528ef444c61-3097-3157328415+0",
              "59d505a0eea9e528ef444c61-3098-3157328415+0",
              "59d505a0eea9e528ef444c61-3099-3157328415+0",
              "59d505a0eea9e528ef444c61-3100-3157328415+0",
              "59d505a0eea9e528ef444c61-3101-3157328415+0",
              "59d505a0eea9e528ef444c61-3102-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b3",
              "59d505a0eea9e528ef444c61-5c5bfd63f9d05f3d83c427b4"
          ],
          "icon": "icon-l22_dimmer_2gang"
        },
        "59d505a0eea9e528ef444c61-302-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-302-3157328415+0",
          "name": "Hall TRV",
          "paired": true,
          "productCode": "HR92",
          "createdDate": "2021-10-25T17:08:11.841Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-3828-3157328415+0",
              "59d505a0eea9e528ef444c61-3829-3157328415+0",
              "59d505a0eea9e528ef444c61-3830-3157328415+0",
              "59d505a0eea9e528ef444c61-3831-3157328415+0",
              "59d505a0eea9e528ef444c61-3832-3157328415+0",
              "59d505a0eea9e528ef444c61-3833-3157328415+0",
              "59d505a0eea9e528ef444c61-3834-3157328415+0",
              "59d505a0eea9e528ef444c61-3835-3157328415+0",
              "59d505a0eea9e528ef444c61-3836-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-6176e47bf130e15ac4089ea1"
          ],
          "icon": "icon-signal_0"
        },
        "59d505a0eea9e528ef444c61-167-3157328415+0": {
          "deviceId": "59d505a0eea9e528ef444c61-167-3157328415+0",
          "name": "Trv dining",
          "paired": true,
          "productCode": "HR92",
          "createdDate": "2019-10-14T17:22:34.299Z",
          "featureIds": [
              "59d505a0eea9e528ef444c61-1355-3157328415+0",
              "59d505a0eea9e528ef444c61-1356-3157328415+0",
              "59d505a0eea9e528ef444c61-1357-3157328415+0",
              "59d505a0eea9e528ef444c61-1358-3157328415+0",
              "59d505a0eea9e528ef444c61-1359-3157328415+0",
              "59d505a0eea9e528ef444c61-1360-3157328415+0",
              "59d505a0eea9e528ef444c61-1361-3157328415+0",
              "59d505a0eea9e528ef444c61-1362-3157328415+0",
              "59d505a0eea9e528ef444c61-1530-3157328415+0"
          ],
          "featureSetGroupIds": [
              "59d505a0eea9e528ef444c61-5da4aeda1003e5429798dc0c"
          ],
          "icon": "icon-signal_0"
        }
      },
      "allDevices": [],
      "temperatureFeatureSets": {},
      "energyFeatureSets": {},
      "switchFeatureSets": {},
      "deviceTypes": {
        "Smart Dimmer": 0,
        "Smart Heating": 0,
        "Smart Socket": 0,
        "Link Plus": 1
      },
    }

    return demoStructure;
  }

  demoCalculateTotals() {
    const demoStructure = this.getDemoStructure();
    let totals = {
      total: '0',
      monthly_total: '0'
    };
    demoStructure.featureSetsWithData.forEach(featureSet => {
        totals.total = totals.total + featureSet.total;
        totals.monthly_total = totals.monthly_total + featureSet.monthly_total;
    });
    return totals;
  }

  getHourlyAverage() {
    const hourlyArr = [
      {timestamp: 1659398400000, value: 0},
      {timestamp: 1659402000000, value: 0},
      {timestamp: 1659405600000, value: 0},
      {timestamp: 1659409200000, value: 0},
      {timestamp: 1659412800000, value: 0},
      {timestamp: 1659416400000, value: 0},
      {timestamp: 1659420000000, value: 0},
      {timestamp: 1659423600000, value: 0},
      {timestamp: 1659427200000, value: 0},
      {timestamp: 1659430800000, value: 0},
      {timestamp: 1659434400000, value: 0},
      {timestamp: 1659438000000, value: 0},
      {timestamp: 1659441600000, value: 0},
      {timestamp: 1659445200000, value: 0},
      {timestamp: 1659448800000, value: 0},
      {timestamp: 1659452400000, value: 0},
      {timestamp: 1659456000000, value: 0},
      {timestamp: 1659459600000, value: 0},
      {timestamp: 1659463200000, value: 0},
      {timestamp: 1659466800000, value: 0},
      {timestamp: 1659470400000, value: 0},
      {timestamp: 1659474000000, value: 0},
      {timestamp: 1659477600000, value: 0},
      {timestamp: 1659481200000, value: 0},
    ];
    const finishedArr = hourlyArr.map(item => {
      item.value = this.getRandomInt(30, 120)
      return item;
    })
    return finishedArr;
  }

  getDailyUsage(groupId) {
    const dataObj = {
      "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73d": [
        {
            "timestamp": 1657941611000,
            "value": 5
        },
        {
            "timestamp": 1657948878000,
            "value": 102
        },
        {
            "timestamp": 1658002265000,
            "value": 99
        },
        {
            "timestamp": 1658005899000,
            "value": 102
        },
        {
            "timestamp": 1658009532000,
            "value": 99
        },
        {
            "timestamp": 1658015279000,
            "value": 102
        },
        {
            "timestamp": 1658050521000,
            "value": 95
        },
        {
            "timestamp": 1658054154000,
            "value": 92
        },
        {
            "timestamp": 1658074673000,
            "value": 89
        },
        {
            "timestamp": 1658081954000,
            "value": 86
        },
        {
            "timestamp": 1658086816000,
            "value": 5
        },
        {
            "timestamp": 1658094097000,
            "value": 114
        },
        {
            "timestamp": 1658109302000,
            "value": 99
        },
        {
            "timestamp": 1658116577000,
            "value": 96
        },
        {
            "timestamp": 1658152938000,
            "value": 93
        },
        {
            "timestamp": 1658160208000,
            "value": 90
        },
        {
            "timestamp": 1658163843000,
            "value": 87
        },
        {
            "timestamp": 1658167478000,
            "value": 74
        },
        {
            "timestamp": 1658178465000,
            "value": 5
        },
        {
            "timestamp": 1658195744000,
            "value": 23
        },
        {
            "timestamp": 1658228761000,
            "value": 100
        },
        {
            "timestamp": 1658276238000,
            "value": 96
        },
        {
            "timestamp": 1658298055000,
            "value": 93
        },
        {
            "timestamp": 1658319158000,
            "value": 90
        },
        {
            "timestamp": 1658332973000,
            "value": 87
        },
        {
            "timestamp": 1658337702000,
            "value": 4
        },
        {
            "timestamp": 1658407896000,
            "value": 110
        },
        {
            "timestamp": 1658411536000,
            "value": 98
        },
        {
            "timestamp": 1658422460000,
            "value": 95
        },
        {
            "timestamp": 1658426120000,
            "value": 92
        },
        {
            "timestamp": 1658436399000,
            "value": 89
        },
        {
            "timestamp": 1658450039000,
            "value": 86
        }
      ],
      "59d505a0eea9e528ef444c61-5b39031f118ab263afd1c73c": [
        {
            "timestamp": 1657941611000,
            "value": 124
        },
        {
            "timestamp": 1657948878000,
            "value": 120
        },
        {
            "timestamp": 1658002265000,
            "value": 124
        },
        {
            "timestamp": 1658005899000,
            "value": 120
        },
        {
            "timestamp": 1658009532000,
            "value": 126
        },
        {
            "timestamp": 1658015279000,
            "value": 41
        },
        {
            "timestamp": 1658050521000,
            "value": 4
        },
        {
            "timestamp": 1658054154000,
            "value": 254
        },
        {
            "timestamp": 1658074673000,
            "value": 124
        },
        {
            "timestamp": 1658081954000,
            "value": 131
        },
        {
            "timestamp": 1658086816000,
            "value": 123
        },
        {
            "timestamp": 1658094097000,
            "value": 120
        },
        {
            "timestamp": 1658109302000,
            "value": 126
        },
        {
            "timestamp": 1658116577000,
            "value": 123
        },
        {
            "timestamp": 1658152938000,
            "value": 126
        },
        {
            "timestamp": 1658160208000,
            "value": 130
        },
        {
            "timestamp": 1658163843000,
            "value": 127
        },
        {
            "timestamp": 1658167478000,
            "value": 124
        },
        {
            "timestamp": 1658178465000,
            "value": 127
        },
        {
            "timestamp": 1658195744000,
            "value": 124
        },
        {
            "timestamp": 1658228761000,
            "value": 127
        },
        {
            "timestamp": 1658276238000,
            "value": 124
        },
        {
            "timestamp": 1658298055000,
            "value": 118
        },
        {
            "timestamp": 1658319158000,
            "value": 122
        },
        {
            "timestamp": 1658332973000,
            "value": 118
        },
        {
            "timestamp": 1658337702000,
            "value": 121
        },
        {
            "timestamp": 1658407896000,
            "value": 124
        },
        {
            "timestamp": 1658411536000,
            "value": 121
        },
        {
            "timestamp": 1658422460000,
            "value": 126
        },
        {
            "timestamp": 1658426120000,
            "value": 120
        },
        {
            "timestamp": 1658436399000,
            "value": 125
        },
        {
            "timestamp": 1658450039000,
            "value": 121
        }
      ]
    }
    const data = [
      {
          "timestamp": 1657941611000,
          "value": 5
      },
      {
          "timestamp": 1657948878000,
          "value": 6
      },
      {
          "timestamp": 1658002265000,
          "value": 5
      },
      {
          "timestamp": 1658005899000,
          "value": 6
      },
      {
          "timestamp": 1658009532000,
          "value": 5
      },
      {
          "timestamp": 1658015279000,
          "value": 6
      },
      {
          "timestamp": 1658050521000,
          "value": 5
      },
      {
          "timestamp": 1658054154000,
          "value": 6
      },
      {
          "timestamp": 1658074673000,
          "value": 5
      },
      {
          "timestamp": 1658081954000,
          "value": 6
      },
      {
          "timestamp": 1658086816000,
          "value": 5
      },
      {
          "timestamp": 1658094097000,
          "value": 6
      },
      {
          "timestamp": 1658109302000,
          "value": 5
      },
      {
          "timestamp": 1658116577000,
          "value": 6
      },
      {
          "timestamp": 1658152938000,
          "value": 5
      },
      {
          "timestamp": 1658160208000,
          "value": 6
      },
      {
          "timestamp": 1658163843000,
          "value": 5
      },
      {
          "timestamp": 1658167478000,
          "value": 6
      },
      {
          "timestamp": 1658178465000,
          "value": 5
      },
      {
          "timestamp": 1658195744000,
          "value": 6
      },
      {
          "timestamp": 1658228761000,
          "value": 5
      },
      {
          "timestamp": 1658276238000,
          "value": 6
      },
      {
          "timestamp": 1658298055000,
          "value": 5
      },
      {
          "timestamp": 1658319158000,
          "value": 6
      },
      {
          "timestamp": 1658332973000,
          "value": 5
      },
      {
          "timestamp": 1658337702000,
          "value": 6
      },
      {
          "timestamp": 1658407896000,
          "value": 5
      },
      {
          "timestamp": 1658411536000,
          "value": 6
      },
      {
          "timestamp": 1658422460000,
          "value": 5
      },
      {
          "timestamp": 1658426120000,
          "value": 6
      },
      {
          "timestamp": 1658436399000,
          "value": 5
      },
      {
          "timestamp": 1658450039000,
          "value": 6
      }
    ]
    const returhData = dataObj[groupId] ? dataObj[groupId] : data;
    return returhData;
  }

  getSwitchData() {
    const data = [
      {
          "timestamp": 1659396298030,
          "value": 0,
      },
      {
          "timestamp": 1659388784849,
          "value": 1,
      },
      {
          "timestamp": 1659388780813,
          "value": 0,
      },
      {
          "timestamp": 1659388531236,
          "value": 1,
      }
    ]
    return data;
  }

  getOnData() {
    const data = [
      {
          "value": 0,
          "duration": 202326475,
          "percentage": "0.0",
          "selected": true
      },
      {
          "value": 1,
          "duration": 402473525,
          "percentage": "0.0",
          "selected": true
      }
  ];
    return data;
  }

  getAvgDailyTemp() {
    const data = [
      {
          "timestamp": 1658361600000,
          "value": 203,
          "min": 177,
          "max": 218
      },
      {
          "timestamp": 1658448000000,
          "value": 204,
          "min": 191,
          "max": 211
      },
      {
          "timestamp": 1658534400000,
          "value": 200,
          "min": 179,
          "max": 209
      },
      {
          "timestamp": 1658620800000,
          "value": 203,
          "min": 191,
          "max": 213
      },
      {
          "timestamp": 1658707200000,
          "value": 200,
          "min": 185,
          "max": 210
      },
      {
          "timestamp": 1658793600000,
          "value": 187,
          "min": 163,
          "max": 203
      },
      {
          "timestamp": 1658880000000,
          "value": 187,
          "min": 162,
          "max": 198
      },
      {
          "timestamp": 1658966400000,
          "value": 192,
          "min": 178,
          "max": 196
      },
      {
          "timestamp": 1659052800000,
          "value": 198,
          "min": 178,
          "max": 210
      },
      {
          "timestamp": 1659139200000,
          "value": 200,
          "min": 189,
          "max": 207
      },
      {
          "timestamp": 1659225600000,
          "value": 203,
          "min": 192,
          "max": 213
      },
      {
          "timestamp": 1659312000000,
          "value": 198,
          "min": 166,
          "max": 215
      },
      {
          "timestamp": 1659398400000,
          "value": 214,
          "min": 202,
          "max": 225
      },
      {
          "timestamp": 1659484800000,
          "value": 212,
          "min": 202,
          "max": 219
      },
      {
          "timestamp": 1659571200000,
          "value": 196,
          "min": 182,
          "max": 211
      }
    ];
    return data;
  }

  getValveOn() {
    const data = [
      {
          "value": 0,
          "duration": 497992186
      },
      {
          "value": 9,
          "duration": 5165878
      },
      {
          "value": 10,
          "duration": 4259207
      },
      {
          "value": 12,
          "duration": 26343084
      },
      {
          "value": 14,
          "duration": 476742
      },
      {
          "value": 15,
          "duration": 3062065
      },
      {
          "value": 17,
          "duration": 4856169
      },
      {
          "value": 19,
          "duration": 540292
      },
      {
          "value": 20,
          "duration": 540807
      },
      {
          "value": 22,
          "duration": 2701518
      },
      {
          "value": 24,
          "duration": 242123
      },
      {
          "value": 27,
          "duration": 1495549
      },
      {
          "value": 28,
          "duration": 54132
      },
      {
          "value": 29,
          "duration": 1140507
      },
      {
          "value": 32,
          "duration": 13498264
      },
      {
          "value": 33,
          "duration": 242644
      },
      {
          "value": 34,
          "duration": 9748187
      },
      {
          "value": 39,
          "duration": 5033575
      },
      {
          "value": 44,
          "duration": 538677
      },
      {
          "value": 48,
          "duration": 4262100
      },
      {
          "value": 49,
          "duration": 299583
      },
      {
          "value": 53,
          "duration": 6060832
      },
      {
          "value": 54,
          "duration": 358585
      },
      {
          "value": 58,
          "duration": 3120635
      },
      {
          "value": 59,
          "duration": 361311
      },
      {
          "value": 63,
          "duration": 1138482
      },
      {
          "value": 64,
          "duration": 299405
      },
      {
          "value": 68,
          "duration": 1727035
      },
      {
          "value": 69,
          "duration": 720065
      },
      {
          "value": 74,
          "duration": 122045
      },
      {
          "value": 75,
          "duration": 121515
      },
      {
          "value": 79,
          "duration": 58271
      },
      {
          "value": 80,
          "duration": 58777
      },
      {
          "value": 84,
          "duration": 121628
      },
      {
          "value": 85,
          "duration": 60195
      },
      {
          "value": 89,
          "duration": 237556
      },
      {
          "value": 95,
          "duration": 602138
      },
      {
          "value": 100,
          "duration": 7138236
      }
    ];
    return data;
  }

  getTempData() {
    const data = [
      [
          {
              "timestamp": 1659040289604,
              "value": 195
          },
          {
              "timestamp": 1659042811642,
              "value": 196
          },
          {
              "timestamp": 1659046410479,
              "value": 194
          },
          {
              "timestamp": 1659060449345,
              "value": 192
          },
          {
              "timestamp": 1659066030854,
              "value": 191
          },
          {
              "timestamp": 1659069632028,
              "value": 190
          },
          {
              "timestamp": 1659072149243,
              "value": 188
          },
          {
              "timestamp": 1659072451060,
              "value": 186
          },
          {
              "timestamp": 1659072870961,
              "value": 184
          },
          {
              "timestamp": 1659073352781,
              "value": 182
          },
          {
              "timestamp": 1659074492081,
              "value": 180
          },
          {
              "timestamp": 1659075689692,
              "value": 178
          },
          {
              "timestamp": 1659077071800,
              "value": 180
          },
          {
              "timestamp": 1659078389855,
              "value": 182
          },
          {
              "timestamp": 1659079170370,
              "value": 184
          },
          {
              "timestamp": 1659080732033,
              "value": 186
          },
          {
              "timestamp": 1659083311808,
              "value": 188
          },
          {
              "timestamp": 1659084090058,
              "value": 190
          },
          {
              "timestamp": 1659084872092,
              "value": 192
          },
          {
              "timestamp": 1659088232753,
              "value": 194
          },
          {
              "timestamp": 1659089729153,
              "value": 196
          },
          {
              "timestamp": 1659090390674,
              "value": 198
          },
          {
              "timestamp": 1659092132160,
              "value": 199
          },
          {
              "timestamp": 1659095192413,
              "value": 202
          },
          {
              "timestamp": 1659098789336,
              "value": 203
          },
          {
              "timestamp": 1659107610206,
              "value": 207
          },
          {
              "timestamp": 1659114616009,
              "value": 208
          },
          {
              "timestamp": 1659117630680,
              "value": 209
          },
          {
              "timestamp": 1659124831554,
              "value": 210
          },
          {
              "timestamp": 1659130339436,
              "value": 209
          },
          {
              "timestamp": 1659137070827,
              "value": 207
          },
          {
              "timestamp": 1659139536577,
              "value": 205
          },
          {
              "timestamp": 1659146728271,
              "value": 204
          },
          {
              "timestamp": 1659156090458,
              "value": 202
          },
          {
              "timestamp": 1659162090359,
              "value": 201
          },
          {
              "timestamp": 1659164491642,
              "value": 200
          },
          {
              "timestamp": 1659166111618,
              "value": 197
          },
          {
              "timestamp": 1659166291093,
              "value": 196
          },
          {
              "timestamp": 1659166830538,
              "value": 194
          },
          {
              "timestamp": 1659167429719,
              "value": 192
          },
          {
              "timestamp": 1659168509720,
              "value": 190
          },
          {
              "timestamp": 1659172111289,
              "value": 189
          },
          {
              "timestamp": 1659175710835,
              "value": 191
          },
          {
              "timestamp": 1659179671258,
              "value": 193
          },
          {
              "timestamp": 1659182428892,
              "value": 197
          },
          {
              "timestamp": 1659186029840,
              "value": 199
          },
          {
              "timestamp": 1659192868006,
              "value": 197
          },
          {
              "timestamp": 1659196111610,
              "value": 199
          },
          {
              "timestamp": 1659199291725,
              "value": 201
          },
          {
              "timestamp": 1659200731653,
              "value": 203
          },
          {
              "timestamp": 1659210327956,
              "value": 205
          },
          {
              "timestamp": 1659213510429,
              "value": 207
          },
          {
              "timestamp": 1659227907795,
              "value": 205
          },
          {
              "timestamp": 1659234448394,
              "value": 204
          },
          {
              "timestamp": 1659238049259,
              "value": 203
          },
          {
              "timestamp": 1659246390948,
              "value": 199
          },
          {
              "timestamp": 1659246748305,
              "value": 197
          },
          {
              "timestamp": 1659247287380,
              "value": 195
          },
          {
              "timestamp": 1659249572678,
              "value": 193
          },
          {
              "timestamp": 1659253167200,
              "value": 192
          },
          {
              "timestamp": 1659255927036,
              "value": 195
          },
          {
              "timestamp": 1659260547481,
              "value": 197
          },
          {
              "timestamp": 1659260790015,
              "value": 199
          },
          {
              "timestamp": 1659260968691,
              "value": 201
          },
          {
              "timestamp": 1659261148990,
              "value": 203
          },
          {
              "timestamp": 1659261390319,
              "value": 205
          },
          {
              "timestamp": 1659261750108,
              "value": 207
          },
          {
              "timestamp": 1659262588767,
              "value": 209
          },
          {
              "timestamp": 1659266188224,
              "value": 208
          },
          {
              "timestamp": 1659267629910,
              "value": 207
          },
          {
              "timestamp": 1659271226308,
              "value": 208
          },
          {
              "timestamp": 1659274227568,
              "value": 209
          },
          {
              "timestamp": 1659275428683,
              "value": 211
          },
          {
              "timestamp": 1659279266804,
              "value": 213
          },
          {
              "timestamp": 1659286467903,
              "value": 212
          },
          {
              "timestamp": 1659286827493,
              "value": 211
          },
          {
              "timestamp": 1659288206864,
              "value": 209
          },
          {
              "timestamp": 1659291147303,
              "value": 207
          },
          {
              "timestamp": 1659291686892,
              "value": 206
          },
          {
              "timestamp": 1659292467785,
              "value": 204
          },
          {
              "timestamp": 1659293067698,
              "value": 202
          },
          {
              "timestamp": 1659293906865,
              "value": 200
          },
          {
              "timestamp": 1659297208334,
              "value": 198
          },
          {
              "timestamp": 1659297986588,
              "value": 196
          },
          {
              "timestamp": 1659299127990,
              "value": 194
          },
          {
              "timestamp": 1659299607492,
              "value": 192
          },
          {
              "timestamp": 1659301050406,
              "value": 194
          },
          {
              "timestamp": 1659304530062,
              "value": 198
          },
          {
              "timestamp": 1659306928082,
              "value": 199
          },
          {
              "timestamp": 1659309328158,
              "value": 201
          },
          {
              "timestamp": 1659325529226,
              "value": 199
          },
          {
              "timestamp": 1659332729534,
              "value": 198
          },
          {
              "timestamp": 1659333566951,
              "value": 197
          },
          {
              "timestamp": 1659333689587,
              "value": 195
          },
          {
              "timestamp": 1659333868048,
              "value": 192
          },
          {
              "timestamp": 1659333987959,
              "value": 190
          },
          {
              "timestamp": 1659334167853,
              "value": 188
          },
          {
              "timestamp": 1659334348067,
              "value": 186
          },
          {
              "timestamp": 1659334586927,
              "value": 184
          },
          {
              "timestamp": 1659334887224,
              "value": 182
          },
          {
              "timestamp": 1659335308333,
              "value": 180
          },
          {
              "timestamp": 1659335667216,
              "value": 178
          },
          {
              "timestamp": 1659336149386,
              "value": 176
          },
          {
              "timestamp": 1659337048414,
              "value": 174
          },
          {
              "timestamp": 1659337406783,
              "value": 172
          },
          {
              "timestamp": 1659338066866,
              "value": 170
          },
          {
              "timestamp": 1659338908286,
              "value": 168
          },
          {
              "timestamp": 1659340106742,
              "value": 166
          },
          {
              "timestamp": 1659342448544,
              "value": 168
          },
          {
              "timestamp": 1659343348811,
              "value": 170
          },
          {
              "timestamp": 1659344548074,
              "value": 172
          },
          {
              "timestamp": 1659345147254,
              "value": 174
          },
          {
              "timestamp": 1659346527852,
              "value": 176
          },
          {
              "timestamp": 1659348446795,
              "value": 180
          },
          {
              "timestamp": 1659349649203,
              "value": 182
          },
          {
              "timestamp": 1659350126762,
              "value": 184
          },
          {
              "timestamp": 1659350728486,
              "value": 186
          },
          {
              "timestamp": 1659353668838,
              "value": 190
          },
          {
              "timestamp": 1659354028248,
              "value": 192
          },
          {
              "timestamp": 1659355648808,
              "value": 194
          },
          {
              "timestamp": 1659357747768,
              "value": 198
          },
          {
              "timestamp": 1659360688617,
              "value": 201
          },
          {
              "timestamp": 1659364285832,
              "value": 202
          },
          {
              "timestamp": 1659366207916,
              "value": 203
          },
          {
              "timestamp": 1659367528227,
              "value": 205
          },
          {
              "timestamp": 1659368486462,
              "value": 207
          },
          {
              "timestamp": 1659371308979,
              "value": 209
          },
          {
              "timestamp": 1659374908808,
              "value": 210
          },
          {
              "timestamp": 1659377789658,
              "value": 211
          },
          {
              "timestamp": 1659380786361,
              "value": 213
          },
          {
              "timestamp": 1659384387935,
              "value": 214
          },
          {
              "timestamp": 1659388405953,
              "value": 215
          },
          {
              "timestamp": 1659393626884,
              "value": 213
          },
          {
              "timestamp": 1659397226131,
              "value": 212
          },
          {
              "timestamp": 1659401727384,
              "value": 211
          },
          {
              "timestamp": 1659408567263,
              "value": 209
          },
          {
              "timestamp": 1659417148666,
              "value": 207
          },
          {
              "timestamp": 1659417506504,
              "value": 205
          },
          {
              "timestamp": 1659418288116,
              "value": 203
          },
          {
              "timestamp": 1659419426887,
              "value": 202
          },
          {
              "timestamp": 1659426626375,
              "value": 203
          },
          {
              "timestamp": 1659428188595,
              "value": 205
          },
          {
              "timestamp": 1659428846456,
              "value": 207
          },
          {
              "timestamp": 1659432446700,
              "value": 209
          },
          {
              "timestamp": 1659433525764,
              "value": 211
          },
          {
              "timestamp": 1659437125401,
              "value": 213
          },
          {
              "timestamp": 1659440125470,
              "value": 215
          },
          {
              "timestamp": 1659443726442,
              "value": 217
          },
          {
              "timestamp": 1659444147421,
              "value": 219
          },
          {
              "timestamp": 1659444927511,
              "value": 221
          },
          {
              "timestamp": 1659445165698,
              "value": 223
          },
          {
              "timestamp": 1659448766546,
              "value": 225
          },
          {
              "timestamp": 1659452306990,
              "value": 221
          },
          {
              "timestamp": 1659459507017,
              "value": 223
          },
          {
              "timestamp": 1659463885202,
              "value": 219
          },
          {
              "timestamp": 1659468267179,
              "value": 217
          },
          {
              "timestamp": 1659471864991,
              "value": 218
          },
          {
              "timestamp": 1659475464950,
              "value": 219
          },
          {
              "timestamp": 1659479066404,
              "value": 218
          },
          {
              "timestamp": 1659482667682,
              "value": 217
          },
          {
              "timestamp": 1659485608443,
              "value": 216
          },
          {
              "timestamp": 1659492806917,
              "value": 215
          },
          {
              "timestamp": 1659503300629,
              "value": 214
          },
          {
              "timestamp": 1659508405351,
              "value": 213
          },
          {
              "timestamp": 1659508768066,
              "value": 212
          },
          {
              "timestamp": 1659513145081,
              "value": 210
          },
          {
              "timestamp": 1659513926143,
              "value": 208
          },
          {
              "timestamp": 1659514586333,
              "value": 206
          },
          {
              "timestamp": 1659516266717,
              "value": 204
          },
          {
              "timestamp": 1659519864860,
              "value": 205
          },
          {
              "timestamp": 1659521846623,
              "value": 206
          },
          {
              "timestamp": 1659523826395,
              "value": 208
          },
          {
              "timestamp": 1659526105340,
              "value": 210
          },
          {
              "timestamp": 1659527727706,
              "value": 212
          },
          {
              "timestamp": 1659530908229,
              "value": 214
          },
          {
              "timestamp": 1659532586147,
              "value": 215
          },
          {
              "timestamp": 1659535587045,
              "value": 217
          },
          {
              "timestamp": 1659539184340,
              "value": 219
          },
          {
              "timestamp": 1659546505256,
              "value": 217
          },
          {
              "timestamp": 1659548185138,
              "value": 216
          },
          {
              "timestamp": 1659550467955,
              "value": 214
          },
          {
              "timestamp": 1659551666430,
              "value": 212
          },
          {
              "timestamp": 1659552927751,
              "value": 210
          },
          {
              "timestamp": 1659554545119,
              "value": 208
          },
          {
              "timestamp": 1659555505332,
              "value": 206
          },
          {
              "timestamp": 1659557187634,
              "value": 204
          },
          {
              "timestamp": 1659557905168,
              "value": 202
          },
          {
              "timestamp": 1659559285266,
              "value": 204
          },
          {
              "timestamp": 1659560486591,
              "value": 206
          },
          {
              "timestamp": 1659561204087,
              "value": 208
          },
          {
              "timestamp": 1659563965886,
              "value": 210
          },
          {
              "timestamp": 1659567564533,
              "value": 211
          },
          {
              "timestamp": 1659578366697,
              "value": 210
          },
          {
              "timestamp": 1659581965619,
              "value": 209
          },
          {
              "timestamp": 1659584246486,
              "value": 208
          },
          {
              "timestamp": 1659584964466,
              "value": 206
          },
          {
              "timestamp": 1659593603733,
              "value": 201
          },
          {
              "timestamp": 1659597085077,
              "value": 200
          },
          {
              "timestamp": 1659597326286,
              "value": 198
          },
          {
              "timestamp": 1659597564453,
              "value": 196
          },
          {
              "timestamp": 1659597866277,
              "value": 193
          },
          {
              "timestamp": 1659598165982,
              "value": 191
          },
          {
              "timestamp": 1659598584947,
              "value": 190
          },
          {
              "timestamp": 1659599063522,
              "value": 188
          },
          {
              "timestamp": 1659600806453,
              "value": 186
          },
          {
              "timestamp": 1659602066818,
              "value": 184
          },
          {
              "timestamp": 1659604287098,
              "value": 182
          },
          {
              "timestamp": 1659606086766,
              "value": 184
          },
          {
              "timestamp": 1659607043909,
              "value": 186
          },
          {
              "timestamp": 1659608184610,
              "value": 188
          },
          {
              "timestamp": 1659611785053,
              "value": 189
          },
          {
              "timestamp": 1659612624746,
              "value": 190
          },
          {
              "timestamp": 1659615326625,
              "value": 192
          },
          {
              "timestamp": 1659617003756,
              "value": 193
          },
          {
              "timestamp": 1659620604222,
              "value": 194
          },
          {
              "timestamp": 1659625481086,
              "value": 195
          }
      ],
      [
          {
              "timestamp": 1659042602103,
              "value": 100
          },
          {
              "timestamp": 1659075602097,
              "value": 225
          },
          {
              "timestamp": 1659129002861,
              "value": 100
          },
          {
              "timestamp": 1659162002423,
              "value": 225
          },
          {
              "timestamp": 1659162757822,
              "value": 100
          },
          {
              "timestamp": 1659248402387,
              "value": 225
          },
          {
              "timestamp": 1659301801279,
              "value": 100
          },
          {
              "timestamp": 1659334802226,
              "value": 225
          },
          {
              "timestamp": 1659388200802,
              "value": 100
          },
          {
              "timestamp": 1659421202643,
              "value": 225
          },
          {
              "timestamp": 1659474601357,
              "value": 100
          },
          {
              "timestamp": 1659507602310,
              "value": 225
          },
          {
              "timestamp": 1659561001787,
              "value": 100
          },
          {
              "timestamp": 1659594002345,
              "value": 225
          },
          {
              "timestamp": 1659625481086,
              "value": 100
          }
      ],
      [
          {
              "timestamp": 1659042805964,
              "value": 0
          },
          {
              "timestamp": 1659075731404,
              "value": 100
          },
          {
              "timestamp": 1659129203473,
              "value": 0
          },
          {
              "timestamp": 1659248521701,
              "value": 100
          },
          {
              "timestamp": 1659301993376,
              "value": 0
          },
          {
              "timestamp": 1659334916946,
              "value": 100
          },
          {
              "timestamp": 1659388387630,
              "value": 0
          },
          {
              "timestamp": 1659421313594,
              "value": 100
          },
          {
              "timestamp": 1659474784909,
              "value": 0
          },
          {
              "timestamp": 1659507708689,
              "value": 100
          },
          {
              "timestamp": 1659561177931,
              "value": 0
          },
          {
              "timestamp": 1659594101414,
              "value": 100
          },
          {
              "timestamp": 1659625481086,
              "value": 0
          }
      ],
      [],
    ]
    return data;
  }

  isDemo() {
    return this.demo;
  }

  setDemo(status) {
    this.demo = status;
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getProductCodeOrIcon(groupId, type) {
    const featureSets = this.getDemoStructure().featureSetsWithData;
    const featureSet = featureSets.find(element => {
      return element.groupId === groupId}
      );
    return type === 'productCode' ? featureSet.productCode : featureSet.icon;
  }
}
